{
  "common": {
    "address": "Address",
    "id": "ID",
    "yes": "Yes",
    "no": "No",
    "all": "All",
    "mixed": "Mixed",
    "unknown": "Unknown",
    "not_specified": "Not specified",
    "page_navigation": "Page navigation",
    "previous_page": "Previous page",
    "next_page": "Next page",
    "read_more_button": "Read more",
    "click_to_learn_more": "Click to learn more",
    "none": "None",
    "other": "Other",
    "edit": "Edit",
    "date": "Date: {date}",
    "kw": "kW",
    "kwh": "kWh",
    "mwh": "MWh",
    "gwh": "GWh",
    "eur": "€",
    "months_abbrev": {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    },
    "next": "Next",
    "back": "Back",
    "save": "Save",
    "saving": "Saving",
    "optional": "Optional",
    "saved_successfully": "Saved successfully",
    "unsaved_changes_confirm": "You have unsaved changes. Leave this page and discard them?",
    "clear": "Clear",
    "filter": "Filter",
    "search": "Search",
    "select": "Select",
    "select_all": "Select All",
    "clear_all": "Clear All",
    "pricing_loading_messages": {
      "retrieving_market_levels": "Retrieving market levels...",
      "applying_sourcing_criteria": "Applying sourcing criteria...",
      "calculating_fees": "Calculating fees..."
    },
    "selected": "selected",
    "total_volume": "Total Volume",
    "last_updated": "Last Updated",
    "certificate": "Certificate",
    "volume": "Volume",
    "technology_label": "Technology",
    "uploaded": "Uploaded",
    "not_uploaded": "Not uploaded",
    "any_file_format": "Any file format",
    "pdf_file_format": "Accepts files in .pdf format",
    "invalid_file_error": "Invalid file provided, please upload a valid file.",
    "invalid_file_contact_support": "If you believe this is a mistake and this document is indeed valid, please contact our customer support. To do this, please click on the chat bubble in the bottom right corner of the screen or select 'Contact Us' from the top menu.",
    "coming_soon": "Coming soon!",
    "hide_admin_options": "Hide admin options",
    "show_admin_options": "Show admin options",
    "contactSupport": "Contact Support",
    "loading": "Loading",
    "select_option": "Please select...",
    "year": "Year",
    "years": "Years",
    "month": "Month",
    "months": "Months",
    "day": "Day",
    "select_month": "Select Month",
    "select_day": "Select Day",
    "uploading": "Uploading...",
    "pending": "Pending",
    "rejected": "Rejected",
    "active": "Active",
    "status": "Status:",
    "add": "Add",
    "creating": "Creating...",
    "create_device": "Create Device",
    "remove": "Remove",
    "delete": "Delete",
    "deleted": "(deleted)",
    "add_another_unit": "Add Another Unit",
    "saved": "Saved",
    "done": "Done",
    "retry": "Retry",
    "download": "Download",
    "close": "Close",
    "open_pdf": "Open PDF",
    "success": "Success",
    "unexpected_error": "Unexpected error, try again later!",
    "full_name": "Full Name",
    "name": "Name",
    "start_date": "Start date",
    "end_date": "End date",
    "email": "Email",
    "company_search": {
      "label": "Company Search",
      "description": "Search for a company by name, business ID, or VAT number",
      "placeholder": "Enter company name, business ID, or VAT",
      "ai_extracted": "AI extracted",
      "custom_entry": "Custom entry",
      "unavailable": "Company search is unavailable, enter your company details manually"
    },
    "counterparty_picker": {
      "company_label": "Company Name",
      "account_label": "Registry Account Number",
      "account_invalid": "Account number must contain only letters and digits",
      "account_invalid_aib": "Must be a valid EECS identifier (2 digits, X, 7 alphanumeric characters)",
      "account_invalid_rego": "Must be an Ofgem account number (GEN, PAR, SUP or AGE followed by 7 digits)",
      "account_invalid_rgp": "Must be a TGE member code (letters and digits, e.g. RESENENC)",
      "account_unrecognized_warning": "Not a recognized account format - registry country can't be auto-detected.",
      "internal_account_label": "Registry Internal Account Number",
      "internal_account_help": "Optional. Required only for registries that use sub-accounts.",
      "internal_account_placeholder": "Optional sub-account ID"
    },
    "eecs_name_mismatch": {
      "both": "Company name and EECS are not matching. {name} matches with EECS: {expectedEecs} and {eecs} matches with {expectedName}",
      "eecs_only": "Company name and EECS are not matching. No matching EECS for {name} and {eecs} matches with {expectedName}",
      "name_only": "Company name and EECS are not matching. {name} matches with EECS: {expectedEecs} and no matching company for {eecs}",
      "unknown_counterparty": "Check the company name and account number in the contract."
    },
    "no_results": "No results found",
    "partial_results": "Showing the first {shown} of {total} matches — keep typing to narrow the list",
    "technology": {
      "solar": "Solar",
      "wind": "Wind",
      "hydro": "Hydro",
      "biomass": "Biomass",
      "nuclear": "Nuclear",
      "mixed": "Mixed"
    },
    "country": {
      "AD": "Andorra",
      "AE": "United Arab Emirates",
      "AF": "Afghanistan",
      "AG": "Antigua & Barbuda",
      "AI": "Anguilla",
      "AL": "Albania",
      "AM": "Armenia",
      "AO": "Angola",
      "AQ": "Antarctica",
      "AR": "Argentina",
      "AS": "American Samoa",
      "AT": "Austria",
      "AU": "Australia",
      "AW": "Aruba",
      "AX": "Åland Islands",
      "AZ": "Azerbaijan",
      "BA": "Bosnia & Herzegovina",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Belgium",
      "BF": "Burkina Faso",
      "BG": "Bulgaria",
      "BH": "Bahrain",
      "BI": "Burundi",
      "BJ": "Benin",
      "BL": "St. Barthélemy",
      "BM": "Bermuda",
      "BN": "Brunei",
      "BO": "Bolivia",
      "BQ": "Caribbean Netherlands",
      "BR": "Brazil",
      "BS": "Bahamas",
      "BT": "Bhutan",
      "BV": "Bouvet Island",
      "BW": "Botswana",
      "BY": "Belarus",
      "BZ": "Belize",
      "CA": "Canada",
      "CC": "Cocos (Keeling) Islands",
      "CD": "Congo - Kinshasa",
      "CF": "Central African Republic",
      "CG": "Congo - Brazzaville",
      "CH": "Switzerland",
      "CI": "Côte d’Ivoire",
      "CK": "Cook Islands",
      "CL": "Chile",
      "CM": "Cameroon",
      "CN": "China",
      "CO": "Colombia",
      "CR": "Costa Rica",
      "CU": "Cuba",
      "CV": "Cape Verde",
      "CW": "Curaçao",
      "CX": "Christmas Island",
      "CY": "Cyprus",
      "CZ": "Czech Republic",
      "DE": "Germany",
      "DJ": "Djibouti",
      "DK": "Denmark",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "DZ": "Algeria",
      "EC": "Ecuador",
      "EE": "Estonia",
      "EG": "Egypt",
      "EH": "Western Sahara",
      "ER": "Eritrea",
      "ES": "Spain",
      "ET": "Ethiopia",
      "FI": "Finland",
      "FJ": "Fiji",
      "FK": "Falkland Islands",
      "FM": "Micronesia",
      "FO": "Faroe Islands",
      "FR": "France",
      "GA": "Gabon",
      "GB": "United Kingdom",
      "GD": "Grenada",
      "GE": "Georgia",
      "GF": "French Guiana",
      "GG": "Guernsey",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GL": "Greenland",
      "GM": "Gambia",
      "GN": "Guinea",
      "GP": "Guadeloupe",
      "GQ": "Equatorial Guinea",
      "GR": "Greece",
      "GS": "South Georgia & South Sandwich Islands",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HK": "Hong Kong SAR China",
      "HM": "Heard & McDonald Islands",
      "HN": "Honduras",
      "HR": "Croatia",
      "HT": "Haiti",
      "HU": "Hungary",
      "ID": "Indonesia",
      "IE": "Ireland",
      "IL": "Israel",
      "IM": "Isle of Man",
      "IN": "India",
      "IO": "British Indian Ocean Territory",
      "IQ": "Iraq",
      "IR": "Iran",
      "IS": "Iceland",
      "IT": "Italy",
      "JE": "Jersey",
      "JM": "Jamaica",
      "JO": "Jordan",
      "JP": "Japan",
      "KE": "Kenya",
      "KG": "Kyrgyzstan",
      "KH": "Cambodia",
      "KI": "Kiribati",
      "KM": "Comoros",
      "KN": "St. Kitts & Nevis",
      "KP": "North Korea",
      "KR": "South Korea",
      "KW": "Kuwait",
      "KY": "Cayman Islands",
      "KZ": "Kazakhstan",
      "LA": "Laos",
      "LB": "Lebanon",
      "LC": "St. Lucia",
      "LI": "Liechtenstein",
      "LK": "Sri Lanka",
      "LR": "Liberia",
      "LS": "Lesotho",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "LV": "Latvia",
      "LY": "Libya",
      "MA": "Morocco",
      "MC": "Monaco",
      "MD": "Moldova",
      "ME": "Montenegro",
      "MF": "St. Martin",
      "MG": "Madagascar",
      "MH": "Marshall Islands",
      "MK": "North Macedonia",
      "ML": "Mali",
      "MM": "Myanmar (Burma)",
      "MN": "Mongolia",
      "MO": "Macao SAR China",
      "MP": "Northern Mariana Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Mauritius",
      "MV": "Maldives",
      "MW": "Malawi",
      "MX": "Mexico",
      "MY": "Malaysia",
      "MZ": "Mozambique",
      "NA": "Namibia",
      "NC": "New Caledonia",
      "NE": "Niger",
      "NF": "Norfolk Island",
      "NG": "Nigeria",
      "NI": "Nicaragua",
      "NL": "Netherlands",
      "NO": "Norway",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "New Zealand",
      "OM": "Oman",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "French Polynesia",
      "PG": "Papua New Guinea",
      "PH": "Philippines",
      "PK": "Pakistan",
      "PL": "Poland",
      "PM": "St. Pierre & Miquelon",
      "PN": "Pitcairn Islands",
      "PR": "Puerto Rico",
      "PS": "Palestinian Territories",
      "PT": "Portugal",
      "PW": "Palau",
      "PY": "Paraguay",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Romania",
      "RS": "Serbia",
      "RU": "Russia",
      "RW": "Rwanda",
      "SA": "Saudi Arabia",
      "SB": "Solomon Islands",
      "SC": "Seychelles",
      "SD": "Sudan",
      "SE": "Sweden",
      "SG": "Singapore",
      "SH": "St. Helena",
      "SI": "Slovenia",
      "SJ": "Svalbard & Jan Mayen",
      "SK": "Slovakia",
      "SL": "Sierra Leone",
      "SM": "San Marino",
      "SN": "Senegal",
      "SO": "Somalia",
      "SR": "Suriname",
      "SS": "South Sudan",
      "ST": "São Tomé & Príncipe",
      "SV": "El Salvador",
      "SX": "Sint Maarten",
      "SY": "Syria",
      "SZ": "Eswatini",
      "TC": "Turks & Caicos Islands",
      "TD": "Chad",
      "TF": "French Southern Territories",
      "TG": "Togo",
      "TH": "Thailand",
      "TJ": "Tajikistan",
      "TK": "Tokelau",
      "TL": "Timor-Leste",
      "TM": "Turkmenistan",
      "TN": "Tunisia",
      "TO": "Tonga",
      "TR": "Türkiye",
      "TT": "Trinidad & Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tanzania",
      "UA": "Ukraine",
      "UG": "Uganda",
      "UM": "U.S. Outlying Islands",
      "US": "United States",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VA": "Vatican City",
      "VC": "St. Vincent & Grenadines",
      "VE": "Venezuela",
      "VG": "British Virgin Islands",
      "VI": "U.S. Virgin Islands",
      "VN": "Vietnam",
      "VU": "Vanuatu",
      "WF": "Wallis & Futuna",
      "WS": "Samoa",
      "XK": "Kosovo",
      "YE": "Yemen",
      "YT": "Mayotte",
      "ZA": "South Africa",
      "ZM": "Zambia",
      "ZW": "Zimbabwe",
      "BE_BRU": "Belgium (Brussels)",
      "BE_FED": "Belgium (Federal)",
      "BE_FLA": "Belgium (Flanders)",
      "BE_WAL": "Belgium (Wallonia)",
      "other": "Other"
    },
    "company": "Company",
    "companies": "Companies",
    "search_companies": "Search companies",
    "select_companies": "Select companies",
    "actions": {
      "title": "Actions",
      "send": "Send",
      "receive": "Receive",
      "portfolios": "Portfolios",
      "buy": "Buy",
      "buy_and_cancel": "Buy and Cancel",
      "sell": "Sell",
      "cancel": "@:common.cancel",
      "confirm_send": "Confirm Send Order",
      "confirm_sell": "Confirm Sale Setup",
      "accept": "Accept"
    },
    "eacs_in_inventory": "EACs in inventory",
    "settings": "Settings",
    "action_items": "Action Needed",
    "documents": "Documents",
    "contracts": "Contracts",
    "devices": "Devices",
    "type_here": "Type your message here...",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "continue": "Continue",
    "step": "Step",
    "placeholderText": "Placeholder - please provide more specific context if possible.",
    "production_period": "Production Period",
    "production_year": "Production Year"
  },
  "primevue": {
    "startsWith": "Starts with",
    "contains": "Contains",
    "notContains": "Does not contain",
    "endsWith": "Ends with",
    "equals": "Equals",
    "notEquals": "Not equals",
    "noFilter": "No filter",
    "lt": "Less than",
    "lte": "Less than or equal to",
    "gt": "Greater than",
    "gte": "Greater than or equal to",
    "dateIs": "Date is",
    "dateIsNot": "Date is not",
    "dateBefore": "Date is before",
    "dateAfter": "Date is after",
    "clear": "Clear",
    "apply": "Apply",
    "matchAll": "Match all",
    "matchAny": "Match any",
    "addRule": "Add rule",
    "removeRule": "Remove rule",
    "today": "Today"
  },
  "language": {
    "en": "English",
    "et": "Estonian",
    "lv": "Latvian",
    "lt": "Lithuanian",
    "sv": "Swedish"
  },
  "settings": {
    "title": "Settings",
    "select_language": "Select language",
    "name": "Name",
    "email": "Email",
    "phone": "Phone Number",
    "email_cannot_be_changed": "To change the account email, invite a new team member from the Company Settings page",
    "receive_transaction_emails": "Receive sale notification emails",
    "receive_transaction_emails_hint": "Emails about your Guarantees of Origin sales, with the fee invoices attached. Set a billing email in your company settings so your accountant still receives the invoices even when this is off."
  },
  "app": {
    "development_environment": "This is development environment",
    "staging_environment": "This is staging environment",
    "managing_client_account": "Managing client's account: {email}",
    "stop_managing": "Stop managing",
    "log_in": "Log in",
    "log_out": "Log out",
    "error_occurred": "An error occurred",
    "error_message_code": "Error code: {errorCode}",
    "contact_support": "Please contact support to resolve this issue. Click on the chat bubble at the bottom right of the screen or select 'Contact Us' from the top menu."
  },
  "signup": {
    "choose_company_country": "Your production device's country",
    "select_country_placeholder": "Select a country",
    "legal": {
      "byJoining": "By signing up, you agree to the",
      "membershipAgreement": "Soldera Platform Agreement.",
      "personalDataNote": "Your personal data will be processed in accordance with our",
      "privacyPolicy": "Privacy Policy."
    },
    "modal": {
      "hello_button": "Start registration",
      "hello": "👋 Welcome!",
      "soldera_faq": "in Soldera FAQ",
      "lv": {
        "section1": "It's great to see that you've decided to join Soldera. If you have any questions, you can find answers to the main questions here",
        "section2": "By filling out the information below, you will give access to Soldera to manage your Guarantees of Origin in the AST information system. We will also ask you to sign a set of documents in the Dokobit system. These documents are automatically generated based on the data you provide. If you get any issues, please write to us in lower right corner, or call our Latvian representative +371 26417883"
      },
      "ee": {
        "section1": "Welcome",
        "section2": "It's great to see you've decided to join us at Soldera. If you have any further questions, you can find answers to common questions here:",
        "section3": "If you are not yet receiving Guarantees of Origin",
        "section4": "We will help you prepare and submit all necessary documents to obtain Guarantees of Origin. The first step is to upload the network contract. This document, required by Elering, contains most of the data needed for the Guarantees of Origin.",
        "section5": "After uploading the network contract, we will provide an overview of your data and ask for any missing information. Once you have confirmed all data, we will prepare the necessary documents (including the contract between us), ask you to sign them, and then submit them to Elering.",
        "section6": "If you are already receiving Guarantees of Origin",
        "section7": "If you would like us to manage the sale of your Guarantees of Origin on your behalf, please click here or on the link on the network contract page. We need the production device owner's and signer's details. Based on these, we will prepare the relevant authorization letters and enter into a contract with you."
      }
    },
    "message_rate_limited_title": "Too many messages",
    "message_rate_limited": "You have sent several messages in a short time. Please wait an hour before sending another, or contact support@soldera.org.",
    "grid_contract_upload": {
      "title": "Network Contract Upload",
      "description": "We need your valid production device's network contract to fill out and submit the necessary documents for registration.",
      "upload_prompt": "Click here to upload the network contract.",
      "supported_formats": "Currently, we only support documents in .pdf format.",
      "existing_contract_error": "Device {eic} is already registered. {link}",
      "manage_devices_link": "Manage devices here.",
      "wrong_file_error": "It appears that you have uploaded a file that is not a network contract. More information on finding network contracts can be found below.",
      "contact_support": "If you believe this is a mistake and the submitted document is indeed a network contract, please contact our customer support. To do this, please click on the chat bubble in the bottom right corner of the screen or select 'Contact Us' from the top menu.",
      "finding_contract_title": "Where to find the network contract?",
      "elektrilevi_contract_info": "To find the network contract with Elektrilevi",
      "elektrilevi_contract_link_text": "click here to enter their e-service.",
      "vkg_contract_info": "To find the network contract with VKG Elektrivõrgud",
      "vkg_contract_link_text": "click here to enter their e-service."
    },
    "multiple_upload": {
      "title": "Document Upload",
      "description": "Please upload the following documents to proceed with registration.",
      "lt_inspection_report": "Latest technical inspection report",
      "lt_inspection_report_where_to_find": "Please find this document in the  <a href=\"https://www.epaslaugos.lt/portal/service/92420/16020\" target=\"_blank\"> state e-service portal </a>",
      "lt_property_limit_scheme": "Production device location boundary scheme",
      "lt_property_limit_scheme_where_to_find": "Please look for this document among the installation documents of the production device",
      "lt_power_of_attorney": "Power of Attorney (ex: JAR ESI)",
      "lt_power_of_attorney_where_to_find": "Any document proving your authority to represent the related company. If the production device has multiple owners, the power of attorney must include signatures from all owners.",
      "where_to_find_this_document": "Where to find this document?",
      "lt_invalid_power_of_attorney": "Please upload a valid power of attorney",
      "UF_lv_grid_connection_scheme": "Grid Connection Scheme",
      "UF_lv_grid_connection_scheme_where_to_find": "This document should be obtained from your grid operator (TSO or DSO). It shows how your production device is connected to the grid and includes relevant metering points.",
      "UF_lv_document_of_device_auxiliaries": "Document of Device Auxiliaries",
      "UF_lv_document_of_device_auxiliaries_where_to_find": "This document should contain information about any auxiliary systems or equipment that support your production device's operation.",
      "UF_lv_power_of_attorney": "Power of Attorney",
      "UF_lv_power_of_attorney_where_to_find": "Power of attorney signed by owner(s) of the Production Device (in case Account Holder is not the owner or is not the only owner of the Production device)"
    },
    "add_generator_component": {
      "title": "Generator Details",
      "subsidy_title": "Generator State Subsidies",
      "subsidy_question": "Has this generator received state subsidy?",
      "elering_support": "Elering production support",
      "battery_section_title": "Storage Device (Battery)",
      "battery_question": "Is the generator associated with a storage device?",
      "battery_details": "Enter storage device details",
      "unit_power": "Unit Power (kW)",
      "capacity": "Capacity (kWh)",
      "ppa_section_title": "Power Purchase Agreement (PPA)",
      "ppa_question": "Is the generator's electricity sold under a long-term power purchase agreement (PPA)?",
      "ppa_include_certificates_question": "Does this PPA include the sale of Guarantees of Origin?",
      "ppa_details": "Enter PPA details",
      "ppa_start_date": "Start Date",
      "ppa_mwh": "@:common.mwh",
      "ppa_client_name": "Client's Company Name",
      "ppa_country": "Country",
      "enter_subsidies": "Enter subsidies",
      "add_subsidy": "Add subsidy",
      "device_technology_title": "Device Technology",
      "device_technology_description": "Please select the device technology",
      "device_technology_solar": "Solar Energy",
      "device_technology_wind": "Wind Energy",
      "device_technology_hydro": "Hydro Energy",
      "device_technology_mixed": "Mixed Technologies Behind One Measurement Point"
    },
    "add_subsidy_component": {
      "subsidy_provider": "Subsidy Provider",
      "decision_date": "Decision Date",
      "subsidy_plan": "Subsidy Plan",
      "amount": "Amount",
      "placeholder_provider": "E.g.: Kredex, PRIA",
      "placeholder_plan": "E.g.: Diversification support",
      "subsidy_type": "Support Scheme Type",
      "subsidy_number": "Support Scheme Number",
      "placeholder_number": "E.g.: 1234567890",
      "investment": "Investment Support",
      "production": "Production Support",
      "select_type": "Select Support Type",
      "objective": "Purpose of State Aid",
      "placeholder_objective": "E.g.: Renewable energy"
    },
    "contact_review_component": {
      "signer_title": "Signatory personal data",
      "generator_owner_title": "Production device owner's data",
      "generator_owner_subtext": "Please enter the production device owner's data. The owner can be either you or your company.",
      "select_company": "Select owner",
      "add_new_company": "New owner"
    },
    "role_selection": {
      "eyebrow": "Get started",
      "title": "How will you use Soldera?",
      "subtitle": "Our infrastructure handles your certificates across 30+ registries. Our experts handle the rest.",
      "corporate_title": "For corporations",
      "corporate_headline": "Clean energy compliance on autopilot",
      "corporate_lead": "Meet your renewable targets, without the admin.",
      "corporate_benefit1": "Personal Account Executive",
      "corporate_benefit2": "Certificates matched, cancelled and verified",
      "corporate_benefit3": "Buy only what is missing",
      "corporate_benefit4": "Audit-ready evidence for CSRD, RE100 and more",
      "corporate_cta": "Continue as a corporation",
      "producer_title": "For energy producers",
      "producer_headline": "GO administration on autopilot",
      "producer_lead": "Earn more from your Guarantees of Origin, without the admin.",
      "producer_benefit1": "Registry to revenue, fully automated",
      "producer_benefit2": "Higher prices from international buyers",
      "producer_benefit3": "Forward sales and ecolabel premiums",
      "producer_benefit4": "No fees: we earn only when you sell",
      "producer_cta": "Continue as a producer",
      "help_title": "Not sure which fits?",
      "help_description": "Corporation with your own production? Book a short call and we'll help you choose.",
      "help_button": "Book a demo"
    },
    "corporate": {
      "title": "Tell us about your company",
      "rate_limit_error": "Company creation limit reached. Please contact {supportEmail} if you are onboarding a large portfolio.",
      "description": "Clean energy compliance on autopilot. Start with your company, then we tailor your plan and your evidence to what you need.",
      "form_title": "Company Information",
      "company_name": "Company Name",
      "registry_code": "Company Registry Code",
      "address": "Company Address",
      "phone_number": "Phone Number",
      "vat": "VAT Number",
      "vat_optional": "Optional",
      "country": "Country",
      "select_country": "Select a country",
      "submit": "Complete Registration",
      "platform_agreement_checkbox_label": "By clicking accept you agree to the {link}."
    },
    "international": {
      "duplicate_company_error": "A company with this registry code already exists for this country. Our team will contact you to finish onboarding."
    },
    "generator_license_review": {
      "title": "Production Device License Number",
      "description": "Please find the license number associated with your production device's production or development permit.",
      "directions": "To find the license number, search in the  <a href=\"https://www.licencijavimas.lt/lis-epp-app/public/licenceSearch\" target=\"_blank\">Lithuanian licensing information system.</a>.",
      "licenseHints": "Possible license numbers from Litgrid"
    },
    "user_type": {
      "select_title": "Select Owner Type",
      "select_description": "Please select whether the device owner you are registering as a private individual or a company.",
      "private": {
        "button": "Register as Private Individual",
        "description": "Choose this if you're registering your home solar panels or other personal renewable energy devices."
      },
      "company": {
        "button": "Register as Company",
        "description": "Choose this if you're registering on behalf of a business or organization which owns renewable energy devices."
      },
      "selection_prefix": "You have selected:",
      "selected_private": "Register as Private Individual",
      "selected_company": "Register as Company",
      "change_selection": "Change selection"
    },
    "contract_review_component": {
      "data_review_title": "Data review",
      "data_review_subtext": "Please review one last time to make sure all data is entered correctly",
      "data_signer_title": "Signatory personal data",
      "data_company_title": "Production device owner's data",
      "data_generator_title": "Production device data",
      "documents_review_title": "Documents review",
      "documents_review_subtext": "On the next page, we ask you to sign a set of documents in the Dokobit system. The documents are automatically generated based on your data. Here is an overview of what documents are waiting to be signed:",
      "self_uploaded_file_text": "This is a document you have previously uploaded. It will be included in the envelope for signing.",
      "documents_signed": "Document signed",
      "documents_remaining": "{count} documents remaining to sign",
      "ee": {
        "origin_certificate_account_application_title": "Application for Guarantees of Origin Account Opening",
        "origin_certificate_account_application_description": "A document expressing the desire to open an Guarantees of Origin account with Elering. This document also authorizes Soldera to manage these certificates.",
        "type_conditions_title": "Standard Conditions for Use of Guarantees of Origin",
        "type_conditions_description": "Standard conditions and rules set by Elering for operations on the Guarantees of Origin market.",
        "authorization_application_title": "Application for Authorization of Guarantees of Origin Account",
        "authorization_application_description": "A document expressing the desire to authorize Soldera to manage Guarantees of Origin within the Elering information system.",
        "investment_support_confirmation_title": "Confirmation Letter for Receiving/Denial of Investment Support",
        "investment_support_confirmation_description": "A document that confirms to Elering the subsidies provided to your production device.",
        "network_contract_title": "Network Contract",
        "network_contract_description": "Your uploaded network contract required by Elering for registering your production device.",
        "device_registration_form_title": "Device Registration Form",
        "device_registration_form_description": "A form required by Elering for submitting your production device data.",
        "soldera_membership_agreement_title": "Soldera Platform Agreement",
        "soldera_membership_agreement_description": "An agreement between you and Soldera outlining the terms of cooperation.",
        "elering_data_title": "Elering Data",
        "elering_data_description": "A document for submitting your data to Elering to facilitate the registration of the production device."
      },
      "lv": {
        "lv_account_authorization_form_title": "Application for the authorization of the Guarantees of Origin account",
        "lv_account_authorization_form_text": "A document expressing the desire to authorize Soldera to manage Guarantees of Origin. This document allows Soldera access to your Guarantees of Origin in the AST information system.",
        "lv_soldera_account_holder_registration_form_title": "Grexel account holder registration form",
        "lv_soldera_account_holder_registration_form_text": "A document expressing the desire to register as an account holder with Grexel. This document allows Soldera access to your Guarantees of Origin in the AST information system.",
        "lv_soldera_membership_agreement_title": "Soldera Platform Agreement",
        "lv_soldera_membership_agreement_text": "An agreement between you and Soldera that stipulates the terms of cooperation. Required if no previous agreement has been made. Includes references to Soldera's privacy policy, trading rules, and basic conditions, which are available on the Soldera website.",
        "lv_new_device_application_title": "Production Device registration form",
        "lv_new_device_application_text": "Production Device registration form, with submitted information verified by independent accredited Production Auditor",
        "lv_ast_terms_and_service_title": "AST Terms and Service",
        "lv_ast_terms_and_service_text": "The terms and conditions for the AST information system."
      },
      "lt": {
        "lt_request_for_go_contract_title": "Application for Guarantees of Origin Service Agreement",
        "lt_request_for_go_contract_description": "A document expressing the desire to enter into an agreement with Litgrid to open an Guarantees of Origin account.",
        "lt_soldera_membership_agreement_title": "Soldera Platform Agreement",
        "lt_soldera_membership_agreement_text": "An agreement between you and Soldera that stipulates the terms of cooperation. Required if no previous agreement has been made. Includes references to Soldera's privacy policy, trading rules, and basic conditions, which are available on the Soldera website.",
        "lt_authotization_application_title": "Application for Authorization of Guarantees of Origin Account",
        "lt_authorization_application_text": "A document expressing the desire to authorize Soldera to manage Guarantees of Origin within the Litgrid information system.",
        "lt_litgrid_terms_service_title": "Litgrid Terms of Service",
        "lt_litgrid_terms_service_description": "The terms of service for the Litgrid information system.",
        "lt_device_registration_title": "Litgrid Device Registration Form",
        "lt_device_registration_description": "A document Litgrid requires in order to register a new device."
      },
      "se": {
        "se_account_authorization_form_title": "Authorization Form for Energimyndigheten",
        "se_account_authorization_form_text": "This form authorizes Soldera to register your account with Energimyndigheten (Swedish Energy Agency) and manage your Guarantees of Origin.",
        "se_access_cesar_freja_eid_authorization_application_title": "Application for access to Cesar account",
        "se_access_cesar_freja_eid_authorization_application_text": "This form authorizes Soldera to access your Cesar account with Energimyndigheten (Swedish Energy Agency) and manage your Guarantees of Origin.",
        "se_soldera_membership_agreement_title": "Soldera Platform Agreement",
        "se_soldera_membership_agreement_text": "This agreement establishes your membership with Soldera and outlines the terms and conditions for using our platform and services.",
        "se_application_for_go_title": "Application for Guarantees of Origin",
        "se_application_for_go_text": "Application form for registering your production device for Guarantees of Origin with the Swedish Energy Agency.",
        "se_appendix_production_units_title": "Production Units Appendix",
        "se_appendix_production_units_text": "Detailed information about your production units that will be registered for Guarantees of Origin.",
        "se_application_for_eecs_go_title": "EECS GO Application",
        "se_application_for_eecs_go_text": "Application for European Energy Certificate System (EECS) Guarantees of Origin registration.",
        "se_application_for_special_account_title": "Special Account Application",
        "se_application_for_special_account_text": "Application for a special account in the Swedish Energy Agency's system for handling Guarantees of Origin.",
        "se_application_for_cesar_access_title": "Cesar System Access Application",
        "se_application_for_cesar_access_text": "Application for access to the Cesar system, which is used for managing Guarantees of Origin in Sweden."
      },
      "fi": {
        "fi_soldera_membership_agreement_title": "Soldera Platform Agreement",
        "fi_soldera_membership_agreement_text": "This agreement establishes your membership with Soldera and outlines the terms and conditions for using our platform and services.",
        "fi_authorization_application_title": "Authorization Application",
        "fi_authorization_application_text": "This document authorizes Soldera to manage your Guarantees of Origin.",
        "fi_transfer_application_title": "Transfer Application",
        "fi_transfer_application_text": "This document transfers your production units to Soldera account, in order to manage your Guarantees of Origin and save on registry account fees."
      }
    },
    "navsteps": {
      "next": "Next",
      "back": "Back",
      "to_signature_page": "Review & Sign",
      "ee": {
        "authorization": {
          "1": "Start",
          "2": "Contact Details",
          "3": "Contract Review"
        },
        "new_device": {
          "1": "Start",
          "2": "Network Contract",
          "3": "Generator",
          "4": "Contact Details",
          "5": "Contract Review"
        }
      },
      "lv": {
        "step1": "Welcome",
        "step2": "Contact Details",
        "new_device": {
          "1": "Start",
          "2": "Account details",
          "3": "Device documents",
          "4": "Device data",
          "5": "Company info",
          "6": "Signing"
        },
        "authorization": {
          "1": "Start",
          "2": "Account details",
          "3": "Signing"
        }
      },
      "lt": {
        "choose_onboarding": "Onboarding type",
        "contact_review": "Account details",
        "multiple_upload": "@:common.documents",
        "generator_license": "License number",
        "contract_review": "Signing"
      },
      "se": {
        "step1": "Start",
        "authorization": {
          "contact_review": "Contact Details",
          "contract_review": "Contract Review"
        },
        "new_device": {
          "contact_review": "Contact Details",
          "generator_review": "Generator Details",
          "contract_review": "Contract Review",
          "grid_review": "Grid Owner Details"
        },
        "contract_review": "Contract Review"
      },
      "fi": {
        "flow_selection": "Flow Selection",
        "contact_details": "Contact Details",
        "contract_review": "Contract Review"
      }
    },
    "ee": {
      "authorization": {
        "title": "How would you like to start?",
        "description": "Soldera sells your Guarantees of Origin for you. Choose the option that fits your production device.",
        "add_authorization": "Give Soldera authorization",
        "add_authorization_description": "Choose this if your device already receives Guarantees of Origin from Elering. You authorize Soldera to manage and sell them.",
        "create_new_account": "Open a green Elering account to receive Guarantees of Origin",
        "create_new_account_description": "Choose this if your device doesn't receive Guarantees of Origin yet. Upload your network contract and we prepare the Elering registration for you.",
        "not_sure": "Not sure?",
        "contact_support": "Contact our support team for help"
      }
    },
    "lv": {
      "authorization": {
        "title": "Have you previously produced Guarantees of Origin?",
        "description": "Soldera is an automated sales agent for Guarantees of Origin. To maximize your revenue from Guarantees of Origin with Soldera, make the selection below",
        "add_authorization": "I have previously produced Guarantees of Origin",
        "create_new_account": "Open a new Guarantees of Origin account in AST",
        "create_new_account_description": "Select this option if you are not receiving Guarantees of Origin and want to register a new device in the AST information system.",
        "add_authorization_description": "Select this option if you are already recieving Guarantees of Origin and want to authorize Soldera to manage them. We can help you register more devices in AST later.",
        "not_sure": "Not sure?",
        "contact_support": "Contact our support team for help",
        "existing_account_title": "Register New Device for Existing Owner",
        "alternative_instructions": "If you wish to open a new account for a device owner you have not yet registered with Soldera, please follow the instructions below."
      },
      "generator_review": {
        "device_name": {
          "title": "Production Device Name"
        },
        "device_power": {
          "title": "Installed Capacity (kW)"
        },
        "device_power_in_permit": {
          "title": "Capacity Specified in System Operator's Permit (kW)"
        },
        "device_eic": {
          "title": "Metering ID (EIC Code)"
        },
        "device_address": {
          "title": "Production Device Address"
        },
        "device_technology": {
          "title": "Technology",
          "options": {
            "device_technology_solar": "Solar",
            "device_technology_wind": "Wind",
            "device_technology_hydro": "Hydro"
          }
        },
        "grid_contract_start_date": {
          "title": "First Date of Commissioning"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "only_device_output": {
          "title": "Meter Corresponds to Net Electricity Output"
        },
        "device_grid_operator": {
          "title": "Grid Connection",
          "options": {
            "grid_operator_tso": "TSO's Grid",
            "grid_operator_dso": "DSO's Grid"
          }
        }
      },
      "do_you_have_subsidy": "Have you received or do you receive state aid?"
    },
    "lt": {
      "authorization": {
        "title": "Do you already have Guarantees of Origin?",
        "description": "To tailor your experience, we need to know if you're already receiving Guarantees of Origin. This helps us determine the best next steps for you.",
        "add_authorization": "Yes, I have Guarantees of Origin.",
        "add_authorization_description": "Select this option if you are already recieving Guarantees of Origin and want to authorize Soldera to manage them. We can help you register more devices in Litgrid later.",
        "create_new_account": "No, I do not have Guarantees of Origin.",
        "create_new_account_description": "Select this option if you are not recieving Guarantees of Origin and want to register a new device in the Litgrid information system.",
        "not_sure": "Not sure?",
        "contact_support": "Contact our support team for help",
        "existing_account_title": "Register New Device for Existing Owner",
        "alternative_instructions": "If you wish to open a new account for a device owner you have not yet registered with Soldera, please follow the instructions below."
      },
      "extra_info": {
        "title": "Additional Information about company",
        "description": "Please provide the following information required by Litgrid."
      }
    },
    "se": {
      "authorization": {
        "title": "Have you previously produced Guarantees of Origin?",
        "description": "Soldera is an automated sales agent for Guarantees of Origin. To maximize your revenue from Guarantees of Origin with Soldera, make the selection below",
        "add_authorization": "I receive EECS Guarantees of Origin",
        "create_new_account": "Open a new Guarantees of Origin account in Swedish Energy Agency",
        "create_new_account_description": "Select this option if you are not receiving Guarantees of Origin and want to register a new device in the Swedish Energy Agency information system.",
        "add_authorization_description": "Select this option if you receive EECS Guarantees of Origin and want to authorize Soldera to manage them. We can help you register more devices in Swedish Energy Agency later.",
        "not_sure": "Not sure?",
        "contact_support": "Contact our support team for help",
        "existing_account_title": "Register New Device for Existing Owner",
        "alternative_instructions": "If you wish to open a new account for a device owner you have not yet registered with Soldera, please follow the instructions below.",
        "add_eecs_conversion": "I receive national Guarantees of Origin",
        "add_eecs_conversion_description": "Select this option if you receive national Guarantees of Origin and want to switch to receiving EECS Guarantees of Origin (European transferable Guarantees of Origin) instead."
      },
      "generator_review": {
        "basic_information": "Basic Information",
        "metering_information": "Metering Information",
        "investment_support": "Investment Support",
        "device_name": {
          "title": "Device Name"
        },
        "device_power": {
          "title": "Installed Capacity (kW)",
          "description": "Enter the installed capacity of the production device in kW"
        },
        "grid_area_id": {
          "title": "Grid Area ID",
          "description": "Enter the grid area ID (three letters or 'IKN')"
        },
        "grid_production_device_id": {
          "title": "Production Device ID",
          "description": "Enter the unique 18-character production device ID"
        },
        "grid_eidel_id": {
          "title": "Ediel ID",
          "description": "Enter the ID number assigned for communication with Svenska Kraftnät"
        },
        "device_power_in_permit": {
          "title": "Device Power in Permit (MW)"
        },
        "device_eic": {
          "title": "Device EIC Code"
        },
        "only_device_output": {
          "title": "Only Device Output"
        },
        "device_address": {
          "title": "Device Address"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "device_grid_operator": {
          "title": "Grid Operator",
          "grid_operator_tso": "TSO",
          "grid_operator_dso": "DSO"
        },
        "grid_contract_start_date": {
          "title": "Grid Contract Start Date"
        },
        "postal_address": {
          "title": "Postal Address",
          "description": "Enter the full street address"
        },
        "postal_code": {
          "title": "Postal Code",
          "description": "Enter the postal code"
        },
        "city": {
          "title": "City",
          "description": "Enter the city name"
        },
        "company_address": "Company Address",
        "invoice_address": "Invoice Address",
        "same_as_company_address": "Invoice address is the same as company address",
        "production_unit": "Production Unit Details",
        "cesar_application": "Cesar Application",
        "go_application": "GO Application",
        "investment_support_question": "Has this production unit received investment support?",
        "investment_support_options": {
          "yes": "Yes",
          "no": "No",
          "do_not_know": "Do not know"
        },
        "property_designation": {
          "title": "Property Designation",
          "description": "Enter the property designation"
        },
        "technology": {
          "title": "Technology",
          "description": "Select the production technology",
          "options": {
            "BTN_Land based": "Land-based Wind",
            "BTN_Ocean based": "Offshore Wind",
            "BTN_Sun": "Solar",
            "BTN_Water": "Hydro",
            "BTN_Thermal": "Thermal Power"
          }
        },
        "thermal_subtype": {
          "title": "Thermal Technology Type",
          "description": "Select the specific thermal technology type",
          "options": {
            "BTN_Industrial back pressure": "Industrial back pressure",
            "BTN_Condensing power": "Condensing power",
            "BTN_Gas engine": "Gas engine"
          }
        },
        "thermal_is_chp": {
          "title": "Is this a CHP unit?",
          "description": "Check if this is a Combined Heat and Power (CHP) unit"
        },
        "holding_percentage": {
          "title": "Holding Percentage",
          "description": "Enter your ownership percentage"
        },
        "metering_location": {
          "title": "Metering Location",
          "description": "Select where the production metering takes place",
          "options": {
            "Directly_after_generator": "Directly after generator",
            "After_auxiliary_equipment": "After auxiliary equipment",
            "After_net_pumping_equipment": "After net pumping equipment",
            "Directly_before_grid_connection": "Directly before grid connection"
          }
        },
        "commissioning_date": {
          "title": "Commissioning Date",
          "description": "Enter the date when the production unit was commissioned"
        },
        "correction_factor_info": {
          "title": "Correction Factor",
          "description": "The standard correction factor will be declared. If the installed capacity is over 10 MW please contact support to declare custom correction factor"
        },
        "investment_support_amount": {
          "title": "Investment Support Amount",
          "description": "Enter the investment support amount received"
        },
        "investment_support_date": {
          "title": "Investment Support Date",
          "description": "Enter the date when investment support was received"
        },
        "grid_metered_by_hour": {
          "title": "Grid Metered by Hour",
          "description": "Select if the grid is metered by hour"
        },
        "grid_concession": {
          "title": "Grid Concession",
          "description": "Select if the grid concession is in place"
        },
        "grid_owner_name": {
          "title": "Grid Owner Name",
          "description": "Enter the name of the grid owner company"
        },
        "grid_owner_corporate_id": {
          "title": "Grid Owner Corporate ID",
          "description": "Enter the corporate registration number of the grid owner"
        },
        "invoice_co_address": {
          "title": "C/O Address for the invoice",
          "description": "Enter care of address for the invoice (if applicable)"
        },
        "invoice_contact_telephone": {
          "title": "Phone number of specific contact for invoice",
          "description": "Enter telephone number of the specific contact/reference person for invoicing"
        },
        "invoice_email": {
          "title": "Invoice Email",
          "description": "Enter email address for invoices"
        },
        "specific_name": {
          "title": "Name of specific contact for invoice",
          "description": "Enter the name of the specific contact/reference person for invoicing"
        },
        "reference_number": {
          "title": "Reference Number",
          "description": "Enter the reference number"
        },
        "invoice_country": {
          "title": "Invoice Country",
          "description": "Enter the country of the invoice address"
        }
      }
    },
    "fi": {
      "authorization": {
        "title": "Get started",
        "description": "Select the transfer option if you already have production devices in the registry. If you don't have any registered devices, contact us to discuss your options.",
        "add_authorization": "Give access to your account in the registry to Soldera",
        "add_authorization_description": "We will have access to your account in the registry and manage certificates for you. Certificates remain on your account.",
        "create_new_account": "Transfer production devices to Soldera",
        "create_new_account_description": "We will transfer your production devices into our registry account and manage them for you.",
        "not_sure": "Need help?",
        "contact_support": "Contact our support team"
      },
      "quickfill": {
        "search": "Search for a company already registered in Fingrid",
        "search_placeholder": "Search for a company in Fingrid",
        "error": "Failed to load companies",
        "quickfill_helper": "Quickfill with a company already registered in Fingrid",
        "manual_entry": "Enter details manually"
      }
    },
    "fallback": {
      "flow_selection": {
        "title": "Get started",
        "intro": "Soldera is the #1 platform for managing Guarantees of Origin. Optimise profitability while minimising administrative workload. Serving industry leaders and thousands of renewable energy production units across Europe.",
        "description": "Select the authorization option if you already have production devices in the registry. If you don't have any registered devices, contact us to discuss your options.",
        "not_sure": "Need help?",
        "contact_support": "Contact our support team",
        "authorization": {
          "title": "Authorize Soldera to manage your production devices",
          "description": "We will manage your production devices for you."
        }
      }
    },
    "proof": {
      "title": "Trusted across Europe"
    }
  },
  "dashboard": {
    "issuance_chart": {
      "title": "Issuance chart",
      "description": "MWh issued per production device over the last 12 months.",
      "y_axis": "MWh issued",
      "y_axis_log": "MWh issued (log scale)",
      "scale_absolute": "Absolute",
      "scale_log": "Log scale",
      "zero_marker_note": "A log scale cannot show zero: months with no issuance are marked with ✕ on the baseline.",
      "no_data": "No issuance data for the last 12 months",
      "load_failed": "Could not load the issuance chart. Please try again."
    },
    "devices_in_registry": "Devices managed in the registry",
    "devices": "Devices",
    "no_devices_in_registry": "No devices in registry",
    "add_device_description": "Add your first device to start managing certificates",
    "add_first_device": "Add First Device",
    "add_registry_device": "Add Registry Device",
    "add_registry_device_description": "Manually add a new device to your registry for managing certificates",
    "select_company": "Select a company",
    "action_required": "Action required",
    "consolidated_view": "Consolidated View",
    "consolidated_view_description": "View all companies together",
    "company_id_label": "ID: {id}",
    "market": {
      "base_price": "Base ask"
    },
    "consolidated": {
      "overview_for": "Overview for {email}",
      "devices_overview": "{count} devices with total of {power} kW",
      "back_to_dashboard": "Back to Dashboard",
      "pending_payouts": "Money pending",
      "paid_out_30d": "Paid out (30d)",
      "projected_production": "Projected Production",
      "projected_production_description": "Production projection based on device power",
      "projected_production_by_company": "Projected Production by Company",
      "projected_production_by_company_description": "Ordered by total projected production",
      "production_volume": "Production Volume",
      "production_volume_description": "Amounts displayed in MWh",
      "production_volume_table": {
        "quarter": "Quarter",
        "month": "Month",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "total": "Total",
        "current": "Current"
      },
      "production_distribution": "Projected Production Source Distribution",
      "production_distribution_description": "Last 12 months",
      "production_devices": "Production Devices",
      "production_devices_description": "{deviceCount} devices in {companyCount} companies",
      "production_devices_table": {
        "company_name": "Company",
        "total": "Total",
        "technology": "Technology",
        "device_count": "Devices",
        "device_name": "Name",
        "device_id": "#",
        "capacity": "Capacity",
        "status": "Status",
        "no_devices": "No devices to display",
        "more_devices": "{count} more devices",
        "view_projection": "View projection",
        "view_breakdown": "View aggregated breakdown",
        "scheduled_transactions_tooltip": "automatic transfers configured in the registry"
      },
      "company_filter_hint": "Choose which companies to explore across the consolidated dashboard",
      "selector_no_companies": "No companies",
      "selector_all_companies": "All companies",
      "selector_countries_companies": "{countries} countries · {companies} companies",
      "selector_company_count": "No companies | 1 company | {count} companies",
      "selector_selected_count": "{selected} of {total} selected",
      "selector_only": "only",
      "selector_show_only": "Show only {country}",
      "selector_remove_country": "Remove {country}",
      "no_companies_selected_title": "No companies selected",
      "no_companies_selected_hint": "Pick at least one company or country above to see its data."
    },
    "buyer": {
      "consolidated_view": "Buyer Consolidated View",
      "go_cancelled": "Energy Attribute Certificates Cancelled",
      "certificates_this_year": "certificates this year",
      "membership_agreement": "Platform Agreement",
      "agree_to_terms": "I agree to the terms and conditions",
      "terms_accepted": "Terms and conditions accepted successfully",
      "manage_inventory": "Buy and Cancel",
      "platform_agreement_clickwrap_intro": "By clicking Accept you agree to the {link}",
      "platform_agreement_link_text": "Soldera Platform Agreement"
    },
    "corporate": {
      "sections": {
        "energy_attribute_certificates": "Energy Attribute Certificates"
      }
    },
    "companies": "@:common.companies",
    "sign_document": "Sign Document",
    "continue_registration": "Continue Registration",
    "add_company_or_device": "Add Company or Device",
    "add_company_access": "Add Company Access",
    "company_id": "Company ID",
    "company_ids_placeholder": "Company ID(s) - single or comma-separated",
    "add_company": "Add Company",
    "internal_role": "Internal Role",
    "user": "User",
    "super_admin": "Super Admin",
    "sales_admin": "Sales Admin",
    "fee_model": "Fee Model",
    "standard": "Standard",
    "special_free": "Special Free",
    "special_5pct": "Special 5%",
    "special_1eur_per_mw": "Special 1€/MW",
    "registry_excluded_devices": "Registry Excluded Devices (comma-separated)",
    "allowed_invite_domains_label": "Allowed invite domains (comma-separated)",
    "allowed_invite_domains_help": "Team invitations may only go to email addresses on these domains. Leave empty to allow any domain.",
    "is_test_company": "Is Test Company?",
    "hosted_account_regions_label": "Hosted account regions (Receive GO)",
    "hosted_account_regions_help": "Select which country registry accounts this company may use for receiving GOs to Soldera-hosted accounts.",
    "save_changes": "Save Changes",
    "all_trackings": "All Trackings",
    "referrer_company_id": "Referrer Company ID",
    "utm_source": "UTM Source",
    "utm_medium": "UTM Medium",
    "utm_term": "UTM Term",
    "utm_content": "UTM Content",
    "utm_campaign": "UTM Campaign",
    "created_at": "Created At",
    "admin_only_transfer_and_delete_company": "ADMIN ONLY: Transfer all assets to another company and DELETE the company:",
    "transfer_to": "Transfer to: {name} - {id}",
    "transfer": "Transfer",
    "nda_signed_link": "The link to the NDA contract we signed with the client",
    "client_nda_signed_link_title": "Special Conditions Documents",
    "client_nda_signed_link": "Please click here to access special terms signed between Soldera and {name}.",
    "custom_percentage": "Custom Percentage",
    "custom_percentage_hint": "Custom percentages between 5 and 20 supported",
    "sales_transactions": {
      "title": "Transaction History",
      "description": "The prices of Guarantees of Origin are volatile and may change daily. Below you will find an overview of all your transactions.",
      "description_link": "For an objective comparison between your transactions and market prices, we recommend reading our article on public price signals of Guarantees of Origin.",
      "no_sales_transactions": "In the future, you will find your transaction history with offer information here!",
      "notificationInfo": "We will notify you via email when sales transactions have occurred.",
      "date": "Transaction Date",
      "item": "Item",
      "final_unit_price": "Unit Price",
      "amount": "Amount",
      "offer_range": "Offer Range",
      "final_country": "Winning Offer Country",
      "status": "Status",
      "processing_explanation": "Soldera is waiting to receive funds from the counterparty. Once received, we'll notify you of the transaction.",
      "completed": "Completed",
      "processing": "Processing",
      "pending_sales_details": "Pending sales details",
      "export_xlsx": "Export to Excel",
      "view_aggregated": "Aggregated",
      "view_by_company": "By company",
      "view_by_power_plant": "By power plant",
      "power_plant": "Power plant",
      "revenue": "Revenue",
      "soldera_fees": "Soldera fees (excl. VAT)",
      "registry_fees": "Registry fees (excl. VAT)",
      "fees_pending": "Fees pending"
    },
    "automaticReporting": {
      "title": "Automatic production reporting",
      "requiresAction": "Requires action",
      "lastUpdated": "Last updated at:",
      "lastDeclaredMonth": "Last declared production month:",
      "lastDeclaredAmount": "Last total amount declared:",
      "helpNeeded": "We require your help to ensure that the correct production device on ESO is linked with the correct device in Litgrid's Grexel registry.",
      "missingAssociation": "Missing association with metering point",
      "automaticallyDeclared": "Automatically declared",
      "declaredFor": "Declared for:",
      "amount": "Amount:",
      "pendingApproval": "Pending approval"
    },
    "income_estimate": {
      "view_estimate": "View income estimate"
    },
    "companyData": {
      "automatic_sale_with_highest_offer": "Automatic sale at the highest offer",
      "fresh_production_sale_above_minimum_price": "Fresh production sale above minimum price of {price}€/MWh",
      "modify": "Modify",
      "money_pending": "Money pending",
      "transaction_history": "Transaction history",
      "origin_certificates": "Guarantees of Origin",
      "view_details": "View details",
      "hide_details": "Hide details",
      "submit_invoice": "Submit invoice",
      "invoice_history": "Invoice history",
      "documents": "@:common.documents",
      "continue_authorization_creation": "Continue application",
      "thank_you_for_joining": "Thank you for joining Soldera!",
      "thank_you_message": "We will contact the registry on your behalf and handle all the proceedings. Now all you have to do is wait for the registry to perform its operations, and we will sell your certificates. Once the sale is made, we will notify you and ask you to generate an invoice so we can transfer the money.",
      "add_companies_or_devices_while_waiting": "While waiting, you have the opportunity to add companies or devices",
      "add_companies_while_waiting": "While waiting, you can add another company",
      "invite_a_friend": "Invite a friend",
      "invite_a_friend_message": "Do you know someone who could also benefit from Soldera? 30% of the fees from each invited friend for their first year goes to you!",
      "click_to_copy_link": "Click here to copy the link to send to a friend",
      "production_settings": "Production settings",
      "measurement_points": "Measurement points",
      "documents_signed_with_soldera": "Membership agreement signed with Soldera",
      "other_documents": "Other documents",
      "company_contract": "Contract with {companyName}",
      "contract_between_company_and_soldera": "Contract between {companyName} and Soldera",
      "link_copied": "Link successfully copied!",
      "link_copied_fallback": "Link copied to clipboard (fallback method).",
      "link_copy_failed": "Failed to copy link. Please copy it manually.",
      "update_min_price_success": "Minimum price update successful!",
      "new_min_price_effective_immediately": "New minimum price is effective immediately",
      "update_min_price_failed": "Failed to update minimum price",
      "invoice_submission_success": "Invoice submission successful!",
      "invoice_paid_within_7_days": "Invoice has been successfully submitted and will be paid within 7 days.",
      "fetch_pending_invoice_items_failed": "Failed to fetch pending invoice items",
      "fetch_certificates_failed": "Failed to fetch certificates",
      "add_device": "Add Device",
      "no_devices": "No devices",
      "add_device_message": "Add a device to your company to start managing your production.",
      "team": {
        "title": "Team",
        "invite_title": "Invite to team",
        "not_trusted_tooltip": "Adding team members is available once your account has been activated. Contact support@soldera.org to get set up.",
        "delete": "Delete",
        "invite": "Invite",
        "send_invite_email": "Send invite email",
        "invalidName": "Name must be at least 2 characters long",
        "invalidEmail": "Invalid email format",
        "domain_not_allowed": "Only these email domains can be invited: {domains}",
        "allowed_domains_hint": "Invitations are limited to these email domains: {domains}",
        "confirmDelete": "Are you sure you want to remove this {account_name} access to {company_name}?"
      },
      "available_guarantees_of_origin": "Available Guarantees of Origin",
      "manage_inventory": "Manage Inventory",
      "projected_production": "Projected Production",
      "manage_production_strategy": "Manage Production Strategy",
      "invoice_management": "Invoice Management",
      "cancellation_documents": "Cancellation Documents"
    },
    "generator": {
      "license_number": "Device with license number {license_number}",
      "hide_documents": "Hide related documents",
      "show_documents": "Show related documents"
    },
    "documents": {
      "last_updated": "Last updated",
      "section_title": "{document_count} documents",
      "expand": "See all {document_count} documents",
      "collapse": "Hide documents",
      "hide_details": "Hide documents in container",
      "show_details": "Show documents in container",
      "document_title": "{document_name}",
      "other_document": "Document updated at {updated_at}",
      "show_associated_device": "Show associated device",
      "hide_associated_device": "Hide associated device",
      "no_documents": "No documents yet",
      "no_documents_message": "Documents you upload or receive will appear here"
    },
    "portfolio": {
      "no_portfolio_data_title": "Your portfolio data is not available yet",
      "no_portfolio_data_subtitle": "Your portfolio data will be displayed here after we have retrieved your registry data.",
      "all_portfolios": "All Portfolios",
      "total_volumes": "Total Volumes",
      "available_volumes": "Available Volumes",
      "expired_volumes": "Expired Volumes",
      "sold_volumes": "Sold Volumes",
      "monthly_technology_breakdown": "Monthly By Technology",
      "monthly_sales_status": "Monthly By Sales Status",
      "company_breakdown": "Volumes by Company",
      "guarantees_of_origin_in_portfolios": "Guarantees of Origin in Portfolios",
      "projected_production": "Projected Production",
      "pending_payouts": "Pending Payouts",
      "production_devices": "Production Devices",
      "documents": "@:common.documents",
      "recipient_eecs_account_number": "Recipient EECS Account Number",
      "recipient_internal_account_number": "Registry Internal Account Number",
      "recipient_internal_account_help": "Optional. Required only for registries that use sub-accounts.",
      "recipient_internal_account_placeholder": "Optional sub-account ID",
      "document": {
        "title": "@:common.documents",
        "company": "@:common.company",
        "status": "Status",
        "last_updated": "Last updated",
        "actions": "@:common.actions.title",
        "contract_details": "Contract Details"
      },
      "certificatesTableTitle": "Portfolio Certificates",
      "sendGoChatWelcome": "Hello! How can I help you send Guarantees of Origin today?",
      "sendGoChatWelcomeWithCerts": "Hello! I see you've selected {count} certificate(s). What are the recipient details?",
      "sendGoChatAssistant": "GO Send Assistant",
      "sendGoChatPlaceholder": "Ask about sending GOs, provide recipient details, or drop a file...",
      "sendGoChatInputPlaceholder": "Enter recipient details or MWh amount...",
      "sendGoOrderSummary": "Sending Order Summary",
      "selected_certificates": "Selected Certificates",
      "selected_certificates_summary": "Selected Certificates Summary",
      "disabledReasonPortfolio": "This certificate bundle cannot be sent because it's already allocated for {portfolio} portfolio",
      "disabledReasonStatus": "This certificate is not available in the selected status.",
      "disabledReasonUnknown": "This certificate is not available in the selected portfolio.",
      "recipientRegistryId": "Recipient Registry ID",
      "recipientCountry": "Recipient Country",
      "recipientCompanyName": "Recipient Company Name",
      "certificatesToSend": "Certificates to Send",
      "noCertificatesSelected": "No certificates selected for sending.",
      "totalMwhToSend": "Total MWh to Send",
      "totalMwhInTable": "Selected MWh",
      "sendGoDropFile": "Drop file here to extract details",
      "sendGoUploadingFile": "Uploading {name}...",
      "sendGoUploadSuccess": "Successfully uploaded {name}.",
      "sendGoSuccessMessage": "Send order submitted successfully!",
      "no_certificates_to_display": "No certificates match the current filters.",
      "disabled_reason_portfolio": "Certificate is in '{portfolio}' portfolio.",
      "disabled_reason_status_sold": "This certificate cannot be selected because it has been sold.",
      "disabled_reason_status_ongoing_sale": "This certificate cannot be selected because it is in an ongoing sale.",
      "disabled_reason_status_expired": "This certificate cannot be selected because it has expired.",
      "disabled_reason_status_non_transferrable": "This certificate cannot be selected because it is not transferrable.",
      "disabled_reason_status_reserved": "This certificate cannot be selected because it is reserved for other tasks.",
      "disabled_reason_status_waiting_for_sale": "This certificate cannot be selected because it is waiting for sale.",
      "disabled_reason_status_pending": "This certificate cannot be selected because it is pending action by the system.",
      "disabled_reason_status_unknown": "This certificate cannot be selected due to its status: {status}.",
      "disabled_reason_unknown": "Cannot be selected",
      "recipient_registry_id": "Recipient Registry ID",
      "recipient_country": "Recipient Country",
      "recipient_company_name": "Recipient Company Name",
      "certificates_to_send": "Certificates to Send",
      "no_certificates_selected": "No certificates selected for sending.",
      "total_mwh_to_send": "Total MWh to Send",
      "available_certificates_title": "Available Certificates in Self-managed Portfolio",
      "table": {
        "more_certificates": "{count} more certificates",
        "select_columns": "Select columns",
        "columns_selected": "{count} columns selected",
        "filters": {
          "search_company": "Search company",
          "search_accounts": "Search accounts",
          "search_portfolio": "Search portfolio / project",
          "search_device": "Search device",
          "month_placeholder": "YYYY-MM",
          "cod_age_year_placeholder": "Year",
          "cod_age_add_condition": "Add condition",
          "active": "@:common.active"
        },
        "filter_chips": {
          "group_label": "Active filters",
          "label": "Filters",
          "none": "None",
          "value": "{column}: {value}",
          "remove": "Remove {column} filter",
          "hiding": "hiding {values}",
          "count_of_total": "{shown} of {total}",
          "contains": "contains “{text}”",
          "cod_age_years": "{conditions} years",
          "tag_default": "Default",
          "tag_document": "From document",
          "tag_unavailable": "No matching inventory",
          "reset": "Reset to default filters",
          "clear_all": "Clear all"
        },
        "filtered_total": "Total",
        "count_cell": {
          "of": "of {count}",
          "editor": "MWh to select from this row",
          "full_title": "Click to select only part of this row",
          "full_label": "Selected all {count} MWh, select only part of this row",
          "partial_title": "Click to change the amount",
          "partial_label": "Selected {selected} of {count} MWh, change amount"
        }
      },
      "footer": {
        "action": "Action",
        "technology_amount": "Technology & Amount",
        "production_period": "@:common.production_period",
        "production_support": "Production Support",
        "no_certificates_selected": "No certificates selected",
        "review_send_title": "Review Send",
        "review_sell_title": "Review Sell",
        "review_cancel_title": "Review Cancel",
        "confirm_send_btn": "Send Now",
        "confirm_sell_btn": "Sell Now",
        "confirm_cancel_btn": "Cancel Now",
        "cancel_btn": "@:common.cancel",
        "missing": "Missing",
        "overselected": "Overselected",
        "matched": "Matched",
        "strategy_auto_high": "Automatic High Bid",
        "strategy_min_price": "Fresh production above min price",
        "strategy_min_price_detailed": "Min price €{price}/MWh for first {duration} months, then auto-sell at market price",
        "risk_flags": "Risk Flags",
        "risk_region_mismatch": "Region mismatch detected",
        "risk_insufficient_inventory": "Insufficient inventory",
        "selected_mwh": "{mwh} MWh",
        "of_available": "of {mwh} available",
        "rows": "Rows",
        "rows_selected": "none selected | {count} selected | {count} selected",
        "rows_partial": "none partial | {count} partial | {count} partial",
        "rows_hidden": "none hidden by filters | {count} hidden by filters | {count} hidden by filters",
        "partial_hint": "Click an amount to select part of a row"
      },
      "cancelGoChatAssistant": "GO Cancellation Assistant",
      "cancelGoChatPlaceholder": "Confirm certificates to cancel or ask questions...",
      "cancelGoChatInputPlaceholder": "Type confirmation or reason...",
      "cancelGoOrderSummary": "Cancellation Summary",
      "certificatesToCancel": "Certificates to Cancel / Retire",
      "noCertificatesSelectedCancel": "No certificates selected for cancellation.",
      "totalMwhToCancel": "Total MWh to Cancel",
      "cancelGoChatIntro": "You have selected {count} certificate(s) for cancellation. Please confirm or provide a reason.",
      "sellGoChatAssistant": "GO Sales Assistant",
      "sellGoChatPlaceholder": "Confirm certificates and sales strategy...",
      "sellGoChatInputPlaceholder": "Confirm sales strategy or ask questions...",
      "sellGoOrderSummary": "Sales Summary",
      "certificatesToSell": "Certificates to Sell",
      "noCertificatesSelectedSell": "No certificates selected for selling.",
      "totalMwhToSell": "Total MWh to Sell",
      "sellGoChatIntro": "You have selected {count} certificate(s) to set up for sale. Please confirm the sales strategy.",
      "receiveGoChatAssistant": "GO Receiving Assistant",
      "receiveGoChatPlaceholder": "Describe the GOs you expect to receive...",
      "receiveGoChatInputPlaceholder": "Enter sender details or ask questions...",
      "receiveGoOrderSummary": "Receiving Summary",
      "senderRegistryId": "Sender Registry ID",
      "senderCountry": "Sender Country",
      "senderCompanyName": "Sender Company Name",
      "expectedMwh": "Expected MWh",
      "receiveGoTablePlaceholder": "Expected incoming transfers will be listed here.",
      "buyGoChatAssistant": "GO Buying Assistant",
      "buyGoChatPlaceholder": "What kind of GOs are you looking for? Describe volume, technology, price range etc.",
      "buyGoChatInputPlaceholder": "Specify volume, technology, price range...",
      "buyGoOrderSummary": "Buy Request / Offers",
      "buyVolume": "Volume (MWh)",
      "buyTechnology": "Technology (Optional)",
      "buyMaxPrice": "Max Price (€/MWh, Optional)",
      "buyOffersPlaceholder": "Offers matching your request will appear here.",
      "buyGoTablePlaceholder": "Potential GOs to buy will be listed here.",
      "fileUpload": {
        "uploadPrompt": "Drop contract here or click to upload",
        "drop_prompt": "Drop your file to upload",
        "title": "Upload Contract",
        "description": "Upload a contract to automatically extract recipient details",
        "dropzone": "Drop contract here or click to browse",
        "supportedFormats": "Supported formats: PDF, Word, Excel, etc.",
        "analyzing": "Analyzing contract...",
        "extractionComplete": "Analysis complete! I've found recipient information.",
        "apply": "Apply Extracted Details",
        "reset": "Reset",
        "uploadAnother": "Upload another file",
        "analysisSuccessTitle": "Contract analyzed successfully.",
        "analysisSuccessMessage": "File details have been extracted and applied to the form.",
        "analysisNoMatchTitle": "No matching certificates.",
        "analysisNoMatchMessage": "The document's criteria (technology, device or production period) don't match any of your available certificates, so nothing could be selected. Please review the request or your filters.",
        "analysisShortfallTitle": "Not enough matching certificates.",
        "analysisShortfallMessage": "Only {selected} MWh of the requested {requested} MWh could be selected from the matching certificates. Review the shortfall before confirming."
      },
      "sellGoSuccessMessage": "Sell order submitted successfully!",
      "sellGoSuccessTitle": "Sale Setup Complete",
      "confirmSellTitle": "Confirm Sale Setup",
      "confirmSellMessage": "You are requesting to sell {mwh} MWh of your renewable energy certificates through Soldera's market price system.",
      "confirm_sell_minimum_price_message": "You are requesting to sell {mwh} MWh of your renewable energy certificates using the minimum price strategy. Here's how it works:",
      "confirm_phase_1_title": "First {duration} months from production",
      "confirm_phase_1_description": "Certificates will only be sold if the market price meets or exceeds your minimum price of €{price}/MWh.",
      "confirm_phase_2_title": "After {duration} months from production",
      "confirm_phase_2_description": "Any remaining certificates will automatically be sold at the highest available market price to ensure they don't lose value.",
      "technologies": "Technologies",
      "production_months": "Production Months",
      "spotSalesPortfolio": "Spot Sales Portfolio",
      "spotSalesPortfolioDescription": "Available for sale at market price",
      "spot_sales_min_price_description": "Minimum price applies first, then auto-sells at market price",
      "oldCertificatesWarningTitle": "Certificate Age Warning",
      "oldCertificatesWarningMessage": "You have selected {count} MWh of certificates that are older than {duration} months from their issuance date. The minimum price strategy only applies to certificates within the first {duration} months after issuance. Please remove these older certificates to proceed with the minimum price strategy.",
      "disabled_reason_status_own_use": "This certificate cannot be selected because it is marked for own use and cannot be traded."
    }
  },
  "cancellation": {
    "list_title": "Cancellation Statements",
    "add_new_statement": "Add New Cancellation Statement",
    "not_trusted_tooltip": "Adding statements is available once your account has been activated. Contact support@soldera.org to get set up.",
    "no_cancellations": "No Cancellation Statements",
    "no_cancellations_info": "Your cancellation statements will appear here after you upload them",
    "view_details": "View Details",
    "download_documents": "Download Documents",
    "download_shown": "Download shown (no documents) | Download shown ({count} document) | Download shown ({count} documents)",
    "download_preparing": "Preparing {current} / {total}…",
    "download_preparing_documents": "Preparing documents…",
    "download_none_selected": "No documents in the current selection",
    "download_too_many_documents": "Too many documents to download at once ({count}). Narrow the filters to at most {max}.",
    "download_too_many_bytes": "The selected documents total {total} MB; the limit is {max} MB. Narrow the filters and try again.",
    "download_too_large_title": "Selection too large to download",
    "bulk_download_failed": "Failed to download cancellation statements",
    "bulk_download_no_documents_title": "No documents to download",
    "bulk_download_no_documents": "None of the selected documents are available any more. The list has been refreshed.",
    "create_statement": "Create Statement",
    "drop_to_create": "Drop files to create a new cancellation statement",
    "table": {
      "id": "@:common.id",
      "created": "Created",
      "beneficiary_name": "Beneficiary Name",
      "period": "Period",
      "mwh_cancelled": "MWh Cancelled",
      "purpose": "Purpose",
      "registry": "Registry",
      "registry_code": "Registry Code",
      "more_statements": "{count} more statements"
    },
    "details_title": "Cancellation Statement Details",
    "details": {
      "basic_info": "Statement Information",
      "documents": "Uploaded Documents",
      "no_documents": "No documents uploaded",
      "period": "@:cancellation.table.period",
      "order_id": "Order ID",
      "load_error": "Failed to load cancellation details",
      "download_all": "Download All Documents",
      "registry_document": "Registry Document",
      "view_registry_document": "View on Registry",
      "add_documents": "Add documents",
      "upload_selected": "Upload"
    },
    "upload": {
      "drop_files": "Drag and drop files here or click to browse",
      "supported_formats": "Supported formats: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, PNG, JPG, JPEG (max 25MB each)"
    },
    "modal": {
      "upload_documents": "Upload Documents",
      "upload_description_with_ai": "Upload cancellation contracts or compliance documents to automatically populate form fields, or add supporting documentation.",
      "analyzing_document": "Analyzing document with AI...",
      "ai_analysis_applied": "AI analysis has been applied to the form",
      "ai_populated": "AI Populated",
      "clear_ai_data": "Clear AI Data",
      "confirm_override_ai_data": "This will replace the AI-populated data with order data. Are you sure you want to continue?",
      "analysis_complete_title": "Analysis Complete",
      "analysis_success_with_fields": "Successfully analyzed document and updated {count} field(s).",
      "analysis_success_no_fields": "Document analyzed successfully, but no new information was found to update the form.",
      "analysis_success_multiple_statements_with_fields": "Found {total_statements} statements in document. Applied first statement and updated {count} field(s). Please review the remaining statements manually.",
      "analysis_success_multiple_statements_no_fields": "Found {total_statements} statements in document, but no new information was found to update the form.",
      "multiple_statements_warning": "Multiple statements ({total_statements}) were detected in the document. Only the first statement was used to populate the form. Please review the remaining statements manually.",
      "uploaded_files": "Uploaded Files",
      "files_required": "At least one file is required",
      "order_selection": "Link to Cancellation Order",
      "order_selection_description": "Optionally link this statement to an existing cancellation order to auto-fill form data.",
      "linked_order": "Linked Cancellation Order",
      "no_order_selected": "None (manual entry)",
      "order_option": "Order #{id} - {date}",
      "order_help_text": "Select an order to automatically fill the form with existing data, or choose 'None' to enter manually.",
      "statement_selection": "Select Statement",
      "no_statement_selected": "Please select a statement",
      "statement_help_text": "Choose a specific statement from the selected order to auto-fill the form data.",
      "statement_details": "Statement Details",
      "auto_fill_from_statement_notice": "Form data has been automatically filled from the selected statement. You can modify any field as needed.",
      "select_statement_notice": "Please select a statement from the dropdown above to auto-fill the form.",
      "field": {
        "operation_notes": "Operation Notes"
      }
    },
    "purpose": {
      "DISCLOSURE": "Disclosure",
      "GRID_LOSSES": "Grid Losses",
      "SELF_CONSUMPTION": "Self Consumption",
      "SUPPORT_SCHEME": "Support Scheme",
      "OTHER": "Other"
    },
    "success": {
      "title": "Statement Created!",
      "message": "Your cancellation statement has been successfully created."
    }
  },
  "document": {
    "document_container": "Document container",
    "send_elering_email": "Send Elering email",
    "resend_email": "Resend email",
    "signed": "Signed",
    "awaiting_signature": "Awaiting signature",
    "download": "Download document",
    "sign_document": "Sign document",
    "delete_document": "Delete document",
    "admin_delete_document": "Admin delete document",
    "confirm_delete": "Are you sure you want to delete this document?",
    "confirm_admin_delete": "Are you sure you want to delete this document as admin?",
    "unfinished_document": "Unfinished registration",
    "forward_service_appendix": {
      "title": "Forward Sales Agreement",
      "description": "This sets the default terms for any Forward Sales the Member and Soldera enter into and provides a framework for the Parties agreeing to Forward Sales Instructions."
    }
  },
  "documents_table": {
    "no_documents": "No documents to display",
    "columns": {
      "id": "@:common.id",
      "name": "@:common.name",
      "type": "Type",
      "category": "Category",
      "company": "@:common.company",
      "status": "Status",
      "created": "Created",
      "actions": "@:common.actions.title"
    },
    "filters": {
      "search_name": "Search by name",
      "search_company": "Search by company"
    },
    "type": {
      "custom_upload": "Upload",
      "dokobit_document": "Signed Document"
    },
    "category": {
      "sending_gos_file_upload": "GO Sending",
      "buy_contract_analysis": "Buy Contract",
      "cancel_contract_analysis": "Cancellation Contract",
      "ppa_contract_analysis": "PPA Contract",
      "bulk_buy_analysis": "Bulk Buy",
      "ppa_instructions": "PPA Instructions",
      "ppa_creation": "PPA Creation",
      "cancellation_statement": "Cancellation Statement",
      "issuance_data_import": "Issuance Data",
      "arbitrary_file_upload": "File Upload",
      "portfolio_documentation": "Portfolio Documentation",
      "other": "Other",
      "unknown": "Unknown"
    },
    "status": {
      "uploaded": "Uploaded",
      "completed": "Signed",
      "awaiting_signature": "Awaiting Signature",
      "canceled": "Canceled"
    },
    "actions": {
      "archive": "Archive",
      "sign": "Sign",
      "view_details": "Details"
    },
    "details_modal": {
      "title": "Document Details",
      "contract_details": "Contract Details",
      "source": "Source"
    },
    "confirm_archive": "Are you sure you want to archive this document? It will be removed from the list.",
    "archive_success_title": "Document archived",
    "archive_success_message": "The document has been archived successfully.",
    "linked_cancellations": "Linked Cancellations",
    "cancellation_id": "Cancellation #{id}"
  },
  "followup": {
    "international_self_signup": {
      "title": "Book your onboarding demo",
      "message": "Thanks for signing up! Book a demo with our team to finish onboarding and sign the necessary documents.",
      "book_demo": "Book a demo"
    },
    "latvia_manual_auth": {
      "title": "Authorize Soldera in Grexel to Complete Setup",
      "message": "Before Soldera can start managing your Guarantees of Origin, you need to manually authorize us in Grexel. Please follow the instructions in the document below to finish the process.",
      "button": "View instructions"
    },
    "latvia_sales_followup": {
      "title": "We will be in touch soon!",
      "message": "Your new devices will require an independent audit before AST will accept them. We will be in touch soon to discuss the next steps. In the meantime, you can add another company or device.",
      "button": "Add Companies or Devices"
    }
  },
  "validations": {
    "required": "This field is required.",
    "maxValue": "The maximum value is {max}.",
    "minValue": "The minimum value is {min}.",
    "required_and_min": "This field is required and the value must be at least {min}.",
    "required_and_range": "This field is required and the value must be between {min} and {max}.",
    "exactStringLength": "This field must be exactly {length} characters long.",
    "exactDigitLength": "This field must be exactly {length} digits long.",
    "minLength": "This field is currently '{model}' characters long, but must be at least {min} characters long.",
    "maxLength": "This field must be at most {max} characters long.",
    "estonianPersonalID": "This field must contain a valid personal ID.",
    "estonianCompanyCode": "This field must contain a valid company registration code.",
    "estonianIDorCompanyCode": "This field must be either a company registration code or the owner's personal ID.",
    "estonianYourPersonalIDifID": "The personal ID must match the owner's personal ID.",
    "estonianDeviceEIC": "This field must contain a valid device EIC code (e.g.: 38ZEE-12345678-X).",
    "estonianVATNumber": "Please enter a valid VAT number.",
    "latvianCompanyNumber": "This field must contain a valid company registration code.",
    "lithuanianCompanyNumber": "This field must contain a valid company registration code.",
    "latvianIDorVATNumber": "This field must contain the VAT code for companies or the personal code for individuals",
    "latvianYourPersonalIDifID": "The personal ID must match the owner's personal ID.",
    "latvianIDorRegistryCode": "This field must contain the registry code for companies or the personal code for individuals",
    "notExampleEIC": "The EIC must not be the code provided in the example, but must be the actual device EIC code.",
    "alpha": "This field may only contain letters.",
    "personalName": "Please enter your name as it appears on your identity document.",
    "phoneNumber": "This field must contain a valid phone number.",
    "someSubsidies": "If the production device has received subsidies, they must be specified here.",
    "generatorExists": "Please upload your network contract for the production device to continue.",
    "reasonableDate": "Please make sure the date is correct.",
    "iban": "Please enter a valid IBAN number.",
    "fileRequired": "Please upload the required document.",
    "swedishPersonalID": "This field must contain a valid Swedish personal ID number (YYMMDD-BBBC).",
    "swedishCompanyCode": "This field must contain a valid Swedish organization number.",
    "swedishIDorCompanyCode": "This field must contain either a valid Swedish personal ID or organization number.",
    "finnishPersonalID": "This field must contain a valid Finnish personal ID.",
    "finnishBusinessID": "This field must contain a valid Finnish Business ID (Y-tunnus).",
    "finnishIDorBusinessID": "This field must contain either a valid Finnish personal ID or Business ID.",
    "integer": "This field must contain a whole number.",
    "required_and_integer": "This field is required and must be a whole number.",
    "required_integer_and_min": "This field is required, must be a whole number, and at least {min}.",
    "required_integer_and_range": "This field is required, must be a whole number, and between {min} and {max}.",
    "selection_required": "At least one selection is required.",
    "between": "Value must be between {min} and {max}.",
    "validRegistryCode": "Registry code must be 3-20 alphanumeric characters (letters, numbers, hyphens allowed).",
    "validAddress": "Address must be between 5 and 200 characters long.",
    "validVATNumber": "Please enter a valid VAT number (format: XX123456789 or CHE123456789).",
    "swedishVATNumber": "Please enter a valid Swedish VAT number (format: SE + 10 digits + 01, e.g., SE556229657301).",
    "validRepresentativeName": "Name must be 2-100 characters and include both first and last name.",
    "validRepresentativePhone": "Phone number must be 6-25 characters and in a valid format.",
    "productionValue": "Production value must be greater than zero.",
    "dateCannotBeFuture": "Date cannot be in the future.",
    "email": "Please enter a valid email address.",
    "eecs_account_format": "Invalid EECS account number format",
    "unit_price_pln_format": "Must be a positive amount with at most 2 decimal places"
  },
  "registry_device": {
    "device_name": "Device Name",
    "device_power": "Device Power",
    "supported_device": "Supported Device",
    "fetch_failed": "Failed to fetch devices",
    "device_code": "Device Code",
    "technology_code": "Technology Code",
    "commercial_operation_date": "Commercial Operation Date",
    "ecolabel_approved": "Ecolabel Approved",
    "address": "@:common.address",
    "device_eic_placeholder": "Enter device identification code",
    "device_name_placeholder": "Enter device name",
    "device_power_placeholder": "Enter power capacity in kW",
    "device_eic_description": "Unique identifier for the device in the registry",
    "commercial_operation_date_description": "The date when the device started commercial operation",
    "polish_fields": {
      "title": "Additional Information Required for Issuance Data Power of Attorney",
      "installation_address": "Installation Address",
      "installation_address_placeholder": "Enter the physical address of the device installation",
      "installation_address_description": "The physical address where the renewable energy device is installed",
      "metering_system_number": "Metering System Number",
      "metering_system_number_placeholder": "Enter the metering system identifier",
      "metering_system_number_description": "The unique identifier for the metering system",
      "metering_system_multiplier": "Metering System Multiplier",
      "metering_system_multiplier_placeholder": "Enter the multiplier value",
      "metering_system_multiplier_description": "The multiplier factor applied to meter readings",
      "osd_name": "Distribution System Operator (OSD) Name",
      "osd_name_placeholder": "Enter the OSD name and branch (if applicable), e.g., PGE Dystrybucja S.A. Oddział Łódź",
      "osd_name_description": "The name of the distribution system operator and specific branch connected to your device",
      "osd_address": "OSD Address",
      "osd_address_placeholder": "Enter the OSD address (branch address if applicable), e.g., ul. Tuwima 58, 90-021 Łódź",
      "osd_address_description": "The address of the distribution system operator branch connected to your device"
    },
    "poa": {
      "generate": "Generate Power of Attorney",
      "generating": "Generating PoA...",
      "generated_successfully": "Power of Attorney Generated Successfully",
      "description": "Generate a Power of Attorney document to authorize Soldera to access your device's issuance data",
      "missing_polish_data_error": "This device is missing required information for Power of Attorney generation",
      "required_for_issuance": "The following information is required to generate a Power of Attorney for accessing issuance data."
    },
    "production_estimate_override": {
      "title": "Production Estimate Override",
      "save": "Save",
      "saving": "Saving...",
      "use_manual_estimates": "Use manual estimates",
      "use_automatic_estimates": "Use automatic estimates",
      "monthly_production_estimates": "Monthly Production Estimates",
      "automatic_vs_manual": "Automatic vs Manual",
      "automatic_calculated": "Automatic (calculated)",
      "automatic": "Automatic",
      "manual": "Manual",
      "override_button": "Override Estimates",
      "projected_production": "Projected Production",
      "configured_values": "Configured values",
      "calculated_values": "Calculated from historic data",
      "feasibility_warning": "Based on the new estimates, your forward sales mandates may no longer cover what they owe: in {period}, {demand} MWh is committed but the estimate falls {shortfall} MWh short. Please review your forward volumes.",
      "feasibility_warning_title": "Forward sales strategy warning"
    }
  },
  "account": {
    "name": "Name",
    "email": "Email",
    "phone_number": "Phone number",
    "registry_code": "Personal ID",
    "comment": "Comment"
  },
  "company": {
    "payout_currency": "Payout currency",
    "payout_currency_hint": "Payouts in other currencies are enabled by Soldera support.",
    "fee_schedule_notice": "Soldera's fees are charged according to our {link}, unless otherwise agreed in writing.",
    "fee_schedule_link_text": "fee schedule",
    "name": "@:common.name",
    "registry_code": "Registry code or personal ID",
    "address": "@:common.address",
    "vat": "VAT Number",
    "vat_or_personal_id": "VAT code or personal ID",
    "bank_account": "Bank Account (IBAN)",
    "bank_name": "Bank Name",
    "bank_swift": "Bank SWIFT Code",
    "invalid_vat": "VAT number must be empty or in format XX999999999 (country code + 8-12 digits)",
    "contact_email": "Contact Email",
    "invoice_email": "Invoice email",
    "billing_email": "Billing email address",
    "billing_email_tooltip": "Invoices will also be sent to this address in addition to your account email. Useful for forwarding to your accountant or finance department.",
    "monthly_rollup": "Skip sale notifications — get one monthly email on the 1st, forward sales included",
    "monthly_rollup_tooltip": "You will not get an email when a sale is made or when a forward sale of your production changes. Instead, on the 1st of each month you get one email with last month's sales, your fee invoice and the changes to your forward sales. Payout invoices are still sent when you request a payout."
  },
  "generator": {
    "device_name": "Inverter Model",
    "device_eic": "Device EIC",
    "device_power": "Total Power (KW)",
    "device_address": "Device Address",
    "grid_contract_start_date": "Production Start Date",
    "subsidies": "Subsidies",
    "battery": "Storage Device",
    "ppa": "Power Purchase Agreement",
    "no_subsidies": "No subsidies",
    "no_storage_device": "No storage device",
    "no_ppa": "No Power Purchase Agreement",
    "no_battery": "No storage device",
    "subsidy_provider": "Subsidy provider: {provider}",
    "subsidy_plan": "Subsidy plan: {plan}",
    "unit_power": "Unit power: {power}",
    "capacity": "Capacity: {capacity}",
    "ppa_start_date": "Start date: {date}",
    "ppa_mwh": "MWh: {mwh}",
    "ppa_client_name": "Client company: {name}",
    "ppa_country": "Client country: {country}",
    "EIC": "EIC",
    "status": {
      "1": "Unregistered",
      "2": "Document to sign",
      "3": "Registered"
    },
    "continue_registration": "Continue registration",
    "sign_document": "Sign document",
    "edit": "Edit",
    "properties": {
      "device_name": "Inverter Model",
      "solar_panel_model": "Solar Panel Model",
      "device_address": "Address",
      "device_power": "Capacity",
      "battery": "Storage Device",
      "subsidies": "Subsidies"
    },
    "unspecified": "Unspecified",
    "documents": "@:common.documents",
    "document_title": "Contract for device EIC: {eic}",
    "license_number": "License number"
  },
  "invoice": {
    "status": {
      "paid": "Paid",
      "canceled": "Canceled",
      "requested": "Requested",
      "drafting": "Drafting"
    },
    "regenerate_confirmation": "Are you sure you want to regenerate the invoice?",
    "regenerate": "Regenerate",
    "cancel_fee_only": "Cancel",
    "cancel_fee_only_confirmation": "Are you sure you want to cancel this fee-only invoice? The invoice items will return to pending and both the fee and settlement invoices will be soft-deleted.",
    "cancel_mixed_types_disabled": "Cannot cancel a mix of expense and fee-only invoices in one batch — select only one type at a time.",
    "send_to_merit": "Send to Merit",
    "send_to_merit_confirmation": "Are you sure you want to send this invoice to Merit?",
    "already_in_merit": "Invoice is already registered in Merit.",
    "error_downloading": "Error downloading the invoice",
    "number": "Number",
    "status_label": "Status",
    "requested_date": "Requested Date",
    "amount": "Amount"
  },
  "invoiceHistory": {
    "title": "Invoice History",
    "noInvoices": "You will find all your invoices here in the future!",
    "notificationInfo": "We will notify you by email when sales transactions have occurred.",
    "export_xlsx": "Export to Excel"
  },
  "setPriceTerms": {
    "modifyStrategyTitle": "Modify Sales Strategy",
    "selectStrategyLabel": "Select Sales Strategy",
    "automaticHighBid": "Automatic sale at highest bid",
    "fresh_prod_above_min_price": "Set a time-limited minimum price",
    "minimumPriceDuration": "Minimum price for the first {duration} months",
    "minimumPriceLabel": "Minimum price",
    "enterPrice": "Enter price",
    "saveChanges": "Save Changes",
    "readMore": "Read More",
    "duration": {
      "minimum_price_window": "Minimum price window",
      "default_hint": "Default is 6 months from production date",
      "limit_active_for": "Limit active for {duration} months from issuance"
    },
    "warning": {
      "depreciation": "Warning: Certificates older than 6 months tend to depreciate quickly as they approach the 12‑month transfer deadline.",
      "noSaleAt12": "Critical Warning: With 10-12 months selected, your GOs may depreciate to zero value as certificates cannot be transferred after 12 months from issuance. Already at the 10-month mark, there is little time remaining, making these certificates difficult to sell."
    },
    "phases": {
      "title": "How this strategy works",
      "phase_1_badge": "Phase 1",
      "phase_1_title": "First {duration} months from production",
      "phase_1_description": "Certificates are held until the market price meets or exceeds your minimum price of €{price}/MWh. If the price is below your minimum, the certificates are not sold.",
      "phase_2_badge": "Phase 2",
      "phase_2_title": "After {duration} months from production",
      "phase_2_description": "Any unsold certificates are automatically sold at the highest available market price. This ensures your certificates are always sold before they expire.",
      "readonly_summary": "Min price for first {duration} months, then auto-sell at market price"
    },
    "howMinimumPriceWorks": "How Soldera's Minimum Price Works",
    "contentParagraph1": "Automatic sales at market price offer a secure way to sell Guarantees of Origin, spreading risk and ensuring they are sold when their freshness is most valued.",
    "content_paragraph_2": "We understand that many of our members would like to plan their sales of Guarantees of Origin. However, there is always a risk that the price of the certificates does not reach the desired minimum. Thus, selling at market price is a better option than letting the certificates expire and therefore go unsold.",
    "content_paragraph_3": "Therefore, we offer the option to set a minimum price strategy. For the first {duration} months after your certificates are issued, we will only sell them if the market price meets or exceeds your minimum price. After this {duration}-month period expires, we will automatically sell all remaining certificates at the current market price to prevent them from losing value. This strategy gives you the opportunity to benefit from price increases while ensuring your certificates are always sold before they expire.",
    "howMarketPriceWorks": "How Soldera's Market Price Works",
    "marketPriceContentParagraph1": "Soldera aggregates GOs from multiple members into larger sales transactions, combining our collective volume to achieve stronger market positioning and better prices. We conduct regular sales using smart strategies and timing that maximizes transaction frequency. To facilitate this process, we transfer your GOs to our registry account, where our software handles everything automatically - you never need to negotiate with buyers or manage transfers yourself.",
    "marketPriceContentParagraph2": "Before each sale, Soldera obtains price quotes from our wide network of international buyers, ensuring competitive pricing through our market relationships. We select the best price offered and complete the sale on behalf of all participating members. Our automated system handles all the complexity while maintaining transparency in the pricing process.",
    "marketPriceContentParagraph3": "Within 5 days of receiving payment from the buyer, we'll notify you of the transaction details by email, including your portion of the proceeds after deducting our fee and transaction costs (most commonly registry export fees). You can then request your payout with one click through the Soldera Platform - if you don't wish to issue an invoice immediately, you may do so later at any time. Soldera transfers the payment to your account within 7 days of receiving your invoice."
  },
  "requestInvoice": {
    "indicative_payout_explainer": "At the ECB rate {rate} of {date}. Indicative: the payout converts at the rates of its own date.",
    "indicative_payout_explainer_without_rate": "Indicative: the payout converts at the rates of its own date.",
    "submit_invoice": "Submit Invoice",
    "money_pending": "Pending Money",
    "sales_revenue": "Sales Revenue",
    "sales_vat": "Sales VAT",
    "state_income_tax": "State Income Tax",
    "service_fees_vat": "Service Fees (incl. VAT)",
    "detailed_overview": "Detailed Overview",
    "view_details": "View Details",
    "invoice_items": "Invoice Items",
    "item": "Item",
    "quantity": "Quantity",
    "unit_price": "Unit Price",
    "total_excl_vat": "Total (excl. VAT)",
    "vat": "VAT",
    "offset_service_fees": "Offset Service Fees",
    "invoice_details": "Invoice Details",
    "invoice_number": "Invoice Number",
    "invoice_number_placeholder": "Invoice Number",
    "vat_number": "VAT Number",
    "vat_number_placeholder": "VAT Number",
    "bank_account_iban": "Bank Account (IBAN)",
    "bank_account_placeholder": "IBAN",
    "contact_block_on_invoice": "Contact Information on Invoice",
    "contact_block_placeholder": "Company Name, \nAddress, \nRegistry Code",
    "reference": "Reference(optional)",
    "reference_placeholder": "Reference number",
    "monthly_rollup_label": "Skip sale notifications — get one monthly email with your fee invoice on the 1st",
    "month_split_label": "Date last month's sales on {date}",
    "month_split_tooltip": "Your sales from {month} go on a separate payout invoice dated {date}, the same month as your {month} fee invoice. Sales from {current_month} go on a second invoice dated today.",
    "month_split_tooltip_pending": "Your sales from {month} go on a payout invoice dated {date}, the same month as your {month} fee invoice. Sales from {current_month} stay pending for a later payout.",
    "month_split_previous_heading": "{month} sales — invoice dated {date}",
    "month_split_current_heading": "{current_month} sales — invoice dated today",
    "month_split_pending_heading": "{current_month} sales — stay pending for a later payout",
    "month_split_current_number": "Invoice number for {current_month} sales",
    "month_split_number_must_differ": "Must differ from the invoice number above"
  },
  "certificateHistory": {
    "overview": "Certificate Overview",
    "productionPeriod": "@:common.production_period",
    "certificateCount": "Certificate Count",
    "expired": "Expired",
    "sold": "Sold",
    "awaitingSale": "Awaiting Sale"
  },
  "chooseCompany": {
    "select_company": "Select the company to authorize",
    "choose_company": "Choose Company",
    "create_new_company": "Create New Company"
  },
  "invoiceItem": {
    "quantity": "Quantity",
    "unit_price": "Unit Price",
    "total_excl_vat": "Total (excl. VAT)",
    "vat": "VAT"
  },
  "tradingCenter": {
    "tradingStrategy": "Trading Strategy",
    "title": "Production Strategy",
    "tabs": {
      "overview": "Overview",
      "strategyCustomisation": "Strategy Customization",
      "issuance_reporting": {
        "title": "Issuance Report"
      }
    },
    "customization": {
      "forwardSales": "Forward Sales",
      "spotSales": "Spot Sales",
      "ppaReserve": "PPA Reserve",
      "holdPortfolio": "Self-management"
    },
    "overview": {
      "projectedProduction": {
        "title": "Projected Production",
        "noData": "Your estimated yearly production will appear here after we have retrieved information about your devices from the registry."
      },
      "spot": {
        "title": "Spot Sales",
        "visualization": {
          "minimumPrice": {
            "title": "Attempt to Sell Above {price}€/MWh",
            "description": "Production included in tenders if expected price is user set min. price",
            "firstMonths": "First {duration} months"
          },
          "highestBid": {
            "title": "Sell at Highest Bid",
            "description": "Production is automatically sold to the highest bidder",
            "lastMonths": "Last {duration} months"
          }
        }
      }
    }
  },
  "market_insights": {
    "title": "Market Insights",
    "description": "Market intelligence and analytics for renewable energy",
    "enter_fullscreen": "View full screen",
    "exit_fullscreen": "Exit full screen",
    "sections": {
      "reports": "Market Reports",
      "charts": "Market Data & Charts"
    },
    "forward_outlook": {
      "title": "Soldera Forward Outlook",
      "description": "Monthly analysis on GO market trends and major news impacting the market"
    },
    "consulting_services": {
      "title": "Scope 2 Compliance Support",
      "description": "Soldera provides compliance on demand. Please contact us for more information.",
      "button_text": "Contact us"
    },
    "norway_reservoir": {
      "title": "Norway Reservoir Levels",
      "description": "Weekly reservoir levels with historical comparison and predictions",
      "zone_label": "Trading Zone",
      "y_axis_label": "% of Capacity",
      "loading": "Loading reservoir data...",
      "error": "Failed to load reservoir data",
      "no_data": "No data available for selected zone",
      "locked_zones_hint": "Unlock all reservoir zones — contact us to enable detailed regional insights",
      "info_text": "Norway is the primary exporter of GOs to other AIB member countries, driven by its substantial hydropower production. Their domestic policies don't incentivize local GO usage and create a significant export surplus. As a result, shifts in Norway's hydropower capacity or domestic consumption patterns have outsized impacts on the broader European GO market.\n\nThis data is updated weekly. Actual reservoir levels usually are confirmed significantly later, so we provide our estimates to better predict market dynamics.",
      "zones": {
        "norway_total": "Norway Total"
      },
      "legend": {
        "historical_max": "Historical Max",
        "historical_median": "Historical Median",
        "historical_min": "Historical Min",
        "last_year": "Last Year",
        "this_year": "This Year",
        "predicted": "Predicted",
        "forecast_from": "Forecast from {date}"
      }
    },
    "cumulative_re": {
      "title": "Cumulative Renewable Energy Production",
      "description": "Year-over-year comparison of renewable energy generation",
      "country_label": "Country",
      "eu_aggregate": "European Union (Aggregate)",
      "y_axis_label": "GWh",
      "loading": "Loading chart data...",
      "error": "Failed to load chart data",
      "info_text": "Annual renewable energy production is a strong indicator of where prices are heading - if we see significant growth in renewable energy production it usually results in prices of GOs going down as GO supply increases.\n\nThis data is updated weekly and does not include countries that aren't AIB members or are not part of mainland Europe."
    }
  },
  "ecolabels": {
    "documents_modal": {
      "title": "Documents — {name}",
      "open_hint": "View and download the original uploaded documents",
      "empty": "No documents visible to you for this device.",
      "download": "Download"
    },
    "fuzzy_search_placeholder": "Search devices by name, registration ID or address…",
    "renewable_types": {
      "solar": "Solar",
      "wind": "Wind",
      "hydro": "Hydro",
      "geothermal": "Geothermal",
      "bioenergy": "Bioenergy",
      "marine": "Marine",
      "other": "Other"
    },
    "statuses": {
      "pending_review": "Pending review",
      "pre_approved": "Pre-approved",
      "rejected": "Rejected"
    },
    "upload": {
      "add_manually": "Add device manually",
      "pending_hint": "Large files can take a few minutes — you can keep editing the rows meanwhile.",
      "wait_for_ai": "Wait for the assistant to finish before submitting",
      "duplicate_of_row_named": "Row {row} (“{name}”) in this upload",
      "open_in_catalog": "Open in catalog",
      "back_to_catalog": "Back to device catalog",
      "title": "Submit devices for pre-approval",
      "subtitle": "Upload a device list (spreadsheet, registry export, email or PDF) and review the extracted rows before submitting.",
      "seller_company": "Seller company",
      "no_seller_company": "No authorized seller company is linked to your account. Contact EKOenergy to get access.",
      "chat_title": "Upload your device list",
      "review_title": "Review extracted devices",
      "review_counts": "{total} rows, {selected} selected",
      "select_all": "Select all",
      "select_all_without_duplicates": "Select all without duplicates",
      "check_and_next": "Check & next",
      "irec_relaxed_hint": "Identified as an I-REC device by its Evident link / device code. Technology and location are optional here — reviewers verify them on Evident.",
      "irec_lookup_loading": "Looking the device up in the Evident device register…",
      "irec_lookup_found": "Device details were filled in from the Evident device register — check them and edit if needed. Technology and location are optional here; reviewers verify them on Evident.",
      "irec_lookup_not_found": "This code was not found in the Evident device register. Please fill in the device name and country yourself; technology and location stay optional.",
      "irec_lookup_unavailable": "The Evident device register could not be reached. Please fill in the device name and country yourself; technology and location stay optional.",
      "deselect_all": "Deselect all",
      "empty_state": "Devices extracted from your upload will appear here for review.",
      "flags": "Checks",
      "flag_ok": "OK",
      "flag_incomplete": "Missing fields",
      "all_fields": "All fields",
      "flag_duplicate": "{count} duplicate?",
      "flag_duplicate_hint": "Possible duplicates found — click to see the matches",
      "flag_reg_id": "ID: {quality}",
      "flag_reg_id_hint": "The registration ID could not be validated against known registry formats",
      "blocked_row_hint": "Fill in the missing required fields to enable this row",
      "blocked_rows_note": "{count} row(s) blocked by missing required fields",
      "field_address_or_coordinates": "Address or coordinates",
      "missing_fields": "Missing: {fields}",
      "duplicate_details": "Possible duplicates",
      "duplicate_what_to_do": "If these are genuinely different plants, just submit — reviewers see the same flags. If a row really is a duplicate, delete one of them (✕).",
      "show_row": "Show row",
      "duplicate_of_catalog": "Existing device “{name}” ({status})",
      "duplicate_of_row": "Row {row} in this upload",
      "submit_selected": "Submit {count} device(s) for review",
      "submitted_title": "{count} device(s) submitted for review",
      "submitted_flagged": "{count} potential duplicate pair(s) were flagged for the reviewers.",
      "view_submissions": "View submissions",
      "upload_more": "Upload more"
    },
    "submissions": {
      "collapse_all": "Collapse all",
      "title": "Submissions",
      "subtitle_admin": "Review submitted devices: check flags, then approve or reject.",
      "subtitle_seller": "Your submitted device batches and their review status.",
      "submit_devices": "Submit devices",
      "empty": "No device submissions yet.",
      "submitted_on": "Submitted",
      "seller": "Seller",
      "devices": "Devices",
      "status": "Status",
      "pending_badge": "{count} pending",
      "approved_badge": "{count} approved",
      "rejected_badge": "{count} rejected",
      "flagged_badge": "{count} flagged",
      "duplicates_column": "Duplicates",
      "details": "Details",
      "duplicates_badge": "{count} possible",
      "duplicates_hint": "Possible duplicates — click to review and resolve them",
      "actions": "Actions",
      "approve": "Approve",
      "reject": "Reject",
      "rejection_reason_placeholder": "Rejection reason (visible to the seller)…",
      "no_duplicates": "No unresolved duplicate candidates for this device.",
      "approved_toast": "{name} approved",
      "override_confirm": "This device has unresolved high-confidence duplicates. Approve anyway?",
      "approve_anyway": "Approve anyway",
      "filter_pending": "Needs review",
      "filter_all": "All",
      "no_pending": "No submissions waiting for review.",
      "show_all": "Show all submissions",
      "merged_badge": "{count} merged",
      "internal_notes": "Internal notes",
      "internal_notes_hint": "Visible to the EKOenergy team only — sellers never see these.",
      "note_placeholder": "Add a note for the team…",
      "add_note": "Add note",
      "save_changes": "Save changes",
      "device_saved": "Device updated",
      "invalid_number_fields": "Latitude, longitude or capacity is not a valid number. Nothing was saved."
    },
    "duplicates": {
      "title": "Duplicates",
      "subtitle": "{pending} candidate pair(s) waiting for review. Decisions are permanent.",
      "filter_pending": "Pending",
      "scan": "Scan for duplicates",
      "scan_started": "Duplicate scan started — new pairs will appear shortly.",
      "empty": "No duplicate candidates in this view. Nice and clean!",
      "load_more": "Show more ({shown} of {total})",
      "device_a": "Device A",
      "device_b": "Device B",
      "this_submission": "This submission",
      "existing_device": "Existing catalog device",
      "newer_entry": "Newer entry",
      "older_entry": "Older entry",
      "coordinates": "Coordinates",
      "not_duplicate": "Not a duplicate",
      "keep_a": "Merge, keep A",
      "keep_b": "Merge, keep B",
      "merge_confirm": "Merge this pair and keep “{name}”? The other record is archived and its documents move over.",
      "confirm_merge": "Confirm merge",
      "resolved_toast": "Pair resolved",
      "ask_ai": "Ask AI",
      "ai": {
        "duplicate": "AI: duplicate",
        "not_duplicate": "AI: not a duplicate",
        "unsure": "AI: unsure"
      },
      "statuses": {
        "not_duplicate": "Not a duplicate",
        "merged": "Merged"
      },
      "reasons": {
        "registration_id_exact": "Same registration ID",
        "registration_id_overlap": "Registration IDs overlap",
        "registration_id_suspect_overlap": "IDs overlap (low trust)",
        "name_exact": "Same name",
        "name_exact_distinct_ids": "Same name, different registry IDs",
        "name_fuzzy": "Similar name {detail}",
        "coords_within_250m": "Within 250 m"
      }
    },
    "title": "Ecolabels",
    "add_device": "Add Device",
    "edit_device": "Edit Device",
    "ai_upload": "AI Upload",
    "devices_selected": "devices selected",
    "bulk_delete": "Delete Selected",
    "export_csv": "Export CSV",
    "no_access_title": "No access to the EKOenergy registry",
    "no_access_contact": "Contact {0} for access.",
    "no_devices": "No ecolabel devices found. Add your first device to get started.",
    "showing_count": "Showing {filtered} of {total} devices",
    "total_count": "{total} devices",
    "devices_heading": "Ecolabel Devices",
    "device_saved": "Device saved successfully",
    "device_deleted": "Device deleted successfully",
    "devices_created": "Devices created successfully",
    "confirm_delete": "Are you sure you want to delete {name}?",
    "confirm_bulk_delete": "Are you sure you want to delete {count} devices?",
    "bulk_deleted": "{count} devices deleted successfully",
    "columns_selected": "{count} columns",
    "select_columns": "Columns",
    "add_devices": "Add Devices",
    "add_devices_description": "Upload a document for AI-powered autofill or manually add devices below.",
    "save_devices": "Save All Devices",
    "add_row": "Add Row",
    "no_rows": "No devices added yet. Upload a document or add rows manually.",
    "devices_saved": "{count} devices saved successfully",
    "filters": {
      "standard": "Standard",
      "status": "Status",
      "country": "Country",
      "search": "Search",
      "search_placeholder": "Search by name...",
      "capacity_placeholder": "e.g. 50",
      "cod_placeholder": "e.g. 2020"
    },
    "table": {
      "name": "@:common.name",
      "plant_ecolabel_id": "Registration ID",
      "standard": "Standard",
      "status": "Status",
      "country": "Country",
      "address": "@:common.address",
      "type": "Type",
      "renewable_type": "Technology",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "capacity": "Capacity",
      "cod": "COD",
      "date_reviewed": "Date Reviewed",
      "valid_from": "Approved From",
      "valid_through": "Approval valid until",
      "registration_authority": "Registry",
      "technology_code": "Tech Code",
      "public_notes": "Notes",
      "relevant_link": "Link",
      "link": "Link",
      "documents": "@:common.documents",
      "actions": "@:common.actions.title"
    },
    "form": {
      "status": "Status",
      "name": "Device Name",
      "plant_id": "Plant Ecolabel ID",
      "country": "Country Code",
      "address": "@:common.address",
      "latitude": "@:ecolabels.table.latitude",
      "longitude": "@:ecolabels.table.longitude",
      "renewable_type": "Renewable Type",
      "marine": "Marine",
      "nuclear": "Nuclear",
      "technology_code": "Technology Code",
      "technology_code_placeholder": "e.g., T010000",
      "registration_authority": "Registration Authority",
      "relevant_link": "Relevant Link",
      "capacity": "Capacity",
      "capacity_units": "Units",
      "cod": "Commercial Operation Date",
      "public_notes": "Public Notes",
      "rejection_reason": "Rejection Reason",
      "location_hint": "Either an address or coordinates are required.",
      "errors": {
        "name_required": "Name is required.",
        "country_required": "Country is required.",
        "renewable_type_required": "Renewable type is required.",
        "latitude_range": "Latitude must be a number between -90 and 90.",
        "longitude_range": "Longitude must be a number between -180 and 180.",
        "capacity_invalid": "Capacity must be a number.",
        "location_required": "Provide either an address or coordinates (latitude and longitude).",
        "registration_authority_required": "Registration authority is required when a registration ID is set.",
        "rejection_reason_required": "A rejection reason is required when the status is Rejected."
      },
      "registry_device_id": "Registry Device ID",
      "date_reviewed": "Date Reviewed",
      "valid_from": "Approved From",
      "valid_through": "Approval valid until"
    },
    "ai_autofill": "AI Autofill from Document",
    "autofill_btn": "Autofill",
    "autofill_confidence": "Confidence: {value}%",
    "labels": {
      "tab": "Labels",
      "heading": "Labels",
      "new_label": "New label",
      "empty": "No labels yet.",
      "draft_number": "Draft",
      "columns": {
        "number": "Number",
        "name": "Name",
        "company": "@:common.company",
        "period": "Period",
        "total": "Total MWh",
        "countries": "Countries",
        "issued": "Issued",
        "status": "Status"
      },
      "entities_suffix": "{count} entities",
      "statuses": {
        "draft": "Draft",
        "issued": "Issued",
        "voided": "Voided"
      },
      "device_statuses": {
        "pending_review": "Not approved yet",
        "rejected": "Rejected"
      },
      "workbench": {
        "create_title": "New label",
        "title": "Label",
        "seller_company": "Seller company",
        "no_sellers": "No authorized seller company yet.",
        "no_own_sellers": "None of your companies is an EKOenergy authorized seller. Contact EKOenergy to create labels.",
        "sources": "Cancellation statements",
        "no_sources": "This label has no cancellation statements."
      },
      "source": {
        "download": "Download the document",
        "seller": "Seller: {company}",
        "remove": "Remove",
        "deleted_device": "Deleted device",
        "confirm_remove": "Remove {file} from this label? The statement is kept, without a label.",
        "confirm_remove_last": "Remove {file}? It is this draft's last document, so the draft is deleted as well.",
        "removed": "Document removed from the label",
        "beneficiary_name": "Beneficiary name",
        "beneficiary_country": "Beneficiary country",
        "registry_country": "Registry country/region",
        "registry_code": "Registry code",
        "total_mwh": "Total MWh",
        "total_invalid": "Enter a whole number of MWh.",
        "period_start": "Period start",
        "period_end": "Period end",
        "period": "Period",
        "device_count": "No devices | {count} device | {count} devices",
        "needs_attention": "Needs attention",
        "expand": "Show details",
        "collapse": "Hide details",
        "devices": "Devices",
        "detect_again": "Detect again",
        "add_device": "Add device",
        "search_devices": "Search the catalog by device name",
        "no_devices_found": "No matching devices found.",
        "mwh_attributed": "MWh attributed to this device",
        "remove_device": "Remove device",
        "candidates": "Suggested devices from the catalog",
        "no_candidates": "No catalog device matches what the document names. Detect again, or add a device.",
        "score": "{score}% match",
        "link": "Link"
      },
      "reasons": {
        "registration_id_exact": "Same registration ID",
        "registration_id_overlap": "Registration IDs overlap",
        "registration_id_suspect_overlap": "IDs overlap (low trust)",
        "name_exact": "Same name",
        "name_exact_distinct_ids": "Same name, different registry IDs",
        "name_fuzzy": "Similar name ({similarity}%)",
        "name_substring": "Name contains the device named on the document",
        "coords_within_250m": "Within 250 m"
      },
      "actions": {
        "open": "Open",
        "preview": "Preview PDF",
        "issue": "Issue label",
        "download": "Download PDF",
        "delete": "Delete draft",
        "void": "Void label",
        "reopen": "Reopen as draft"
      },
      "confirm_issue": "Issue this label? It receives the next label number and can no longer be edited.",
      "confirm_delete": "Delete this draft? Its cancellation statements are kept, without a label.",
      "confirm_void": "Void label {number}? Its number is not reused and its PDF is marked VOID. The label can then be reopened as a new draft with all its data.",
      "confirm_reopen": "Reopen label {number} as a draft? A new draft is created with its name, period and cancellation statements; the voided label keeps its number and its VOID PDF.",
      "created": "Draft label created",
      "issued": "Label {number} issued",
      "deleted": "Draft deleted",
      "voided": "Label {number} voided",
      "reopened": "Label {number} reopened as a draft",
      "reopened_as_draft": "Reopened as draft",
      "detail": {
        "submitted_by": "Submitted by",
        "name": "Name on the label",
        "name_hint": "Line breaks are kept on the label.",
        "name_required_hint": "The statements name several beneficiaries: enter the name printed on the label. Line breaks are kept.",
        "derived": "Derived",
        "edited": "Edited",
        "period": "Period",
        "full_year": "Full year",
        "date_range": "Date range",
        "year": "Year",
        "period_start": "Period start",
        "period_end": "Period end",
        "period_outside": "A statement's period falls outside the label period.",
        "rows": "Annex 1",
        "total": "Total",
        "problems": "Resolve these before issuing",
        "source_needs_attention": "{file} needs attention.",
        "year_invalid": "Enter a four-digit year, or leave it empty.",
        "period_incomplete": "Enter both dates, or leave both empty.",
        "period_reversed": "The start date cannot be after the end date."
      },
      "rows": {
        "country": "Place of consumption",
        "volume": "Volume (MWh)",
        "type": "Type",
        "entity": "Entity"
      },
      "problems": {
        "statement_beneficiary_name_missing": "The beneficiary name is missing.",
        "statement_beneficiary_country_missing": "The beneficiary country is missing.",
        "statement_total_missing": "The total MWh is missing.",
        "statement_no_devices": "No devices are linked.",
        "device_deleted": "Linked device {device} no longer exists.",
        "device_not_pre_approved": "Device {device} is not pre-approved.",
        "device_pending_review": "Device {device} is not approved yet. Approve it on the Submissions tab; this draft updates when reopened.",
        "device_rejected": "Device {device} was rejected. Link another device.",
        "device_type_missing": "Device {device} has no renewable type.",
        "device_type_unsupported": "Device {device} has the renewable type Other, which a label cannot name.",
        "attribution_required": "Several devices are linked: enter each device's MWh so that they add up to {expected} MWh (now {attributed} MWh).",
        "name_missing": "Enter the name shown on the label.",
        "period_invalid": "Set the label period; it cannot start after it ends."
      }
    },
    "ekoenergy": {
      "title": "EKOenergy ecolabel"
    }
  },
  "charts": {
    "xAxisLabel": "X-Axis",
    "stackByLabel": "Stack By",
    "fields": {
      "portfolio_type": "Portfolio Type",
      "production_month": "Production Month",
      "status": "Status",
      "technology_type": "Technology",
      "company_name": "Company Name",
      "portfolio_name": "Portfolio Name",
      "production_device_name": "Production Device",
      "production_support": "Production Support",
      "ecolabel_tags": "Ecolabel",
      "transfer_deadline": "Transfer Deadline",
      "count": "Count",
      "certificate_id": "Certificate ID",
      "registration_authority": "Registration Authority",
      "registry_region": "Current registry",
      "issuing_region": "Issuing registry",
      "cod_age": "COD Age",
      "limit_price": "Min Price",
      "sale_price": "Sale Price",
      "account_emails": "Accounts",
      "registry_id": "Registry ID",
      "bundle_start": "Bundle Start",
      "bundle_end": "Bundle End"
    },
    "values": {
      "production_support": {
        "true": "Supported",
        "false": "Not Supported",
        "null": "Unknown"
      },
      "portfolio_type": {
        "FORWARD": "Forward Sales",
        "SPOT_MARKET_PRICE": "Spot Sales",
        "SPOT_MIN_PRICE": "Spot Sales with Min Price",
        "HOLD": "Self-managed",
        "UNALLOCATED": "Waiting For Action",
        "VIRTUAL": "Hosted Accounts",
        "PPA": "PPA Reserve",
        "OWN_USE": "Own Use"
      },
      "certificate_status": {
        "ONGOING_SALE": "Ongoing Sale",
        "SOLD": "Sold",
        "EXPIRED": "Expired",
        "NON_TRANSFERRABLE": "Non-transferrable",
        "RESERVED": "Reserved",
        "WAITING_FOR_SALE": "Waiting For Sale",
        "AVAILABLE": "Available",
        "CANCELLED": "Cancelled",
        "PENDING": "@:common.pending",
        "TRANSFERRED": "Transferred",
        "REVOKED": "Revoked",
        "OWN_USE": "Own Use"
      }
    },
    "noDataMessage": "Nothing to display. Please adjust your filter selections.",
    "panel": {
      "title": "Chart",
      "region_label": "Chart of the certificates in the table",
      "mwh": "{mwh} MWh",
      "summary_rows": "in no rows · {available} MWh available | in {count} row · {available} MWh available | in {count} rows · {available} MWh available",
      "hide": "Hide chart",
      "show": "Show chart",
      "break_down_by": "Break down by",
      "segment_label": "Filter the table to {field} {value}, {mwh} MWh",
      "segment_inline": "{label} · {mwh} MWh",
      "segment_hint": "Click a segment to filter the table to it"
    }
  },
  "inventory": {
    "actions": {
      "title": "Inventory Management",
      "send": {
        "success": "Send operation completed successfully",
        "prompt": "Where would you like to send these Guarantees of Origin? Please specify country, volumes and receiver registry number.",
        "simulated_response": "Got it! Preparing to send your Guarantees of Origin."
      },
      "receive": {
        "success": "Receive operation completed successfully",
        "prompt": "From whom are you expecting to receive Guarantees of Origin? Please specify country, volumes and sender registry number.",
        "simulated_response": "Understood! We'll notify you upon arrival."
      },
      "buy": {
        "success": "Buy operation completed successfully",
        "prompt": "What Guarantees of Origin are you looking to buy today? Please specify country, volumes and receiver registry number.",
        "simulated_response": "Great! Searching for available Guarantees of Origin to buy. Here's some offers: 500 MWh from Estonia, Wind power, Production date: Jan 2024, Price: €2.50/MWh; 1,000 MWh from Latvia, Solar power, Production date: Feb 2024, Price: €3.00/MWh; 750 MWh from Lithuania, Hydro power, Production date: Mar 2024, Price: €2.75/MWh"
      },
      "sell": {
        "success": "Sell operation completed successfully",
        "prompt": "Which Guarantees of Origin would you like to put up for sale? Please specify country, volumes.",
        "simulated_response": "Perfect! Listing your Guarantees of Origin for sale. We'll notify you when a buyer is found."
      }
    }
  },
  "errors": {
    "genericNetworkError": "Network error. Please try again.",
    "missingCompanyId": "Error: Company context is missing.",
    "unsupportedFileType": "Unsupported file type. Please upload a valid file.",
    "fileTooLarge": "File is too large. Maximum size is 25MB."
  },
  "go_cancel": {
    "beneficiary_suggestions": {
      "placeholder": "Select or enter a beneficiary"
    },
    "statements_title": "Cancellation Statements",
    "add_statement_button": "Add Cancellation Statement",
    "no_statements_yet": "No cancellation statements added yet. Click 'Add Cancellation Statement' to begin.",
    "more_statements": "more statements",
    "statement_number": "Statement #{number}",
    "remove_statement_button": "Remove",
    "remove_statement_row_aria": "Remove cancel statement row {index}",
    "statement_form_placeholder": "Full cancellation statement form will be here.",
    "confirm_order_button": "Review Cancellation Order",
    "portfolio_items_title": "Select Portfolio Items for Cancellation",
    "portfolio_table_placeholder": "PortfolioItemsTable will be displayed here to select certificates.",
    "upload_description": "Upload a document to automatically extract cancellation statements and beneficiary information",
    "analysis_success_with_statements": "Extracted {count} cancellation statements from the document.",
    "analysis_success_no_statements": "No cancellation statements were found in the document.",
    "analysis_complete_title": "Document Analysis Complete",
    "analysis_shared_fields_inconsistent_warning": "Shared fields extracted from statements are inconsistent. Please confirm beneficiary type, period, and cancellation purpose template manually.",
    "shared_defaults_title": "Shared Settings for All Statements",
    "shared_defaults_incomplete": "Complete shared settings before reviewing the cancellation order.",
    "table_validation_hint": "Some rows are incomplete or invalid. Fix highlighted fields to continue.",
    "max_statements_reached": "Maximum of {max} cancellation statements reached. Split into multiple orders if you need more.",
    "analysis_truncated_warning": "The document contained {total} statements but only the first {max} were loaded. Submit them as a separate order, then re-upload for the rest.",
    "form": {
      "prior_year_cutoff_specific": "Cancellations for {year} are no longer allowed — the deadline was {cutoffDate}",
      "beneficiary_details_title": "Beneficiary Details",
      "beneficiary_name": {
        "label": "Beneficiary",
        "placeholder": "Enter company or personal name"
      },
      "beneficiary_type": {
        "label": "Beneficiary Type",
        "CONSUMER": "Consumer",
        "ELECTRICITY_SELLER": "Electricity Seller",
        "CONVERSION_PLANT_OPERATOR": "Conversion Plant Operator"
      },
      "registry_code": {
        "label": "Company ID",
        "short_label": "Company ID",
        "placeholder": "Enter Company Registry Code or Personal ID"
      },
      "address": {
        "label": "Address",
        "placeholder": "Enter full address",
        "required_help": "Address is required for this country"
      },
      "registry_country_region": {
        "label": "Registry Country/Region",
        "placeholder": "Select registry country or region",
        "mismatch_warning": "Selected registry differs from certificate location"
      },
      "cancellation_details_title": "Cancellation Details",
      "mwh_cancelled": {
        "label": "Consumption (MWh)",
        "short_label": "MWh Cancelled",
        "placeholder": "0"
      },
      "period_start": {
        "label": "Consumption Period Start"
      },
      "period_end": {
        "label": "Consumption Period End",
        "invalid_date_range": "End date must be after start date",
        "cutoff_help": "Cancellations for {year} consumption must be submitted before March 31, {nextYear}"
      },
      "cancellation_purpose": {
        "label": "Cancellation Purpose",
        "DISCLOSURE": "Disclosure",
        "GRID_LOSSES": "Grid Losses",
        "SELF_CONSUMPTION": "Self-consumption",
        "SUPPORT_SCHEME": "Support Scheme",
        "OTHER": "Other"
      },
      "cancellation_purpose_text": {
        "label": "Cancellation Purpose",
        "placeholder": "Enter the purpose of this cancellation",
        "help": "Briefly describe why these certificates are being cancelled"
      },
      "global_operation_notes": {
        "label": "Overall Notes for Cancellation Order (Optional)",
        "placeholder": "Enter any overall notes for the entire cancellation order..."
      },
      "keep_private": {
        "label": "Keep cancellation statement private",
        "hint": "The registry will not generate a publicly accessible link for this cancellation statement PDF.",
        "ppa_hint": "Applies only in registries on the Grexel platform (LV, LT, DK, HR, HU, BE-FED, SE, FR); ignored elsewhere."
      },
      "tge_legal_form": {
        "label": "Legal form",
        "placeholder": "Choose the beneficiary's legal form",
        "detected_hint": "From the beneficiary name",
        "not_detected_hint": "Not in the beneficiary name. TGE requires it.",
        "options": {
          "limited_company": "Limited company (sp. z o.o., S.A.)",
          "partnership": "Partnership (sp. j., sp. p., sp. k., S.K.A.)",
          "private_partnership": "Civil partnership (s.c.)",
          "sole_proprietorship": "Sole proprietorship",
          "other": "Other"
        }
      },
      "tge_vat_number": {
        "label": "VAT number (NIP)",
        "short_label": "VAT",
        "placeholder": "PL1234567890",
        "hint": "Optional"
      }
    },
    "no_portfolio_items_available": "No portfolio items currently available for cancellation.",
    "tooltip_beneficiary_name": "The legal entity or person that will be named as the beneficiary on the cancellation statement.",
    "tooltip_registry_country_region": "The registry where the cancellation will be performed.",
    "tooltip_registry_code": "The company's business registration number, or an individual's personal ID — not the VAT number. Appears on the cancellation statement.",
    "tooltip_address": "The registered or facility address of the beneficiary. Required for some registries.",
    "tooltip_mwh_cancelled": "The amount of certificates to cancel in megawatt-hours (MWh). 1 MWh = 1 certificate.",
    "auto_select_certificates_checkbox": "Auto-select Certificates",
    "order_submitted_successfully": "Cancellation order submitted successfully!",
    "order_submission_failed": "Failed to submit cancellation order. Please try again.",
    "buy_missing_request_sent": "Request to acquire missing GOs has been sent. We will contact you shortly.",
    "buy_missing_request_failed": "Failed to send request for missing GOs. Please try again or contact support.",
    "insufficient_inventory_warning": "Warning: Insufficient GOs in inventory to cover the total MWh specified in statements. You have {availableMwh} MWh available but need {neededMwh} MWh.",
    "buy_missing_gos_button": "Request Missing GOs",
    "autoselect_failed": "Auto-selection of certificates failed. Please select manually or try again.",
    "review_modal_statement_title": "Cancelling for: {beneficiaryName} in",
    "region_mismatch_warning": {
      "title": "Registry Mismatch",
      "message": "Some selected certificates currently reside in a different registry than the selected target registry for cancellation. We'll transfer these certificates to the selected registry before processing the cancellation."
    },
    "any_aib_option": "Any AIB",
    "any_aib_address_hint": "Add {'{'}address{'}'} to the cancellation purpose as a placeholder when using Any AIB. The beneficiary location will be reported as \"Europe\" on the statement.",
    "address_placeholder_missing_warning": "The cancellation purpose uses the {'{'}address{'}'} placeholder, but at least one beneficiary has no address. The {'{'}address{'}'} text will be left unchanged for those rows.",
    "beneficiary_type_conflict_switch": "Every statement in this cancellation submits the beneficiary type {sharedType}, but {names} previously used {rememberedType}. Switch the shared beneficiary type to {rememberedType}, or continue if the earlier type is out of date.",
    "beneficiary_type_conflict_mixed": "Every statement in this cancellation submits the beneficiary type {sharedType}, but these beneficiaries previously used a different one: {details}. Continue if the earlier types are out of date.",
    "accelerator_title": "Start from a document",
    "summary_order_title": "Cancellation order",
    "summary_mwh_to_cancel": "MWh to cancel",
    "summary_statements": "Statements",
    "summary_consumption_period": "Consumption period",
    "summary_certificates_selected": "Certificates selected",
    "summary_mwh_value": "{mwh} MWh",
    "summary_ready": "Ready to confirm",
    "summary_status_incomplete": "Complete the cancellation details",
    "summary_status_select": "Select certificates to cancel",
    "summary_status_match": "Select certificates to match {mwh} MWh",
    "summary_status_insufficient": "Not enough matching inventory",
    "no_data_short": "—",
    "summary_build_title": "Build your order",
    "summary_step_beneficiary": "Add a beneficiary & consumption",
    "summary_step_certificates": "Select certificates to cancel",
    "summary_step_review": "Review & confirm the order",
    "private_pill": "Private",
    "statement_options_button_aria": "Statement {index} options",
    "statement_options_button_private_aria": "Statement {index} options — kept private",
    "statement_private_tooltip": "Cancellation statement kept private",
    "carried_selection_summary": "No rows came from your Overview selection. | {count} row ({mwh} MWh) came from your Overview selection. | {count} rows ({mwh} MWh) came from your Overview selection.",
    "carried_selection_summary_partial": "No rows came from your Overview selection. | {count} row ({mwh} MWh, {partial}) came from your Overview selection. | {count} rows ({mwh} MWh, {partial}) came from your Overview selection.",
    "carried_selection_partial": "none partial | {count} partial | {count} partial",
    "carried_selection_paused": "Auto-select is paused so it doesn't replace them.",
    "carried_selection_use_amount": "Use {mwh} MWh as the amount",
    "carried_selection_clear": "Clear and auto-select",
    "table_hint": "Only certificates available to cancel are listed. Checked rows are cancelled in full; click an amount to cancel only part of a row.",
    "filter_shortfall": "Only {available} of {needed} MWh match your filters. Remove a filter to see more certificates.",
    "filter_shortfall_unavailable": "No certificates match your filters, {needed} MWh needed. Remove the filter marked in red to see your certificates.",
    "summary_status_filter_shortfall": "Not enough certificates match your filters"
  },
  "cancellation_rules": {
    "any_aib_notice": {
      "title": "Any AIB cancels in Norway",
      "message": "These GOs are cancelled in the Norwegian registry, so the cancellation statement will list Norway as the country of consumption while the \"purpose\" field may expand on the purpose and intent of the cancellation. While this is a common workaround for countries where it would otherwise not be possible to cancel for, please verify if this route is acceptable before continuing."
    },
    "selection_too_large": "More than {max} rows are selected, so the cancellation rules are not checked and no warnings are shown. Select fewer rows to see them.",
    "concerns_statements": "Concerns: {statements}",
    "more_statements": "and {count} more",
    "warnings": {
      "scheme_mismatch": "{certificate_schemes} certificates can't be moved into {target_region}, a {target_scheme} registry, so only {target_scheme} certificates can be cancelled there.",
      "scheme_mismatch_any_aib": "Any AIB cancels in an AIB registry, so {certificate_schemes} certificates can't be cancelled with it.",
      "unknown_scheme": "{target_region} may not accept {mwh} MWh of the selected GOs: they sit in a registry in {certificate_countries}, whose certificate scheme is unknown, so it isn't known whether they can be moved there.",
      "unknown_scheme_any_aib": "Any AIB cancels in {target_region}, which may not accept {mwh} MWh of the selected GOs: they sit in a registry in {certificate_countries}, whose certificate scheme is unknown, so it isn't known whether they can be moved there.",
      "origin_restriction_import": "{target_region} may restrict the import of GOs issued in {issuing_countries}, so these GOs may not reach the registry.",
      "origin_restriction_import_any_aib": "Any AIB cancels in {target_region}, which may restrict the import of GOs issued in {issuing_countries}, so these GOs may not reach the registry.",
      "origin_restriction_disclosure": "{target_region} may not accept GOs issued in {issuing_countries} for disclosure. The GOs may still be imported, but a cancellation there may not count as evidence.",
      "origin_restriction_disclosure_any_aib": "Any AIB cancels in {target_region}, which may not accept GOs issued in {issuing_countries} for disclosure. The GOs may still be imported, but a cancellation there may not count as evidence.",
      "supplier_required": "{operator} only lets electricity suppliers cancel, so Soldera arranges the cancellation through the beneficiary's supplier or a local partner.",
      "not_allowed": "Nobody can cancel GOs for use in {target_region}.",
      "expiry_close": "{mwh} MWh of the selected GOs expire within {threshold_days} days, the earliest on {earliest_date}. Pick fresher GOs or place the order sooner.",
      "expiry_close_passed": "{mwh} MWh of the selected GOs expire within {threshold_days} days or have already expired, the earliest on {earliest_date}. Pick fresher GOs.",
      "transfer_deadline_close": "{mwh} MWh of the selected GOs must be transferred to this registry, and their transfer deadline is within {threshold_days} days, the earliest on {earliest_date}. Pick other GOs or place the order sooner.",
      "transfer_deadline_close_passed": "{mwh} MWh of the selected GOs must be transferred to this registry, and their transfer deadline is within {threshold_days} days or has already passed, the earliest on {earliest_date}. Pick other GOs.",
      "monthly_matching": "Cancellations in {target_region} must cover the same calendar month the GOs were produced in.",
      "no_registry_account": "{mwh} MWh of the selected GOs are not linked to a registry account, so they can't be cancelled and the order will be rejected. Deselect them or contact support."
    },
    "warning_details": {
      "period_not_single_month": "The consumption period {period_start} – {period_end} is not a single calendar month.",
      "production_months": "Production months of the affected GOs: {months}."
    }
  },
  "go_send": {
    "insufficient_inventory_warning": "Warning: Insufficient GOs in inventory to cover the total MWh in send request. You have {availableMwh} MWh available but need {neededMwh} MWh.",
    "recipient_hosted_badge": "HOSTED",
    "recipient_hosted_helper": "Delivered to this company's hosted account on Soldera",
    "recipient_hosted_region_note": "Region is resolved per certificate at send time",
    "recipient_search_placeholder": "Search by company name, registry code, or EECS…",
    "recipient_no_results": "No matching companies",
    "hosted_delivery_info": "Delivery details are managed by Soldera and will be resolved automatically per certificate at send time.",
    "mixed_registry_selection_error": "Certificates from different registries cannot be sent in one order. Please send them as separate orders.",
    "unit_price_pln_label": "Unit price (PLN/MWh)",
    "unit_price_pln_help": "Contract unit price in PLN/MWh. The Polish registry (TGE) requires it and records it on the transfer itself.",
    "account_invalid_unknown_registry": "Enter an EECS account number (e.g. 23X1234567) or an Ofgem account number so the registry country can be detected"
  },
  "portfolio_instructions": {
    "description": "Description",
    "ppa_name": "PPA Name",
    "configuration": "Configuration",
    "allocation_mode": "Allocation Mode",
    "allocation_configuration": "Allocation Configuration",
    "delivery_configuration": "Delivery Configuration",
    "allocate_all": "Whole production",
    "allocate_percentage": "Percentage",
    "whole_production_info": "All production from the selected devices will be allocated to this PPA.",
    "allocate_fixed_amount": "Allocate fixed amount",
    "allocate_fixed_amounts": "Fixed amounts",
    "total_mwh_label": "Total MWh",
    "allocate_fixed_amounts_per_year": "Allocate fixed amounts per year",
    "granularity_yearly": "Yearly",
    "granularity_quarterly": "Quarterly",
    "granularity_monthly": "Monthly",
    "granularity": "Granularity",
    "leap_year_badge": "Leap year",
    "current_period_limit": "Allocate fixed amount ({amount} {unit}) for {periodLabel}",
    "apply_to_all_years": "Apply to all years",
    "apply_to_all_years_tooltip": "Copy these values to every other year (partial quarters are skipped)",
    "reset_year": "Reset",
    "partial_quarter_badge": "Partial",
    "partial_period_badge": "Partial",
    "contract_range_required_for_granularity": "Set the PPA start and end dates in Execution Configuration below to configure monthly/quarterly limits.",
    "start_date_required_for_granularity": "Contract start date is required for monthly and quarterly limits.",
    "end_date_must_follow_start": "Contract end date must be on or after the start date.",
    "invalid_limit_durations_for_granularity": "Limit durations do not match the selected granularity. Re-create or convert the limits for the chosen granularity.",
    "partial_period_hint_single": "One period is partial: {firstRange}.",
    "partial_period_hint_multiple": "{count} periods are partial: {firstRange} → {lastRange}.",
    "confirm_granularity_switch_title": "Switch allocation granularity?",
    "confirm_granularity_switch_body": "You have non-zero values. Switching will redistribute them to the new granularity. Continue?",
    "granularity_switch_title": "Redistribute existing values?",
    "granularity_switch_body": "You've entered values at the {from} level. Switching to {to} will redistribute them to match the new granularity.",
    "granularity_switch_from": "From",
    "granularity_switch_to": "To",
    "granularity_buckets": "{count} buckets/year",
    "granularity_switch_note": "Totals per year are preserved.",
    "granularity_switch_confirm": "Redistribute",
    "matrix_year_total": "Year total: {total}",
    "matrix_grand_total": "Grand total: {total} MWh ({count} entries)",
    "year_issues_badge": "{count} issues",
    "percentage_to_allocate": "Percentage to allocate",
    "select_devices": "Select devices",
    "search_devices_placeholder": "Search {count} available devices...",
    "search_more_devices_placeholder": "{selected} selected • Search {available} available devices",
    "all_devices_selected": "All devices selected",
    "devices_blocked_by_other_ppas": "Remaining devices are used by other PPA portfolios",
    "no_devices_available": "No devices available",
    "loading_devices": "Loading devices...",
    "selected_devices": "Selected Devices",
    "selected_devices_summary": "{count} selected",
    "add_devices": "Add devices",
    "allocate_percentage_display": "Allocate {percent}%",
    "devices_count_display": "{count} device(s) selected",
    "from_all": "From all devices",
    "no_instructions_set": "No instructions set.",
    "editing_title": "Editing: {name}",
    "upload_ppa_document": "Upload PPA Document",
    "ppa_document_formats": "PDF, DOC, DOCX files supported",
    "ppa_document_upload_error": "Invalid PPA document format",
    "fixed_amounts_per_year": "Fixed amounts per year",
    "period_limits": "Period Limits",
    "add_period_limit": "Add Period Limit",
    "remove_period_limit": "Remove Period Limit",
    "select_year": "Select Year",
    "mwh_placeholder": "Enter MWh limit",
    "fixed_amount_must_be_gt_zero": "Each fixed allocation must be greater than 0 MWh",
    "update_success": "Portfolio instructions updated successfully.",
    "update_success_title": "Success",
    "remove_device": "Remove device {deviceName}",
    "device_assigned_to_100_percent_ppa": "Device '{deviceId}' is assigned to a 100% PPA and must be exclusive",
    "device_used_in_fixed_limit_ppa": "Device '{deviceId}' is used in a PPA with fixed period limits and cannot be assigned to any other PPA",
    "device_exceeds_100_percent": "Device '{deviceId}' exceeds 100% across PPAs (total: {totalPercentage}%)",
    "device_cannot_mix_with_exclusive_mode": "Device '{deviceId}' cannot be used in {currentMode} because it's already assigned to other PPAs",
    "fixed_amounts_mode": "fixed amounts mode",
    "all_mode": "all production mode"
  },
  "hold_strategy": {
    "customize_strategy_title": "Customize Self-managed Certificates Strategy",
    "about_hold_strategy": "About the Self-managed Certificates Strategy",
    "no_hold_instructions": "No Self-managed Certificates Strategy configured",
    "create_hold_portfolio": "Create Self-managed Certificates Strategy",
    "hold_portfolio": "Self-managed Certificates",
    "percentage_to_hold": "Percentage to send to self-management",
    "scope_all_label": "Global hold (all devices)",
    "scope_all_description": "Applies to all unallocated certificates.",
    "scope_specific_label": "Targeted hold (specific devices)",
    "scope_specific_description": "Applies only to selected devices. Others flow to spot.",
    "targeted_allocation_badge": "{percentage}% from {deviceCount} devices"
  },
  "ppa_strategy": {
    "customize_strategy_title": "Customize PPA Reserve",
    "creating_new_ppa_instructions": "Creating new PPA Reserve",
    "about_ppa_strategy": "About PPA Reserve",
    "no_ppa_instructions": "No PPA Reserve instructions configured",
    "ppa_agreement": "PPA Agreement",
    "projected_total": "Projected Total",
    "delivered": "Delivered",
    "no_documents": "No documents attached",
    "fixed_yearly_allocation": "Fixed yearly allocation",
    "percentage_allocation": "{percentage}% of production",
    "next_delivery": "Next delivery"
  },
  "go_buy": {
    "volume_to_buy": "Volume to Buy",
    "procurement_fee": "Procurement Fee",
    "purchase_summary": "Purchase Summary",
    "price_breakdown_title": "Price Breakdown",
    "price_breakdown_description": "Prices track market third-party indexes to get you the best price on the market. Volumes are sourced from over 3000 powerplants across Europe directly. Aggregated automated sourcing provides best value.",
    "premiums": "Attribute Premiums",
    "upload_description": "Upload a document describing your purchase needs",
    "ask_for_quote_button": "Ask for quote",
    "send_purchase_request_button": "Send Purchase Request",
    "purchase_request_submitted": "Purchase request submitted",
    "purchase_request_submitted_detail": "{volume} MWh request submitted successfully.",
    "agent_quote_prompt": "Submit your purchase request and Soldera will conduct an RFQ — you'll receive an indicative quote, usually within one business day",
    "modes": {
      "re100": "RE100",
      "cheapest": "Cheapest",
      "advanced": "Advanced",
      "re100_help": "RE100: wind + solar, COD ≤ 15 years, optimized price",
      "cheapest_help": "Cheapest: optimized lowest cost, while being compliant",
      "advanced_help": "Advanced: customize all attributes"
    },
    "form": {
      "volume": {
        "label": "Volume to Purchase (MWh)"
      },
      "operation_notes": {
        "label": "Additional Notes (Optional)",
        "placeholder": "Enter any notes for this purchase..."
      }
    },
    "certificate_scheme": "Certificate scheme",
    "source_country": "Production country",
    "any_country": "Any country"
  },
  "bulk_buy": {
    "upload_description": "Upload documents to extract company data and cancellation requirements for multiple facilities",
    "upload_description_new": "Upload your sustainability report and consumption data. AI will auto-fill all the fields for you to check.",
    "quick_info": "Quick Start",
    "upload_hint": "Upload one or more documents to automatically extract company data",
    "manual_add_hint": "Or manually add companies by filling in the empty row at the bottom",
    "purchase_settings": "Purchase Settings",
    "overview": "Overview",
    "purchase_mode": {
      "CHEAPEST": "Cheapest",
      "GHG": "GHG",
      "RE100": "RE100",
      "ADVANCED": "Premium Options",
      "OTHER": "Other"
    },
    "ghg_description": "SBTi, ERI, CDB",
    "re100_description": "Wind + Solar, COD ≤ 15 years",
    "cheapest_description": "Most cost-effective options",
    "premium_description": "Custom sourcing requirements",
    "go_source": "EAC Source",
    "technology": "Technology",
    "ecolabel": "Ecolabel",
    "vintage": "Vintage",
    "support": "Support Status",
    "cod_requirement": "COD Requirement",
    "matching_mode": {
      "yearly": "Yearly vintages",
      "monthly": "Monthly vintages",
      "hourly": "24/7 hourly matching (Premium)"
    },
    "destination_companies": "Beneficiaries",
    "destination_companies_description": "Each row represents a company that will receive the EAC cancellation on their behalf.",
    "companies": "@:common.companies",
    "no_companies": "No beneficiaries added yet. Upload documents or manually add companies to get started.",
    "company_name": "Beneficiary",
    "country": "Beneficiary Country",
    "registry_code": "Company ID",
    "volume": "Consumption (MWh)",
    "match_origin": "Match Origin",
    "price": "Indicative price",
    "tooltip_company_name": "The legal entity that will be named as the beneficiary on the cancellation statement — the party claiming the renewable energy consumption.",
    "tooltip_country": "The country where the beneficiary is located and consuming electricity. This determines where the certificates need to be cancelled.",
    "tooltip_registry_code": "The company's business registration number — not the VAT number. Appears on the cancellation statement.",
    "tooltip_address": "The registered or facility address of the beneficiary. Used for identification on the cancellation statement.",
    "tooltip_volume": "Annual electricity consumption to cover with renewable energy certificates, in megawatt-hours (MWh). 1 MWh = 1 certificate.",
    "tooltip_price": "Indicative price based on current market levels and your selected sourcing options — an indicative bid, not a firm one. Click 'Ask for quote' to calculate.",
    "eac_type": "EAC Type",
    "tooltip_eac_type": "The certificate scheme used in the beneficiary's country. Determined automatically from the country; pick one for countries outside our registries.",
    "pricing_idle": "Not calculated",
    "rfq_notice": "Soldera will conduct an RFQ",
    "global_cancellation_settings": "Global Cancellation Settings",
    "period_start": "Period Start",
    "period_end": "Period End",
    "beneficiary_type": "Beneficiary Type",
    "beneficiary_types": {
      "ELECTRICITY_SELLER": "Electricity Seller",
      "CONSUMER": "Consumer",
      "CONVERSION_PLANT_OPERATOR": "Conversion Plant Operator"
    },
    "summary": "Summary",
    "total_volume": "Total Volume",
    "total_price": "Indicative total price",
    "illiquid_companies": "no companies priced via RFQ | 1 company priced via RFQ | {count} companies priced via RFQ",
    "confirm_order": "Confirm Order",
    "ask_for_quotes": "Ask for quotes",
    "cancellation_details_title": "Cancellation Details",
    "beneficiary_name": "Beneficiary Name",
    "residency": "Residency",
    "company_address": "Address",
    "address": "@:common.address",
    "cancellation_purpose": "Cancellation Purpose",
    "cancellation_purpose_text": "Cancellation Purpose",
    "operation_notes_placeholder_consumer": "Proof of consumption",
    "operation_notes_placeholder_seller": "Electricity supply",
    "cancellation_purposes": {
      "DISCLOSURE": "Disclosure",
      "GRID_LOSSES": "Grid Losses",
      "SELF_CONSUMPTION": "Self Consumption",
      "SUPPORT_SCHEME": "Support Scheme",
      "OTHER": "Other"
    },
    "operation_notes": "Operation Notes",
    "confirm_title": "Confirm Buy & Cancel Order",
    "order_summary": "Order Summary",
    "illiquid_warning": "no companies will be priced via RFQ | 1 company will be priced via RFQ | {count} companies will be priced via RFQ",
    "total_known_price": "Total Known Price",
    "cancellation_not_supported_title": "Cancellation not directly supported",
    "cancellation_not_supported_description": "The following companies are in registries where we cannot perform cancellation directly. Please choose how you'd like to proceed:",
    "cancellation_option_agent": "Soldera arranges cancellation in the local registry for full compliance",
    "cancellation_option_any_registry": "Cancel in any AIB Registry (standard cancellation price)",
    "companies_with_pricing": "Companies with Known Pricing ({count})",
    "confirm_and_submit": "Confirm and Submit Orders",
    "quoted_pricing": "Quoted Pricing",
    "base_price": "Base Price",
    "price_per_mwh": "Price per MWh",
    "no_pricing_info": "No pricing information available for this order",
    "cancellation_fee": "Cancellation Fee",
    "minimum_cancellation_fee": "Minimum Cancellation Fee",
    "brokerage_fee": "Procurement Fee",
    "incl_brokerage": "incl. €{amount}/MWh procurement fee",
    "incl_cancellation": "incl. €{amount}/MWh cancellation fee",
    "incl_min_cancellation": "incl. €{amount} min. cancellation fee",
    "eac_source": "EAC Source",
    "matching": "Matching",
    "cancellation_settings": "Cancellation Settings",
    "purchase_settings_title": "Purchase Settings",
    "purchase_mode_label": "Purchase Mode",
    "pricing_error": "Unable to calculate pricing. Please try again or contact support.",
    "volume_required": "Volume must be at least 1 MWh",
    "intro": "Buy renewable energy certificates and cancel them on behalf of your beneficiaries — in a single step. Choose how the certificates should be sourced, add each beneficiary below, then confirm.",
    "accelerator_title": "Start from a document",
    "sourcing_preference_description": "How we source certificates for every beneficiary.",
    "sourcing_cheapest_title": "Cheapest",
    "sourcing_cheapest_desc": "Most cost-effective options available",
    "sourcing_ghg_title": "GHG",
    "sourcing_ghg_desc": "Meets SBTi, ERI & CDP reporting criteria",
    "sourcing_re100_title": "RE100",
    "sourcing_re100_desc": "Wind + Solar, COD ≤ 15 years",
    "sourcing_other_title": "Other",
    "sourcing_other_desc": "Describe your own sourcing requirement",
    "custom_requirement_label": "Custom sourcing requirement",
    "custom_requirement_placeholder": "Tell us what you need — specific technology, country, vintage, ecolabels, or any other sourcing requirement. Our team will follow up with a tailored quote.",
    "custom_requirement_advisory": "Custom requirements are priced via RFQ — our sourcing team will respond with an indicative quote, usually within one business day.",
    "shared_cancellation_settings": "Shared cancellation settings",
    "add_beneficiary": "Add beneficiary",
    "add_another_beneficiary": "Add another beneficiary",
    "no_beneficiaries_title": "No beneficiaries added yet",
    "no_beneficiaries_description": "Upload a document above to auto-fill them, or add your first beneficiary manually to get started.",
    "total_consumption": "Total consumption",
    "estimated_cost": "Indicative cost",
    "add_at_least_one_beneficiary": "Add at least one beneficiary",
    "ask_for_quote": "Ask for quote",
    "fetching_quotes": "Fetching quotes…",
    "review": "Review",
    "request_custom_quote": "Request custom quote",
    "custom_quote_reassurance": "Soldera will conduct an RFQ and reply with an indicative quote before anything is bought.",
    "manual_quote": "Priced via RFQ",
    "by_quote": "By RFQ",
    "priced_subline": "{known} of {total} MWh priced · {perMwh}/MWh",
    "rfq_reassurance": "Priced lines are submitted for execution at their quoted price. For the remaining volumes, Soldera will conduct an RFQ across our supplier network and respond with an indicative quote — usually within one business day. Nothing is bought for RFQ lines until you approve the quote.",
    "review_order_title": "Review buy & cancel order",
    "average_unit_price": "Average unit price",
    "indicative_bid_note": "All prices shown are indicative bids based on current market levels — not firm bids. The final price is confirmed when your order is executed.",
    "quotes_indicative_note": "All quotes are indicative — the final price is confirmed at execution.",
    "market_levels_as_of": "Market levels as of {date}",
    "quote_reference": "Ref {id}",
    "quote_reference_label": "Quote reference",
    "consumption_period": "Consumption period",
    "cancellation_mode_selection_aria": "Cancellation mode selection",
    "remove_beneficiary_row_aria": "Remove beneficiary row {index}"
  },
  "issuance_reporting": {
    "upload_file": "Upload File",
    "export": "Export",
    "add_new": "@:common.add",
    "filters": {
      "period_start": "From month",
      "period_end": "To month",
      "all_devices": "All devices",
      "all_statuses": "All statuses"
    },
    "status": {
      "pending": "@:common.pending",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "completed": "Completed"
    },
    "table": {
      "device": "Device",
      "device_code": "Device Code",
      "total_production": "Total Production",
      "date": "Date",
      "actions": "Actions"
    },
    "file_upload": {
      "import_summary": "Records imported: {imported}. Records rejected: {rejected}.",
      "rejected_records": "Rejected records",
      "rejected_record": "Record {index} · {device}",
      "country_label": "Country",
      "select_country": "Select country",
      "title": "Upload production data report",
      "description": "Please upload your production data report in tabular format (Excel, CSV, etc.)",
      "upload_prompt": "Drag and drop your file here or click to browse",
      "upload_another": "Upload another file",
      "supported_formats": "Supported formats: .xlsx, .xls, .csv. For large Excel workbooks, remove unused sheets and formatting or split the workbook into smaller files.",
      "analyzing": "Analyzing file...",
      "countries": {
        "ES": {
          "label": "Spain"
        },
        "PL": {
          "label": "Poland"
        }
      }
    },
    "no_data_for_period": "No data for period",
    "delete_record": "Delete Record",
    "confirm_delete_record": "Are you sure you want to delete this record? This action cannot be undone.",
    "delete_success": "Record deleted successfully",
    "update_success": "Production data updated successfully",
    "create_success": "Production data record created successfully",
    "export_success": "Data exported successfully",
    "file_upload_success": "File uploaded successfully. Created {created} records out of {total} processed.",
    "no_data": "No production data available",
    "no_data_description": "Upload production data to get started with issuance reporting.",
    "pl_status": {
      "title": "Issuance workflow status",
      "production_data_received": "Production data received",
      "waiting_for_quarterly_application_submission": "Quarterly application pending submission",
      "application_submitted_to_tge_registry": "Application submitted",
      "tge_registry_overdue_submission_deadline": "Quarterly application overdue",
      "goos_issued_successfully": "Guarantees of Origin issued successfully"
    },
    "pl_status_flags": {
      "application_fee_paid": "Application fee paid",
      "application_fee_not_paid": "Application fee not paid",
      "communication_with_tge_initiated": "Follow-up initiated",
      "automatic_written_notice": "Automatic written notice",
      "telephone_call": "Telephone call"
    },
    "import_not_trusted": "File imports are available once your account has been activated. Contact support@soldera.org to get set up.",
    "company_required": "Select a company to view issuance reporting."
  },
  "links": {
    "trading_procedure": "https://www.soldera.org/compliance/trading-procedure",
    "trading_procedure_text": "Soldera trading procedure"
  },
  "company_orders": {
    "rfq_timeline": {
      "submitted": "RFQ submitted",
      "quote_expected": "Indicative quote expected by {date}",
      "approval_gate": "Nothing is bought until you approve the quote"
    },
    "title": "Transactions",
    "order_type": "Order Type",
    "portfolio": "Portfolio",
    "total_selected_mwh": "Volume",
    "order_starter": "Order Starter",
    "initiated_by": "Initiated by",
    "order_date": "Order Date",
    "date": "Date",
    "export_csv": "Export orders CSV",
    "created": "Created",
    "updated": "Updated",
    "confirm_order": "Confirm Order",
    "edit_order": "Edit Order",
    "edit_order_title": "Edit Company Order",
    "edit_order_success": "Order updated successfully.",
    "edit_order_error": "Failed to update order.",
    "edit_order_load_error": "Failed to load order details for editing.",
    "mwh_mismatch_warning": "Total MWh in cancel statements ({statementsMwh}) does not match selected portfolio items ({portfolioMwh}). Adjust the statement MWh values or the portfolio selection so they match.",
    "order_details": "Order Details",
    "order_information": "Order Information",
    "portfolio_items_summary": "Portfolio Items Summary",
    "total_mwh": "Total MWh",
    "support_status": "Support Status",
    "associated_portfolio_items": "Associated Portfolio Items",
    "no_portfolio_items": "No portfolio items associated with this order.",
    "processing_result": "Processing Result",
    "order_type_details": "{type} Order Details",
    "order_types": {
      "SEND": "@:common.actions.send",
      "RECEIVE": "Receive",
      "BUY": "Buy",
      "SELL": "Sell",
      "CANCEL": "Cancel",
      "BUY_AND_CANCEL": "Buy & Cancel"
    },
    "loading_portfolio_items": "Loading portfolio items...",
    "view": "View",
    "confirm": "Confirm",
    "reject": "Reject",
    "confirm_all": "Confirm All",
    "confirm_all_message": "Are you sure you want to confirm all {count} waiting order(s)? Processing will start automatically.",
    "confirm_order_message": "Are you sure you want to confirm this order? Processing will start automatically.",
    "reject_all": "Reject All",
    "batch_confirm_success": "Successfully confirmed {count} order(s)",
    "batch_confirm_partial": "Confirmed {success} order(s), failed {failed}",
    "batch_reject_success": "Successfully rejected {count} order(s)",
    "batch_reject_partial": "Rejected {success} order(s), failed {failed}",
    "status": {
      "waiting_confirmation": "Waiting Confirmation",
      "pending": "Pending",
      "pending_agent": "Manual processing",
      "processing": "Processing",
      "completed": "Completed",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "send": {
      "recipient_information": "Recipient Information",
      "company_name": "Company Name",
      "registry_country": "Registry Country",
      "eecs_account_id": "EECS Account ID",
      "internal_account_id": "Registry Internal Account Number",
      "unit_price_pln": "Unit Price (PLN/MWh)",
      "operation_notes": "Operation Notes",
      "portfolio_items_title": "Select Portfolio Items to Send"
    },
    "cancel": {
      "total_statements": "Total Statements",
      "total_mwh_cancelled": "Total MWh Cancelled",
      "statement": "Statement",
      "address": "@:common.address",
      "period": "@:cancellation.table.period",
      "purpose": "Purpose"
    },
    "sell": {
      "sale_summary": "Sale Preparation",
      "hold_to_spot_description": "This order moves selected Guarantees of Origin from your self-managed portfolio to the @:charts.values.portfolio_type.SPOT_MARKET_PRICE portfolio for market sales.",
      "hold_to_min_price_description": "This order moves selected Guarantees of Origin from your self-managed portfolio to the @:charts.values.portfolio_type.SPOT_MIN_PRICE portfolio (€{minimumPrice}/MWh minimum).",
      "process_information": "Process Information",
      "source_portfolio": "Source Portfolio",
      "destination_portfolio": "Destination Portfolio",
      "operation_type": "Operation Type",
      "internal_portfolio_transfer": "Internal Portfolio Transfer"
    },
    "buy": {
      "order_summary": "Order Summary",
      "purchase_summary": "Purchase Summary",
      "volume": "Volume",
      "total_price": "Total Price",
      "total_price_per_mwh": "Total Price per MWh",
      "go_specifications": "EAC Specifications",
      "eac_source": "EAC Source",
      "technology": "Technology",
      "ecolabel": "Ecolabel",
      "vintage": "Vintage",
      "support": "Support",
      "operation_notes": "Operation Notes",
      "purchase_mode": "Purchase Mode",
      "cod_requirement": "COD Requirement",
      "matching": "Matching",
      "uploaded_contract": "Uploaded Contract",
      "contract": "Contract"
    },
    "generic": {
      "no_additional_details": "No additional order details available."
    },
    "transactions": {
      "no_portfolio_items": "No portfolio item records for the certificates of this transaction.",
      "transaction_type": "Transaction Type",
      "awaiting_confirmation": "{count} order awaiting confirmation | {count} orders awaiting confirmation",
      "in_progress": "{count} in progress",
      "no_transactions": "No transactions to show",
      "load_more": "Load more",
      "more_transactions": "{count} more transactions",
      "registry_transaction": "Registry transaction",
      "registry_transactions": "Registry transactions",
      "not_yet_in_registry": "Not yet visible in the registry",
      "occurred": "Occurred",
      "connection": "Connection",
      "volume": "Volume",
      "certificates": "Certificates",
      "volume_in_registry": "Volume in registry",
      "certificates_in_registry": "Certificates in registry",
      "counterparty": "Counterparty",
      "counterparty_account": "Counterparty account",
      "counterparty_eecs": "Counterparty EECS",
      "event_group": "Registry transaction group",
      "events": "Registry transactions",
      "event_count": "Transactions",
      "from": "From",
      "to": "To",
      "total": "Total",
      "showing": "{shown} of {total}",
      "technology": "Technology",
      "production_month": "Production month",
      "production_device": "Production device",
      "production_device_count": "{count} devices",
      "event_group_label": "{label} · {count}",
      "event_types": {
        "ISSUANCE": "Issuance",
        "INCOMING_TRANSFER": "Incoming transfer",
        "OUTGOING_TRANSFER": "Outgoing transfer",
        "CANCEL": "Cancellation",
        "EXPIRY": "Expiry",
        "REVOCATION": "Revocation"
      },
      "event_row_types": {
        "ISSUANCE": "Registry issuance",
        "INCOMING_TRANSFER": "Registry transfer in",
        "OUTGOING_TRANSFER": "Registry transfer out",
        "CANCEL": "Registry cancellation",
        "EXPIRY": "Registry expiry",
        "REVOCATION": "Registry revocation",
        "ALLOCATION": "Portfolio allocation",
        "RETURN": "Portfolio return"
      },
      "event_group_types": {
        "ISSUANCE": "Registry issuances",
        "INCOMING_TRANSFER": "Registry transfers in",
        "OUTGOING_TRANSFER": "Registry transfers out",
        "CANCEL": "Registry cancellations",
        "EXPIRY": "Registry expiries",
        "REVOCATION": "Registry revocations",
        "ALLOCATION": "Portfolio allocations",
        "RETURN": "Portfolio returns"
      }
    }
  },
  "hosted_accounts": {
    "receive_new_gos_title": "Receive New Guarantees of Origin",
    "receive_new_gos_description": "Set up a new intention to receive Guarantees of Origin to your Soldera-hosted registry account. We use this to match incoming transfers.",
    "select_country": "Select country where you want to receive Guarantees of Origin",
    "select_country_placeholder": "Choose a country for receiving Guarantees of Origin...",
    "select_country_first": "Please select a country to continue",
    "hosted_account": "Hosted account",
    "account_details_heading": "Share these details with the sender",
    "transfer_identification_heading": "Identify the incoming transfer",
    "description": "Provide these Soldera registry details to the party sending Guarantees of Origin, so the transfer reaches the correct account.",
    "company_name": "Company Name",
    "eecs_account": "EECS Account",
    "amount_mwh": "Amount (MWh)",
    "sender_company_name": "Sender Company Name",
    "sender_eecs_account": "Sender EECS Account",
    "counterparty_email": "Sender Email",
    "counterparty_email_hint": "We email the sender the account details to transfer to.",
    "counterparty_email_optional_hint": "Optional with a production device set. If given, we email the sender the account details to transfer to.",
    "optional_notes_on_email": "Notes for notification email",
    "operation_notes_placeholder": "Add any special instructions or notes...",
    "operation_notes_hint": "Shown to the sender in the transfer instructions email, and to the Soldera team.",
    "production_device_codes": "Production device codes",
    "production_device_codes_placeholder": "e.g. 643XXXXXXXXXXXXXXX",
    "production_device_codes_hint": "Only Guarantees of Origin from these devices are matched to this order. Leave the amount empty to receive everything these devices deliver; with a repeating schedule, the order keeps doing so every period. Separate several codes with commas.",
    "production_device_codes_too_many": "Enter at most {max} device codes",
    "production_device_code_too_long": "Each device code can be at most {max} characters",
    "receive_order_created": "Receive order created. We will match incoming transfers to it.",
    "receive_order_created_sender_notified": "Receive order created. We have emailed the sender the transfer instructions.",
    "create_receive_order": "Create Receive Order",
    "create_order": "Create Receive Order",
    "advanced_options": "Advanced options",
    "company_name_copied": "Company name copied to clipboard!",
    "eecs_account_copied": "EECS account copied to clipboard!",
    "copy_fallback": "Copied to clipboard (fallback method)",
    "copy_failed": "Copy failed. Please copy manually.",
    "no_regions_unlocked": "No hosted accounts are configured for your organization yet.",
    "contact_us_cta": "Contact us",
    "contact_us_title": "Need to receive in another country?",
    "contact_us_title_no_accounts": "Ready to receive Guarantees of Origin?",
    "contact_us_description": "Contact us to purchase more hosted accounts.",
    "contact_us_description_no_accounts": "Contact us to set up your first hosted account.",
    "contact_us_button": "Contact us",
    "no_accounts_configured": "No hosted accounts configured. Contact us to get started.",
    "company_id_missing": "Company ID is missing"
  },
  "receive_order": {
    "repeating_label": "Repeating Schedule",
    "repeating_options": {
      "none": "One-off",
      "monthly": "Monthly",
      "quarterly": "Quarterly",
      "half_yearly": "Half-Yearly",
      "yearly": "Yearly"
    },
    "at_least_one_required": "Provide at least one of these fields to help us match the transfer"
  },
  "portfolios": {
    "title": "Portfolios",
    "description": "View and manage all your portfolio allocations. Rename, split, merge, or move items between portfolios.",
    "show_items": "Show no items | Show 1 item | Show {count} items",
    "merge": "Merge",
    "split": "Split",
    "merge_modal_title": "Merge Portfolios",
    "source_portfolio": "Source Portfolio",
    "target_portfolio": "Target Portfolio",
    "select_target_placeholder": "Select target portfolio...",
    "merge_confirm_warning": "All items from {source} will be moved to {target}. The source portfolio will be permanently deleted.",
    "merge_info": "Select a target portfolio to see the merge details. The source portfolio will be deleted after merging.",
    "volume_and_items": "{volume} MWh • {count} items",
    "split_modal_title": "Split Portfolio",
    "split_select_items": "Select certificates to move",
    "split_new_name_label": "New Portfolio Name",
    "split_new_name_placeholder": "e.g., Batch B",
    "split_default_name": "Split from {name} on {date}",
    "items_selected": "No items selected | 1 item selected | {count} items selected",
    "confirm_merge": "Confirm Merge",
    "confirm_split": "Confirm Split",
    "section_inventory": "Inventory",
    "section_inventory_desc": "GOs available for actions such as send, cancel, and more.",
    "section_spot": "Spot Sales",
    "section_spot_desc": "GOs queued for sale on the spot market.",
    "section_ppa": "PPA",
    "section_ppa_desc": "Reserved for future obligations.",
    "section_forwards": "Forwards",
    "section_forwards_desc": "Reserved for forward sales.",
    "volume_label_inventory": "Available",
    "volume_label_spot": "Queued for Sale",
    "volume_label_ppa": "Reserved",
    "volume_label_forwards": "Reserved",
    "badge_own_registry": "Connected",
    "badge_soldera_account": "Hosted",
    "badge_spot_market": "Market Price",
    "badge_spot_min": "Min {price} EUR",
    "badge_spot_min_default": "Min Price",
    "badge_stx": "STX",
    "badge_ppa": "PPA",
    "badge_forward": "Forward",
    "badge_default": "Default",
    "tooltip_own_registry": "Guarantees of Origin held in the company's connected EECS registry account",
    "tooltip_soldera_account": "Guarantees of Origin held in Soldera's hosted account on behalf of the company",
    "tooltip_spot_market": "Sold at current market price",
    "tooltip_spot_min": "Sold only when market price meets the minimum threshold",
    "tooltip_default": "Default portfolio for allocation. Cannot be merged.",
    "view_ppa_config": "Configure",
    "view_forwards": "View Forwards",
    "move_items": "Move",
    "move_modal_title": "Move Items",
    "move_modal_desc": "Choose a destination portfolio and select the items to move.",
    "move_target": "Destination Portfolio",
    "select_move_target": "Select destination...",
    "confirm_move": "Confirm Move",
    "no_portfolios": "No portfolios found for this section.",
    "empty_inventory": "No GOs currently in inventory. GOs will appear here once received or purchased.",
    "empty_portfolio": "This portfolio has no items.",
    "show_empty": "Show {count} empty portfolios",
    "hide_empty": "Hide empty portfolios",
    "badge_own_use": "Not tradeable",
    "tooltip_own_use": "Guarantees of Origin marked for own use by the registry. They cannot be sold, transferred or cancelled."
  },
  "production_strategy": {
    "title": "Production Strategy",
    "overview": "Overview",
    "ppa_settings": "PPA Settings",
    "self_managed_settings": "Self-Managed Settings",
    "spot_settings": "Spot Sales Settings",
    "issuance_report": "Issuance Report",
    "forward_commitments": "Forward Commitments",
    "whole_year": "Next 12 months",
    "from_this_month_onward": "From this month onward",
    "next_year": "Next year",
    "bulk_issuance_report": "TSO Declaration Excel",
    "generating_report": "Generating...",
    "generating_report_progress": "Generating... {current}/{total}",
    "report_duration_hint": "Each company is fetched from the registry in turn, so this can take a while. You can leave this page and come back.",
    "download_report": "Download Report",
    "generate_new_report": "Generate new",
    "report_generated_at": "Generated {time}",
    "report_failed": "Failed - Click to Retry",
    "bulk_issuance": {
      "button_text": "Issue all GOs",
      "title": "Issue all guarantees of origin",
      "description": "Select the production period and companies for issuance:",
      "production_period": "Production period",
      "period_error": "Start month must be before or equal to end month",
      "companies_label": "@:common.companies",
      "no_companies": "No HKNR companies found for this account.",
      "confirm_all": "Confirm all declarations",
      "confirm_title": "Confirm bulk issuance",
      "confirm_message": "Issuing GOs for {count} company(ies). If a company is missing installations, it will be skipped.\n\n\"Proof of origin/Herkunftsnachweis\" text will be left empty in the form.\n\"Subsidy for electricity generation/Förderung der Stromerzeugung\" will be left as it is in the form.\n\nAre you sure you want to continue?",
      "cancel_title": "Cancel bulk issuance",
      "cancel_message": "Are you sure you want to cancel? Certificates already issued cannot be rolled back.",
      "already_processed": "Already processed companies:",
      "in_progress": "In progress",
      "status": {
        "pending": "@:common.pending",
        "in_progress": "Processing...",
        "completed": "{count} installation(s) submitted",
        "skipped": "Skipped (nothing to issue)",
        "error": "Error"
      }
    },
    "production_allocations": "Production Allocations",
    "company_production": "Company Production",
    "show_all_companies": "Show all companies",
    "not_available_consolidated": "Not available in consolidated view",
    "yearly_allocations": "Yearly allocations",
    "ppa": "PPA",
    "agreements": "Agreements",
    "ppa_agreements": "PPA Agreements",
    "documents": "@:common.documents",
    "display_name": "Display Name",
    "no_display_name": "No display name available",
    "display_name_help": "Auto-generated from transaction details",
    "action_instructions": "Action Instructions",
    "execution_configuration": "Execution Configuration",
    "delivery_method": "Delivery Method",
    "automatic": "Execute automatically",
    "manual": "Ask for confirmation",
    "automatic_explainer": "the system executes the transaction automatically on the scheduled date — no manual approval needed.",
    "manual_explainer": "at the scheduled execution time the system creates a company order that must be manually approved before execution.",
    "execution_method": "Execution Method",
    "execution_method_aria": "Execution method",
    "delivery_method_aria": "Delivery method",
    "delivery_timing": "Delivery Timing",
    "execution_timing": "Execution Timing",
    "yearly": "Yearly",
    "half_year": "Half-yearly",
    "quarterly": "Quarterly",
    "monthly": "Monthly",
    "fixed_dates": "Fixed Dates",
    "fixed_dates_count": "{count} fixed dates",
    "fixed_delivery_dates": "Fixed Delivery Dates",
    "add_date": "Add Date",
    "end_date": "End Date",
    "ppa_contract_end_date": "End date of the PPA contract",
    "end_date_help": "When the PPA contract ends",
    "ppa_contract_start_date": "Start date of the PPA contract",
    "start_date_help": "When the PPA contract begins (required for monthly/quarterly limits)",
    "transaction_type": "Transaction Type",
    "send": "Send",
    "cancel": "@:common.cancel",
    "send_help": "Transfer GOs to recipient",
    "cancel_help": "Retire GOs for beneficiary",
    "send_details": "Send Details",
    "cancel_details": "Cancellation Details",
    "notes": "Notes",
    "notes_placeholder": "Add internal notes for this PPA — context, counterparty owner, renewal terms...",
    "analyze_files": "Analyze Files",
    "counterparty_details": "Counterparty Details",
    "transaction_type_aria": "Transaction type",
    "q4_production_execution_date": "Q4 execution date:",
    "q1_production_execution_date": "Q1 execution date:",
    "q2_production_execution_date": "Q2 execution date:",
    "q3_production_execution_date": "Q3 execution date:",
    "h1_production_delivery_date": "H1 production delivery date:",
    "h2_production_delivery_date": "H2 production delivery date:",
    "h3_production_delivery_date": "H3 production delivery date:",
    "h4_production_delivery_date": "H4 production delivery date:",
    "allocation_mode_aria": "Allocation mode",
    "remove_recurring_date": "Remove recurring date",
    "yearly_delivery_day": "Date 1 (Yearly Delivery)",
    "half_year_delivery_days": "Half-Year Delivery Days",
    "quarterly_delivery_days": "Quarterly Delivery Days",
    "monthly_delivery_day": "Monthly Delivery Day",
    "last_day_of_month": "Last day",
    "recurring_delivery_dates": "Recurring Delivery Dates",
    "recurring_execution_dates": "Recurring Execution Dates",
    "recurring_dates_description": "Select day+month combinations that will repeat each year until the PPA end date",
    "recurring_dates_description_monthly": "Select the day of each month when execution will happen.",
    "recurring_dates_description_quarterly": "Configure execution dates for each quarter (shown in operational order).",
    "recurring_dates_description_half_year": "Choose execution dates for the first and second half of the year.",
    "recurring_dates_description_yearly": "Select the single annual execution date.",
    "recurring_dates_description_fixed_dates": "Add execution dates that will repeat in order across the contract.",
    "add_recurring_date": "Add Recurring Date",
    "first_half": "Date 1 - First Half",
    "second_half": "Date 2 - Second Half",
    "date_1_q1": "Date 1 - Q1",
    "date_2_q2": "Date 2 - Q2",
    "date_3_q3": "Date 3 - Q3",
    "date_4_q4": "Date 4 - Q4",
    "quarter_range_q1": "(Jan-Mar)",
    "quarter_range_q2": "(Apr-Jun)",
    "quarter_range_q3": "(Jul-Sep)",
    "quarter_range_q4": "(Oct-Dec)",
    "thinking": "Thinking ...",
    "forward_sales": "Forward sales",
    "forward_sales_overview": {
      "title": "Forward sales overview"
    },
    "forward_mandates_list": {
      "title": "Your active forward sales mandates",
      "empty": "Your companies are not in any active forward sales mandate.",
      "load_failed": "Your forward sales mandates could not be loaded."
    },
    "forward_materials": {
      "description": "Soldera Forward Advantage is designed to help you secure predictable revenue and reduce price fluctuation risks without having to worry about the day-to-day management of your forward sales.",
      "outlook_info_1": "Learn about major market trends and see how prices have moved historically.",
      "outlook_info_2": "Understand how Soldera Forward Advantage can help you secure revenue.",
      "strategy_title": "Soldera Forward Advantage Trading Strategy",
      "strategy_info": "Get the details of how we do forward sales on your behalf.",
      "framework_title": "Forward Sales Framework",
      "framework_info": "Review the legal terms and conditions of all forward sales made through Soldera."
    },
    "of_projected_production_per_quarter": "of projected production per quarter",
    "hedged": "Hedged",
    "already_committed": "Already committed",
    "for_upcoming_sales": "For upcoming sales",
    "self_managed_certificates": "Self-managed certificates",
    "self_manage": "Self-manage",
    "allocation": "Allocation",
    "allocated": "Allocated",
    "spot_sale": "Spot sale",
    "sell_at_highest_bid": "Sell at highest bid",
    "reserved_for_ppas": "Reserved for PPAs",
    "hedged_for_forward_sales": "Hedged for Forward Sales",
    "committed_forward": "Committed forward",
    "forward_estimate": "estimate",
    "forward_estimate_note": "Estimated share of a shared mandate",
    "to_be_sold": "To be sold forward",
    "to_be_sold_description": "Listed forward volume not yet sold, placed in the months where production remains after existing commitments.",
    "sell_all_remaining_spot": "Sell all remaining via Spot",
    "ppa_allocation_card": "PPA allocation card",
    "forward_allocation_card": "Forward sales allocation card",
    "self_managed_allocation_card": "Self-managed certificates allocation card",
    "spot_allocation_card": "Spot sales allocation card",
    "wizard_step_action": "Action",
    "wizard_step_allocation": "@:production_strategy.allocation",
    "wizard_step_execution": "Execution & review",
    "wizard_step_1_hint": "Drop a contract to auto-fill, or continue manually",
    "show_all_as_one_form": "Show all as one form",
    "new_ppa_portfolio": "New PPA portfolio",
    "edit_ppa_portfolio": "Edit PPA portfolio",
    "ppa_modal_crumb": "Production strategy · PPA",
    "step_x_of_y": "Step {current} of {total}",
    "save_ppa": "Save PPA",
    "prefill_from_document": "Pre-fill from document",
    "portfolio_name_title": "Portfolio name",
    "portfolio_name_desc": "How this PPA appears across your dashboards.",
    "contract_dates_title": "Contract dates",
    "contract_dates_desc": "When the PPA contract starts and ends.",
    "action_title": "Action",
    "action_desc": "What should happen with the GOs from this PPA.",
    "allocation_title": "@:production_strategy.allocation",
    "allocation_desc": "How much production is covered.",
    "devices_title": "Devices",
    "devices_desc": "Which plants source the energy.",
    "execution_title": "Execution",
    "execution_desc": "When and how transactions run.",
    "review_title": "Review",
    "review_desc": "What will happen when you save.",
    "notes_title": "Notes",
    "notes_desc": "Add internal context for this PPA.",
    "upload_ppa_to_auto_fill": "Upload a PPA document to auto-fill",
    "upload_ppa_auto_fill_subtitle": "Drop a PDF, DOC or DOCX — we'll extract what we can. You can edit everything afterwards.",
    "or_skip_and_continue": "or skip and continue below",
    "what_is_this_ppa_for": "What is this PPA for?",
    "send_certificates": "Send certificates",
    "cancel_on_behalf": "Cancel on behalf",
    "send_label": "@:common.actions.send",
    "send_explainer": "transfers the certificates to the counterparty's registry account — they receive them and can use or retire them themselves.",
    "cancel_on_behalf_label": "Cancel on behalf",
    "cancel_on_behalf_explainer": "retires the certificates on the counterparty's behalf — nothing is transferred; the certificates are consumed against their name.",
    "not_set": "Not set",
    "no_devices_selected": "No devices selected",
    "review_cancel_for": "Cancelled for {name}",
    "review_cancel_generic": "Cancel on behalf",
    "review_n_periods": "{count} periods",
    "review_devices_summary": "{count} selected · {mw} MW",
    "review_counterparty_label": "Counterparty",
    "review_allocation_label": "@:production_strategy.allocation",
    "review_devices_label": "Devices",
    "review_execution_label": "Execution",
    "automatic_short": "Automatic",
    "manual_short": "Manual"
  },
  "ppa_summary": {
    "heading": "Upcoming executions",
    "loading": "Calculating expected volumes...",
    "no_data": "No projection data available yet.",
    "no_data_short": "—",
    "mwh_value": "{amount} MWh",
    "next_delivery": "Next delivery",
    "following_delivery": "Following delivery",
    "contract_ends": "Contract ends",
    "send": "Will deliver on {date} (expected {amount} MWh).",
    "cancel": "Will cancel period {start} -> {end} on {date} (expected {amount} MWh)."
  },
  "ai_chat": {
    "certificate_criteria_conflict": "{context} contain conflicting certificate requirements ({criterion}). Upload them separately.",
    "conflict_contexts": {
      "excel_rows": "The Excel rows",
      "uploaded_documents": "The uploaded documents",
      "draft_and_document": "The current draft and uploaded document"
    },
    "shared_setting_conflict": {
      "intro": "Nothing was imported. A cancellation order can have only one beneficiary type, consumption period and cancellation purpose, but these statements differ:",
      "other_statements": "Other statements ({count})",
      "more_statements": "…and {count} more",
      "outro": {
        "uploaded_documents": "Correct these statements in your document and upload it again, upload them in separate files, or add a note to your upload stating the value that applies to all statements.",
        "draft": "The draft was not changed. Tell me which value applies to all statements, or finish this order and start a new chat for the other statements."
      }
    },
    "document_irrelevant": "This document doesn't seem to fit what we're preparing here, so nothing was imported. Please upload another document, or ask me why it didn't fit.",
    "title": "AI assistant",
    "input_placeholder": "Write a message…",
    "send": "Send",
    "attach": "Attach a document",
    "drop_files": "Drop files to attach",
    "drop_files_hint": "PDF, Word, Excel, CSV or TXT · up to {maxMb} MB",
    "drop_busy": "Attach files after the reply arrives",
    "new_chat": "Start a new chat",
    "thinking": "Working on it…",
    "error_reply": "Sorry, something went wrong while processing that. Please try again.",
    "ecolabel_label_needs_document": "A label is built from cancellation statement documents, so I need the statement itself to create the draft. Attach it as a PDF, Word, Excel, CSV or text file; you can add instructions in the same message.",
    "greetings": {
      "cancel": "Hi! Upload a cancellation document (PDF, Word, Excel or CSV) and I'll draft the statements for you. If any critical information is missing, I'll ask for it here. You can also just describe what you need in a message.",
      "buy": "Hi! Upload a procurement document or describe what you want to buy (volume, technology, vintage…), and I'll fill in the purchase settings for you.",
      "send": "Hi! Upload a transfer document or tell me who should receive the GOs (recipient, EECS account, MWh amount), and I'll prepare the transfer for you.",
      "bulk_buy": "Hi! Upload consumption reports or facility lists and I'll extract the companies, volumes and purchase settings. If anything important is missing, I'll ask for it here.",
      "ppa": "Hi! Upload your PPA contract or describe the delivery schedule, and I'll fill in the delivery instructions. If anything important is missing, I'll ask for it here.",
      "ecolabel_label": "Hi! Tell me what to correct in this draft, such as a beneficiary, a period, a total or how the MWh split between the devices, and I'll make the change. Attach more cancellation statements to add them to the label.",
      "ecolabel_label_new": "Hi! Attach the cancellation statements this label is built from and I'll create the draft: each document is read by AI and the devices it names are matched against the catalog. You can add instructions in the same message.",
      "ecolabel_devices": "Hi! Upload your device list (spreadsheet, registry export, email or PDF) and I'll extract every device with its details, check for missing fields and flag possible duplicates. You can also describe devices or corrections in a message."
    }
  },
  "branding": {
    "powered_by": "Powered by",
    "registry_infrastructure": "Registry Infrastructure",
    "powered_by_soldera": "Powered by Soldera Registry Infrastructure"
  },
  "cnmc": {
    "workflow_intro": "Report monthly production, prepare CNMC issuance files, then track PPA transfers and exports.",
    "filing_details": "Filing details",
    "prepare_issuance": "Prepare issuance",
    "recipient_name": "Recipient legal name",
    "destination_registry": "Destination registry",
    "choose_registry": "Choose a registry",
    "domestic_transfer": "Spain · domestic transfer",
    "recipient_r2": "CNMC supplier identifier (R2)",
    "eecs_account": "EECS account",
    "market_destination": "Export destination for market volumes",
    "change_destination": "Change destination",
    "confirm_representation": "I am authorized to submit filings for this producer and have confirmed any representation requirements.",
    "accept_declarations": "I confirm these readings are available for issuance, no other claims are open against them, and the producer accepts CNMC’s filing declarations and data processing terms.",
    "fields": {
      "producer_name": "Producer legal name",
      "street": "Street",
      "street_number": "Street number",
      "staircase": "Staircase (optional)",
      "postal_code": "Postal code",
      "municipality": "Municipality",
      "province": "Province",
      "country": "Country",
      "phone": "Phone",
      "email": "Email",
      "place": "Place of signature",
      "representative_name": "Representative name (if applicable)"
    },
    "production": "Production",
    "allocation": "Allocation",
    "review": "Review",
    "monthly_breakdown": "Enter each device and month separately. Fractions are excluded from GO issuance; volumes are never pooled across months.",
    "device": "Production device",
    "month": "Production month",
    "production_mwh": "Production (MWh)",
    "whole_go_total": "{count} whole GOs before existing commitments",
    "allocation_explanation": "PPA instructions determine allocation. To change the split, update your PPA instructions and refresh this draft.",
    "route": "Delivery route",
    "market": "Market",
    "routes": {
      "DOMESTIC": "Domestic",
      "EXPORT": "AIB export"
    },
    "issuance_split": "{domestic} domestic GOs · {exported} GOs for AIB export",
    "saved_draft_explanation": "Your draft is saved. Confirm the batch to reserve these quantities and generate the issuance files.",
    "open_batch": "Open batch",
    "batch_number": "CNMC batch #{id}",
    "needs_attention_explanation": "Soldera needs to review this filing. Submitted requests continue to be monitored; affected volumes remain reserved.",
    "edit_draft": "Edit draft",
    "delete_draft": "Delete draft",
    "delete_draft_confirmation": "Delete CNMC batch #{id}? This permanently deletes the draft, its allocation and its production readings. This cannot be undone.",
    "confirm_and_generate": "Confirm allocation and generate files",
    "stacking_instructions": "Upload each issuance ZIP to CNMC, then record its own receipt below. You can prepare transfer and export files once issuance is submitted, while approval is pending. Upload each delivery ZIP separately and record its own receipt.",
    "prepare_ppa_delivery": "Prepare {name} delivery",
    "ppa_delivery_issuance_required": "Submit this PPA’s issuance file to CNMC, then enter its Número de Registro above and click Record submission.",
    "market_export_issuance_required": "Submit the AIB export issuance file to CNMC, then enter its Número de Registro above and click Record submission.",
    "prepare_market_export": "Prepare market export",
    "kinds": {
      "DOMESTIC_ISSUANCE": "Domestic issuance",
      "EXPORT_ISSUANCE": "AIB export issuance",
      "TRANSFER": "Domestic transfer",
      "EXPORT": "Export"
    },
    "statuses": {
      "DRAFT": "Draft",
      "CONFIRMED": "Confirmed",
      "PREPARED": "Prepared",
      "SUBMITTED": "Submitted · unverified",
      "PENDING": "Pending",
      "APPROVED": "Approved · awaiting evidence",
      "COMPLETED": "Completed",
      "COMPLETE": "Complete",
      "IN_PROGRESS": "In progress",
      "NEEDS_ATTENTION": "Needs attention",
      "ABANDONED": "Abandoned",
      "SUPERSEDED": "Replaced"
    },
    "source_receipts": "Source issuance · Nº Registro Origen",
    "outdated_file": "This file uses an older template. Replace an unsubmitted file before uploading; keep submitted files for your records.",
    "lookup_retry": "CNMC verification is temporarily unavailable. A retry is scheduled; the last known status is preserved.",
    "filing_deadline": "Filing deadline",
    "go_expiry": "GO expiry",
    "last_checked": "Last checked",
    "not_checked": "Not checked yet",
    "company_order": "Company order",
    "download_zip": "Download ZIP",
    "check_status": "Check status",
    "record_submission": "Record submission",
    "correction_reason": "Reason for correction or withdrawal",
    "abandon_batch": "Abandon batch",
    "abandonment_reason": "Reason for abandoning this batch",
    "abandon_explanation": "Only unsubmitted or verified rejected/withdrawn issuance can release production. A failed delivery does not release issued volumes.",
    "connection": "CNMC connection",
    "preparation_disabled": "New filing preparation is not enabled for this connection. Existing filing history remains available.",
    "profile_required": "Confirm your filing details before preparing issuance.",
    "template_updated": "CNMC has updated this form. We need to update support before you can generate a new file. Your entered data is saved.",
    "checking_templates": "Checking CNMC forms. Generation will be available after verification.",
    "no_batches": "No issuance batches yet.",
    "batch": "Batch",
    "progress": "Progress",
    "filing_order": "This order is managed through CNMC filing forms. Open the issuance batch to download files, enter receipts and check progress.",
    "pending_ppa": "Reserved for CNMC PPA delivery",
    "cnmc_transferred": "Confirmed PPA delivery",
    "ppa_progress": "{reserved_go_count} GOs reserved · {ready_go_count} ready for filing · {transferred_go_count} transferred",
    "linked_filings": "CNMC filings",
    "order_instructions": "Upload the files in CNMC and record each receipt in the linked batch. Registry checks confirm completion.",
    "awaiting_delivery_form": "Issuance is reserved. Prepare the transfer or export file from Issuance Report after recording the issuance receipt.",
    "inventory_accepted": "Inventory received and assigned",
    "arrival_review": "Spanish export arrivals",
    "arrival_review_help": "Review the exact receiving account, full plant volumes and production months. Split pickups and plant aliases require a reason. Acceptance assigns ownership and portfolios together.",
    "export_verified": "Export verified",
    "awaiting_verification": "Awaiting CNMC verification",
    "receiving_account": "Receiving account",
    "imported_at": "Imported at",
    "production_months": "Production months",
    "reviewed_name": "Reviewed plant name",
    "use_registry_name": "Use registry name",
    "accept_inventory": "Accept inventory",
    "replace_file": "Replace file",
    "replace_file_help": "Create a linked replacement using the current supported template. Submitted requests must be verified rejected or withdrawn first. Historical files remain available.",
    "awaiting_issuance_receipt": "Waiting for issuance receipt",
    "next_action": "Next step",
    "actions": {
      "REVIEW": "Review and confirm allocation",
      "SUBMIT_ISSUANCE": "Upload issuance files and enter each Número de Registro | Upload the issuance file and enter its Número de Registro | Upload issuance files and enter each Número de Registro",
      "SUBMIT_DELIVERY": "Upload delivery files and enter each Número de Registro",
      "PREPARE_DELIVERY": "Prepare delivery files",
      "WAIT_CNMC": "Waiting for CNMC confirmation",
      "WAIT_INVENTORY": "Waiting for inventory in the receiving account",
      "CONTACT_SOLDERA": "Soldera review required",
      "COMPLETE": "Completed",
      "ABANDONED": "Abandoned"
    },
    "staff_review": "Soldera review",
    "staff_review_help": "After resolving this case, record what changed and check fresh CNMC evidence. Existing files, reservations and delivery records remain in the audit history.",
    "resume_verification": "Resume verification",
    "load_more": "Load more",
    "replacement_draft": "Create replacement draft",
    "replacement_draft_help": "A replacement draft keeps the original production claims. Resolve and release the old filings before confirming overlapping production.",
    "template_check_failed": "CNMC form verification failed. A retry is scheduled; your data is saved.",
    "next_check": "Next check",
    "registry_evidence": "CNMC evidence",
    "net_production": "Actual net production",
    "domestic_volume": "Domestic",
    "export_volume": "AIB export",
    "unallocated_fraction": "Unallocated fraction",
    "application_number": "Application #{id}",
    "requested": "Requested",
    "approved": "Approved",
    "delivered": "Delivered",
    "zip_package": "Original workbook in ZIP",
    "issuance_receipt": "Número de Registro · Expedición",
    "receipt_format": "20 digits, without spaces: submission year + 03 + 14 digits. Use the submission year, not the production year.",
    "receipt_example": "e.g. 20260300000045887410",
    "transfer_receipt": "Número de Registro · Transferencia",
    "export_receipt": "Número de Registro · Exportación",
    "issuance_receipt_help": "After submitting this issuance ZIP, copy its Número de Registro from CNMC. Find it under Consultas por Solicitante, or as Nº registro at the top of the trámite details.",
    "delivery_receipt_help": "After submitting this transfer or export ZIP, copy its new Nº registro from the top of the CNMC trámite details. Do not use Nº Registro Origen (the source issuance) or the export Message ID.",
    "correct_receipt": "Correct registration number",
    "delivery_due": "Delivery readiness",
    "issuance_stage": "Stage 1 · Issuance forms",
    "delivery_stage": "Stage 2 · Transfer and export forms",
    "download_notice": "Downloading a package does not submit it. Record each CNMC receipt in the batch to enable dependent forms and monitoring.",
    "enter_manually": "Enter manually",
    "upload_with_ai": "Upload with AI",
    "upload_readings_help": "AI reads device CIL codes, production months and MWh from Excel or CSV files (max. 25 MB). Review and edit the rows below. For large Excel workbooks, remove unused sheets and formatting or split the workbook into smaller files.",
    "readings_uploaded": "Readings from {filename} are shown below. Review them before continuing.",
    "upload_readings_conflict": "A device/month in this file already has a different reading in the table. Remove that row before uploading again.",
    "invalid_readings_file": "Choose an Excel (.xlsx, .xls) or CSV file up to 25 MB.",
    "add_production_help": "Enter a monthly reading manually or upload a file with AI.",
    "ppa_reserves": "Issuance reservations",
    "no_ppa_reserves": "No PPA reservations. Available whole GOs are allocated to market export.",
    "filing_snapshot_help": "Shared defaults for CNMC applications. Each batch keeps the filing details used when it was prepared.",
    "producer": "Producer",
    "contact_address": "Contact and address",
    "representation": "Representation",
    "declarations": "Declarations",
    "connection_identity": "From the selected CNMC connection",
    "saved_for_connection": "Saved for later batches on this connection",
    "eecs_recipient": "EECS registry account",
    "domestic_recipient": "Spanish supplier · CNMC",
    "recipient_type": "Recipient type",
    "domestic_delivery_help": "Domestic delivery through CNMC. Soldera reserves this share at issuance and prepares the transfer form. You submit the files in CNMC.",
    "export_delivery_help": "Export delivery through CNMC to the recipient’s EECS registry account. Soldera reserves this share at issuance and prepares the export form. You submit the files in CNMC.",
    "ppa_execution_desc": "Allocation and delivery through CNMC.",
    "ppa_execution_help": "Your PPA share and recipient are fixed when you confirm issuance. Record the issuance receipt to prepare the transfer or export file in Issuance Report. Upload each file to CNMC and record its receipt. Soldera tracks approval and delivery.",
    "ppa_execution_summary": "Via CNMC issuance",
    "r2_help": "The recipient’s CNMC eligible supplier registration.",
    "ready_for_filing": "Ready for filing",
    "template_verification_pending": "CNMC forms are awaiting verification. File generation will be available once the latest templates have been verified.",
    "validation": {
      "r2": "Enter the CNMC supplier registration, starting with R2-.",
      "eecs_region": "The EECS account must belong to the selected registry.",
      "month": "Enter a valid production month.",
      "production_precision": "Enter MWh with at most 3 decimal places."
    },
    "connection_required": "Connect a Spanish producer account to prepare CNMC filings. Contact support@soldera.org for help."
  },
  "forwards": {
    "common": {
      "mwh": "MWh",
      "mwh_value": "{value} MWh",
      "committed": "Committed",
      "escrowed": "Escrowed",
      "available": "Available",
      "planned": "Planned",
      "delivered": "Delivered",
      "shortfall": "Not covered",
      "fill_of_total": "{filled} of {total} MWh",
      "no_window_end": "no delivery deadline",
      "not_priced": "Not priced yet",
      "price_per_mwh": "{price} €/MWh",
      "price_range_per_mwh": "{min} – {max} €/MWh",
      "retry": "Try again",
      "unknown": "Unknown",
      "not_backed": "Not backed yet",
      "yes": "Yes",
      "no": "No",
      "none": "None",
      "actions": "Actions",
      "status": {
        "draft": "Draft",
        "confirmed": "Confirmed",
        "completed": "Completed",
        "cancelled": "Cancelled",
        "archived": "Archived",
        "escrow_remaining": "Escrow left behind",
        "pay_as_produced": "Pay-as-produced"
      },
      "super_admin_only_create": "Only a super admin can create deals.",
      "support": {
        "mixed": "Mixed: supported or unknown",
        "unsupported": "Unsupported"
      },
      "period_width": {
        "month": "Months",
        "quarter": "Quarters",
        "half_year": "Half-years",
        "year": "Years"
      },
      "device_count": "{count} devices | {count} device | {count} devices",
      "deal_badges": {
        "under_committed": "{mwh} MWh not backed",
        "volume_over": "{mwh} MWh over the deal volume",
        "volume_under": "{mwh} MWh under the deal volume"
      },
      "deal_text": {
        "description_help": "Printed on the producers' invoices and shown to producers in their sales list.",
        "internal_notes": "Internal notes",
        "internal_notes_help": "For staff only: never shown to producers or buyers, and never printed."
      }
    },
    "overview": {
      "title": "Forward sales",
      "description": "Action items, forward volume sold per production year, upcoming deliveries and the deals you manage.",
      "year_totals": {
        "title": "Sold forward by production year",
        "description": "The forward volume sold of each production year and its average buyer price.",
        "loading": "Loading the yearly totals",
        "empty": "Nothing is sold forward yet.",
        "load_failed": "The yearly forward totals could not be loaded.",
        "volume": "{mwh} MWh",
        "average": "€{price}/MWh avg",
        "no_average": "no priced volume yet",
        "unpriced": "{mwh} MWh without a price",
        "contents": {
          "intro": "The volume counts confirmed and completed deals, plus what cancelled deals had already shipped, but no drafts. By deal type:",
          "fixed_volume": "Fixed-volume deals: their delivery plan, each period counted in the year it starts, whether shipped or not.",
          "pay_as_produced": "Pay-as-produced contracts: what each month shipped, or its nominated volume until it ships."
        }
      },
      "attention": {
        "title": "Needs attention",
        "description": "Items across this account's mandates and deals. They clear themselves once resolved.",
        "loading": "Loading attention items",
        "empty": "Nothing needs your attention.",
        "load_failed": "The attention items could not be loaded.",
        "status": {
          "stale_draft": "Stale draft",
          "open_slices": "Unbacked",
          "escrow_shortfall": "Short",
          "producer_price_missing": "No producer price",
          "price_conflict": "Price conflict",
          "delivery_unpriced": "No price",
          "free_escrow": "Escrow to return",
          "infeasible": "Oversold",
          "mandate_escrow_missing": "Missing",
          "other": "Other",
          "coarse_issuance": "Issuance",
          "allocation_not_ready": "Not allocating",
          "contango_discouraged": "Contango 20%"
        },
        "action": {
          "open_mandate": "Open mandate",
          "open_deal": "Open deal",
          "review_draft": "Review draft",
          "deliver": "Open delivery",
          "return_escrow": "Return escrow",
          "other": "Open"
        },
        "reason": {
          "stale_draft": "Draft deal, {days} days without confirmation. Its commitments still reserve inventory, but nothing is allocating yet.",
          "open_slices": "{mwh} MWh of this deal is not backed by a mandate yet.",
          "escrow_shortfall": "{mwh} MWh of committed volume is still missing from escrow.",
          "producer_price_missing": "Swap delivery due {date}: no producer price is set, so its producers invoice at the sell price.",
          "price_conflict": "Delivery due {date}: {company} sells through differently priced mandates ({mandates}), so the delivery cannot ship.",
          "delivery_unpriced": "No delivery is missing a buyer price. | {count} delivery ({mwh} MWh) has no buyer price, so the yearly forward totals leave it out. | {count} deliveries ({mwh} MWh) have no buyer price, so the yearly forward totals leave them out.",
          "free_escrow": "{mwh} MWh is in escrow with no delivery left to fill. Return it to the owning companies.",
          "infeasible": "Expected production falls {mwh} MWh short of what the mandate owes in {period}.",
          "infeasible_periods": "Expected production falls short of what the mandate owes in {periods}.",
          "mandate_escrow_missing": "{mwh} MWh committed in {period} is missing from escrow; the registry should already have issued it.",
          "coarse_issuance": "Certificates are issued {issued}, but the mandate lists {listed}: those devices cannot deliver its listed volumes. List {widest} or longer.",
          "allocation_not_ready": "Nightly allocation skips {companies} (not allocation-ready), so their production never reaches escrow for the deals this mandate backs.",
          "contango_discouraged": "This mandate sells only at 20% or more above the spot price, which rarely holds, so its volume is seldom sold. Consider “Only sell in contango” instead."
        },
        "issued_in_region": "{width} ({region})",
        "period_mwh": "{period} ({mwh} MWh)",
        "width_adverb": {
          "month": "monthly",
          "quarter": "quarterly",
          "half_year": "half-yearly",
          "year": "yearly"
        }
      },
      "deliveries": {
        "title": "Upcoming deliveries",
        "description": "Planned deliveries of the deals you manage, nearest window end first. Missing volume is what the delivery's escrow still lacks, grouped by the device countries of the mandates that committed it. A pay-as-produced month is shown against its nominated target, which is monitored, not owed.",
        "loading": "Loading deliveries",
        "empty": "No deliveries match these filters.",
        "load_failed": "The upcoming deliveries could not be loaded.",
        "download_xlsx": "Download xlsx",
        "transaction": "Transaction",
        "window": "Delivery window",
        "deal": "Deal",
        "escrowed_of_planned": "Escrowed / planned · missing by country",
        "open_transaction": "Open transaction",
        "open_deal": "Open deal",
        "escrowed_of_target": "{escrowed} of {target} MWh target",
        "on_or_before": "on or before {date}",
        "short": "short",
        "due_today": "due today",
        "due_tomorrow": "due tomorrow",
        "due_in_days": "in {days} days",
        "overdue_one_day": "1 day overdue",
        "overdue_days": "{days} days overdue",
        "transaction_status": {
          "draft": "Draft",
          "pending_buyer_details": "Awaiting buyer details",
          "pending_contracts": "Awaiting contracts",
          "ready_to_transfer": "Ready to transfer",
          "delivered": "Delivered",
          "completed": "Completed"
        },
        "delivered_awaiting_completion": "delivered, awaiting payment",
        "filters": {
          "status": "Transaction status",
          "window_end": "Delivery window ends",
          "window_end_any": "Any date",
          "deal_name": "Deal name"
        }
      },
      "deals": {
        "title": "Deals you manage",
        "description": "Full detail (delivery plan, commitments, escrow attribution) is on the deal page.",
        "loading": "Loading deals",
        "empty": "No deals match these filters.",
        "load_failed": "The deals could not be loaded.",
        "new_deal": "New forward draft",
        "new_pap_deal": "New pay-as-produced deal",
        "no_buyer": "Not set",
        "no_price": "Not set",
        "price_range": "{min} - {max}",
        "deliveries_of": "{done} of {total}",
        "stale": "{days} d old",
        "infeasible": "Infeasible",
        "filters": {
          "status": "Status",
          "status_all": "All statuses",
          "name": "Deal name",
          "name_placeholder": "Any name",
          "mandate": "Contains mandate",
          "mandate_placeholder": "Mandate name",
          "company": "Contains company",
          "company_placeholder": "Company name"
        },
        "columns": {
          "deal": "Deal",
          "buyer": "Buyer",
          "quarters": "Production",
          "volume": "Deal volume (MWh)",
          "price": "Price (€/MWh)",
          "deliveries": "Deliveries completed",
          "status": "Status"
        }
      }
    },
    "mandates": {
      "intro": {
        "title": "Sell your future production in advance",
        "body": "With forward sales, you sell Guarantees of Origin for production that hasn't been issued yet, at a price agreed today. Soldera Forward Advantage helps you secure predictable revenue and reduce the risk of price swings, without having to manage your forward sales day to day. To start, create a forward sales mandate: choose which of your companies take part and how much they offer in each period. Soldera sells that volume to buyers in its network, and the certificates are delivered as the registry issues them. If one company produces less than expected, the other companies in the mandate can cover the shortfall with their extra production.",
        "cta": "Create your first mandate"
      },
      "guide": {
        "title": "About forward sales"
      },
      "loading": "Loading mandates",
      "empty": "No mandates match these filters yet.",
      "load_failed": "The mandate timeline could not be loaded.",
      "attention": {
        "description": "What to change about your mandates. Items clear themselves once resolved."
      },
      "restricted_access": "Your company belongs to this mandate. Access to every member company is required to view its details.",
      "status_filter": "Status",
      "status_filter_all": "All statuses",
      "company_filter": "Companies",
      "company_filter_all": "All companies",
      "name_filter": "Mandate name",
      "name_filter_placeholder": "Search by name",
      "name_filter_no_matches": "No mandates match this name.",
      "status": {
        "active": "Active",
        "archived_open": "Archived, still owing",
        "archived_settled": "Archived and settled"
      },
      "year_previous": "Previous year",
      "year_next": "Next year",
      "band_title": "All mandates",
      "band_column": "{quarter}: {listed} MWh listed, {committed} MWh committed, {escrowed} MWh escrowed, {available} MWh available",
      "band_available": "{quarter}: {value} MWh available of {listed} MWh listed",
      "band_committed": "{quarter}: {value} MWh committed, not yet escrowed ({committed} MWh committed in total)",
      "band_escrowed": "{quarter}: {value} MWh escrowed",
      "infeasible_periods": "This mandate has sold more than its devices are expected to produce in {periods}.",
      "row_subtitle": "{companies} · {devices} · {shape}",
      "row_companies": "{count} companies | {count} company | {count} companies",
      "pap_window": "Contract window · {escrowed} MWh escrowed · {delivered} MWh delivered",
      "cell_figure": "{committed} of {listed}",
      "cell_escrowed_figure": "{value} escrowed",
      "cell_available": "{mandate}, {quarter}: {value} MWh still available",
      "available_help": "For each period, the most one new deal could still take. Periods share commitments made over wider periods, so these figures do not add up.",
      "cell_committed": "{mandate}, {quarter}: {value} MWh committed, {escrowed} MWh of it escrowed",
      "cell_stranded": "{mandate}, {quarter}: {value} MWh escrowed with no live commitment",
      "cell_empty": "{mandate}, {quarter}: nothing listed",
      "cell_deal_tooltip": "{deal} · {value} MWh, {escrowed} MWh escrowed · {status} · delivery by {window}",
      "entry_width": {
        "quarter": "Quarterly",
        "month": "Monthly",
        "half_year": "Half-yearly",
        "half_year_recommended": "Half-yearly (recommended)",
        "year": "Yearly"
      },
      "listing_kind": {
        "one_off": "One-off",
        "recurring": "Recurring",
        "pay_as_produced": "Pay-as-produced"
      },
      "options": {
        "title": "Options",
        "minimum_price": "Minimum price",
        "minimum_price_placeholder": "No floor",
        "minimum_price_hint": "A deal may not price this mandate's volume below this.",
        "minimum_price_negative": "The minimum price cannot be negative.",
        "minimum_price_too_precise": "The minimum price can have at most {decimals} decimals.",
        "contango": {
          "label": "Contango",
          "help": "Contango means the forward price is above the spot price on the day the sale is made.",
          "none": "Sell regardless of the spot price",
          "any": "Only sell in contango",
          "at_least_20_percent": "Only sell in contango, 20% or more above spot (discouraged)",
          "discouraged": "A 20% premium over spot is rare, so this mandate's volume is seldom sold. Consider “Only sell in contango” instead."
        },
        "archive_on_delivery": "Archive the mandate once its last commitment is delivered",
        "archive_on_delivery_hint": "For a mandate that exists for a single contract."
      },
      "advanced_listing": {
        "label": "Show advanced listing options",
        "hint": "Everyone who edits this mandate gets every listing shape: one-off, other period widths and pay-as-produced. Without it the editor offers only a recurring listing's quarters.",
        "locked": "Stays on while the listing is anything other than recurring and quarterly, or while the mandate sells ahead."
      },
      "volumes": {
        "title": "Listed volume",
        "intro": "Enter how much this mandate offers for forward sale in each period. The volume is for the whole mandate, not for each company. Listed volume is not binding and you can change it at any time. It becomes binding once it is committed to a deal, and committed volume must be delivered even if you lower the listing later. You can enter MWh or a % of the estimated production. A % is saved as MWh.",
        "previewing": "Updating",
        "mode": "How volumes are stated",
        "entry_width": "Period width",
        "entry_width_hint": "How long each period you list is. Your volume can be sold together with your other periods as a longer period, but never split into shorter ones.",
        "month_note": "Only usable in registries that use monthly issuance.",
        "month_warning": "This is an advanced feature. Monthly listings do not support balancing: one month's overproduction cannot cover another month's underproduction.",
        "half_year_note": "A half-yearly mandate can only back half-year and full-year production periods within deliveries.",
        "year_note": "A yearly mandate can only back full-year production periods within deliveries.",
        "pay_as_produced_note": "A pay-as-produced mandate sells its devices' whole output, so it lists no volumes, and its devices cannot belong to any other mandate.",
        "period": "Period",
        "share_of_estimate": "% of estimate",
        "feedback": "Committed · free · estimated",
        "mwh_for": "MWh listed for {period}",
        "share_for": "Share of the estimate for {period}",
        "remove_period": "Remove {period}",
        "no_rows": "No periods listed yet.",
        "add_period": "Add period",
        "whole_year": "Whole year",
        "no_estimate": "No estimate yet",
        "feedback_line": "{committed} committed · {free} free · {estimated} estimated",
        "free_hint": "Free is what can still be sold today: nothing once a period's production is over, nothing the sales strategy has not released yet, and never more than the quarter, half-year and year around it have left.",
        "over_committed_note": "The following existing commitments remain unaffected:",
        "over_committed_period": "{period}: {committed} MWh committed",
        "over_estimate": "{percent}% of the estimate",
        "errors": {
          "period_duplicate": "This period is already listed on another row."
        },
        "how_it_works": "How listing works"
      },
      "production_range": {
        "limited": "Restrict listing to a fixed production period",
        "first_month": "First production month",
        "last_month": "Last production month",
        "hint": "New deals can include only production in these months. A recurring listing lists nothing outside them; a pay-as-produced contract must lie within them. Leave a side empty for no limit.",
        "no_limit": "No limit",
        "last_before_first": "The last month cannot be before the first."
      },
      "members": {
        "title": "Companies",
        "description": "Whose production this mandate sells.",
        "placeholder": "Select companies",
        "not_enabled": "Forward sales are not enabled. Contact support.",
        "not_allocation_ready": "Not set up for nightly allocation, so nothing will be escrowed for it.",
        "no_candidates": "No companies match.",
        "at_least_one": "A mandate needs at least one company.",
        "manage_account": "To change this mandate's companies, manage an account that owns them.",
        "own_companies_only": "Only your own account's companies are offered. To build a mandate from a client's companies, manage their account."
      },
      "devices": {
        "title": "Devices",
        "description": "Every registered device of the companies above. Estimates are net of PPA.",
        "use_allowlist": "Sell from selected devices only",
        "empty": "No devices.",
        "loading": "Loading the companies' devices…",
        "include": "Include {device}",
        "device": "Device",
        "company": "Company",
        "obligations": "Obligations",
        "mandate_count": "{n} mandate | {n} mandates",
        "ppa_count": "{n} PPA | {n} PPAs",
        "obligations_note": "Everything already claiming this device: the forward sales mandates it belongs to (overlap is allowed; the listed volumes are what compete), plus any PPAs covering it. A PPA is served ahead of forwards, so its volume never reaches a commitment. A device in a pay-as-produced mandate is exclusive to that mandate and cannot be added here.",
        "country": "Country",
        "technology": "Technology",
        "cod": "Commissioned",
        "support": "Support",
        "ecolabels": "Ecolabels",
        "estimate": "Estimate (MWh)",
        "estimate_note": "Estimates cover the mandate's listed periods and already exclude each device's PPA share.",
        "unnamed": "Device {id}",
        "stale_deleted_by_registry": "Deleted by the registry. Untick it to remove it from the mandate.",
        "stale_not_registered": "No longer registered. Untick it to remove it from the mandate.",
        "include_all": "Include all devices"
      },
      "eligibility": {
        "title": "Deal eligibility",
        "description": "What a deal restricting each dimension would find here. The worst device sets every value.",
        "country_tier": "Countries",
        "tier": {
          "standard_aib_gc": "Standard AIB GC",
          "aib_outside_standard": "AIB, outside the standard set",
          "pl_be": "Poland / Belgium",
          "non_aib": "Outside AIB",
          "unknown": "Not resolved"
        },
        "technology_mix": "Technologies",
        "oldest_cod": "Oldest commissioning date",
        "cod_claim_year": "For claim year {year}, the preferred commissioning date is on or after {cutoff}. This checks age only.",
        "cod_preferred": "All devices meet this age preference.",
        "cod_not_preferred": "The mandate does not meet this age preference, or commissioning dates are missing.",
        "cod_standards_note": "Some reporting standards limit how old a device may be: RE100, for example, accepts only devices commissioned or repowered within the last 15 years.",
        "supported": "Production support",
        "ecolabels": "Ecolabels",
        "through_year": "through {year}",
        "ecolabel_requirements": {
          "ekoenergy": "Requires every device to be pre-approved by EKOenergy.",
          "okpower": "Soldera's assessment of the OK-power criteria: every device pre-approved by EKOenergy, unsupported, and wind or solar.",
          "okpower_new": "Soldera's assessment of the OK-power criteria: every device pre-approved by EKOenergy, unsupported, and solar at most 5 years old or wind at most 4 years old in the production year."
        },
        "failing_device_count": "not met by {count} of {total} devices",
        "failing_device_count_named": "not met by {count} of {total} devices: {devices}",
        "blocker_device_count": "{count} of {total} devices",
        "blocker_device_count_named": "{count} of {total} devices: {devices}",
        "no_issues": "No issues reported for this dimension. Deal-specific restrictions still apply.",
        "no_devices": "No devices in this mandate.",
        "all_qualify": "All devices qualify",
        "guide": {
          "title": "Optimizing eligibility",
          "intro": "Group devices that the same buyers would accept, so that no single device keeps a mandate out of a deal:",
          "unsupported": "Unsupported hydro, solar and wind from one country in one mandate. Most buyers accept these.",
          "biomass": "Biomass and biogas in a separate mandate, because many buyers exclude them.",
          "issuance": "Devices in registries that don't issue every month in a separate mandate, with a period length that matches how often the registry issues.",
          "several_mandates": "A company can belong to several mandates. To put only some of its devices in this mandate, turn on “{option}” under {section} and tick the ones to include."
        }
      },
      "commitments": {
        "title": "Commitments on this mandate",
        "description": "What has been sold from it.",
        "loading": "Loading commitments",
        "empty": "Nothing has been sold from this mandate.",
        "all_completed": "Every commitment on this mandate is completed.",
        "show_completed": "Show completed ({count})",
        "period": "Production period",
        "escrowed": "Escrowed",
        "window": "Delivery window",
        "price": "Price",
        "status": "Status",
        "deal": "Deal",
        "open_deal": "Open the deal",
        "committed_on": "Committed on",
        "on_or_before": "on or before {date}"
      },
      "escrow_remaining": {
        "description": "Your companies are no longer in this mandate, but the certificates below stay in escrow until the deliveries they back are shipped or returned. Nothing else about the mandate is shown.",
        "empty": "Nothing of yours is left in this mandate.",
        "period": "Period",
        "escrowed": "In escrow",
        "status": "Deal status",
        "window_end": "Delivery by",
        "price": "Price"
      },
      "editor": {
        "loading": "Loading the mandate",
        "not_found_title": "This forward sales mandate is not available",
        "not_found_body": "It does not exist, or it belongs to companies you do not have access to.",
        "title": "Forward sales mandate",
        "new_title": "New forward sales mandate",
        "description": "A forward sales mandate states what volume its companies offer for forward sale, and from which devices.",
        "name": "Name",
        "name_hint": "Shown to everyone who can see this mandate, including owners of a member company who can't open it, and to Soldera when it builds deals. Name the group and what it sells, e.g. \"Acme wind 2027\". Leave out buyer names and prices.",
        "mandate_description": "Description",
        "mandate_description_hint": "Notes for the member companies, such as what the group agreed, who to contact, or anything to keep in mind when selling this mandate. Anyone who can open the mandate can read it. It is for information only: what can be sold is set by the listed volumes and options.",
        "delete": "Delete",
        "confirm_delete": "Delete this mandate? Nothing has ever been committed against it, so nothing is lost.",
        "archive": "Archive",
        "unarchive": "Unarchive",
        "discard": "Discard changes",
        "save": "Save",
        "save_anyway": "Save anyway",
        "save_failed": "The mandate could not be saved. Check the form and try again.",
        "unsaved_changes": "You have unsaved changes.",
        "close_confirm": "Close the mandate and discard your unsaved changes?",
        "read_only": "You can view this mandate but not change it.",
        "details_title": "Name and description",
        "name_required": "Enter a name for the mandate."
      },
      "wizard": {
        "step_members": "Companies & devices",
        "step_listing": "Listings",
        "step_confirm": "Confirm",
        "create": "Create mandate"
      },
      "summary": {
        "title": "Summary",
        "companies": "Companies",
        "devices": "Devices",
        "devices_all": "All devices ({count})",
        "devices_allowlisted": "No devices selected | {count} selected device | {count} selected devices",
        "listing": "Listing",
        "obligation_note": "These are exact volumes, not production estimates. Listing them is not binding, but once a deal pulls from this mandate, the companies in it are legally obliged to deliver exactly the volume that deal took, whatever their devices produce.",
        "obligation_note_pay_as_produced": "Once a deal pulls from this mandate, the companies in it are legally obliged to deliver what their devices produce over the deal's window."
      },
      "cell_sellable_now": "Sellable now: {value} MWh"
    },
    "sales_strategy": {
      "title": "Sales strategy",
      "help": "How this mandate's listed volume is released for sale over time. Selling a production year in parts, at different times, spreads its price risk.",
      "split": {
        "asap": "As soon as possible",
        "half_yearly": "Sell twice a year",
        "quarterly": "Sell four times a year"
      },
      "split_help": {
        "asap": "releases everything at once",
        "half_yearly": "releases the volume in two equal parts",
        "quarterly": "releases the volume in four equal parts (recommended)"
      },
      "sell_ahead": {
        "label": "Sell ahead",
        "help": "How much of each production year is sold two years before production. The rest is sold during the year before production.",
        "next_year_only": "Next year only",
        "two_years_ahead": "Two years ahead",
        "preset": "{percent}%",
        "share_of": "of each production year",
        "lead_next_year": "Each production year is sold during the year before it.",
        "lead_ahead": "Each production year is sold over two years: {early}% during the year two before production, the remaining {rest}% during the year before.",
        "cadence": {
          "asap": "It is all released on 1 January.",
          "half_yearly": "It is released in two equal parts, on 1 January and 1 July.",
          "quarterly": "It is released in four equal parts, on 1 January, 1 April, 1 July and 1 October."
        },
        "cadence_ahead": {
          "asap": "Each share is released at once, on 1 January.",
          "half_yearly": "Each share is released in two equal parts, on 1 January and 1 July.",
          "quarterly": "Each share is released in four equal parts, on 1 January, 1 April, 1 July and 1 October."
        },
        "bar_caption": "Example: how {year} production is sold",
        "bar_segment": "{year} · {percent}%",
        "release_more": "Saving releases {mwh} MWh more of {year} production for sale at once, because its earlier sales windows have already opened.",
        "release_less": "Saving holds back {mwh} MWh of {year} production that is released for sale today."
      },
      "summary": "{split}, {horizon}",
      "summary_split": {
        "asap": "as soon as possible",
        "half_yearly": "twice a year",
        "quarterly": "four times a year"
      },
      "summary_next_year": "next year's production",
      "summary_ahead": "{percent}% two years ahead",
      "future_only": "A change applies to future sales only. Volume already committed stands.",
      "schedule_title": "Sales schedule",
      "schedule_open": "Show sales schedule",
      "schedule_pending": "The sales schedule appears here once the mandate can be previewed.",
      "schedule_empty": "Nothing is listed for the coming production years yet.",
      "schedule_timeline": "Sales timeline for {year}",
      "schedule_production": "Production",
      "schedule_auction": "Q{quarter} auction",
      "schedule_total": "Total",
      "schedule_opens_on": "Opens on {date}",
      "schedule_group_early": "{year} production · early share {percent}%",
      "schedule_group_early_note": "(the remaining {percent}% in {year})",
      "schedule_group_rest": "{year} production · remaining {percent}%",
      "schedule_group_rest_note": "({percent}% released in {year})",
      "commitments_stand_inline": "Some commitments are above what this strategy releases today. They stand; the strategy applies to new sales.",
      "held_back": "{mwh} MWh held back by its sales strategy ({strategy}).",
      "held_back_next_release": "{mwh} MWh held back by its sales strategy ({strategy}); {next} MWh more is released on {date}.",
      "held_back_reason": "held back by its sales strategy",
      "held_back_reason_until": "held back by its sales strategy until {date}",
      "override": {
        "label": "Ignore all sales strategy (DANGEROUS)",
        "banner_title": "Selling beyond the producer's sales strategy",
        "subject": "{mandate}: {period}",
        "beyond_line": "{subject} — {mwh} MWh beyond its sales strategy ({strategy}).",
        "beyond_line_next_release": "{subject} — {mwh} MWh beyond its sales strategy ({strategy}); next release on {date}.",
        "ignored_nothing_beyond": "Sales strategy ignored — no take exceeds it yet",
        "ignored_figures_unknown": "Sales strategy ignored — its figures could not be read; the save reports any volume beyond it"
      }
    },
    "picker": {
      "mode": {
        "existing_inventory": "Existing inventory",
        "future_inventory": "Future inventory"
      },
      "new_pap_deal": "New pay-as-produced deal →",
      "deal": {
        "title": "Deal",
        "description": "The buyer, the prices and the delivery plan are set on the deal page once this draft exists."
      },
      "filters": {
        "title": "Production range & quick filters"
      },
      "mandates": {
        "title": "Select mandates"
      },
      "cancel": "Cancel",
      "confirm": "Create draft deal",
      "confirming": "Creating…",
      "footer_note": "Creating the deal writes a draft with one commitment per mandate and a delivery scaffold. Buyer details, prices and the delivery plan are set on the deal page.",
      "criteria": {
        "description": "What the buyer is committing to. The deal is held to these criteria for the rest of its life.",
        "name": "Deal name",
        "name_placeholder": "e.g. Nordic buyer 2026",
        "description_label": "Description",
        "description_placeholder": "Optional text for the invoice line",
        "countries": "Countries",
        "countries_all": "Any country",
        "countries_hint": "Pre-filled with the standard AIB GC countries. Clear the field to allow any country.",
        "technologies": "Technologies",
        "technologies_all": "Any technology",
        "technologies_advanced": "Advanced",
        "cod_from": "COD from",
        "cod_until": "COD until",
        "cod_hint": "Limits the deal to devices whose commercial operation date falls in this range.",
        "cod_calculator": "COD calculator",
        "cod_calculator_modal": {
          "title": "COD calculator",
          "description": "Sets COD from so that no device is older than the maximum age on the delivery date.",
          "delivery_date": "Delivery date",
          "max_age": "Maximum device age at delivery",
          "years": "years",
          "result": "COD from {date}",
          "apply": "Apply"
        },
        "support": "Production support",
        "support_any": "Either",
        "support_no": "Unsupported only",
        "ecolabels": "Ecolabels",
        "ecolabels_all": "No ecolabel requirement",
        "ecolabels_hint": "OK-power new expires with a device's age, so a mandate can qualify for an early production year and fail a later one.",
        "min_price_filter": "Hide mandates priced above",
        "min_price_filter_hint": "A view filter only. It is not saved with the deal.",
        "quick_filters": "Quick filters",
        "quick_aib_gc": "Standard AIB GC",
        "quick_hsw": "HSW",
        "quick_biomass": "@:common.technology.biomass",
        "quick_nuclear": "Nuclear",
        "name_required": "Give the deal a name."
      },
      "ecolabel": {
        "ekoenergy": "EKOenergy pre-approved",
        "okpower": "OK-power compatible",
        "okpower_new": "OK-power new compatible"
      },
      "period": {
        "title": "Production quarters",
        "from": "From",
        "until": "Until",
        "invalid_range": "The range ends before it starts.",
        "selected": "{count} quarters: {periods}",
        "cover_note": "Each mandate sells the range at its own width: by quarter where its listings and registry allow, otherwise by half-year or year. A mandate that cannot cover the whole range is left out. Each slice ships after the quarter it ends in."
      },
      "take": {
        "filter_mandate": "Mandate or company",
        "auto_distribute": "Auto-distribute",
        "spread": "Spread over mandates",
        "target": "MWh",
        "target_label": "Target volume",
        "clear": "Clear",
        "hidden_takes": "Taken mandates hidden by the filters: {count} ({mwh} MWh).",
        "show_hidden_takes": "Show them",
        "remove_hidden_takes": "Remove their takes",
        "mandate": "Mandate",
        "technology": "Technology",
        "country": "Country",
        "cod": "Oldest COD",
        "ecolabels": "Ecolabels",
        "support": "Support",
        "conditions": "Conditions",
        "take": "Take (MWh)",
        "no_floor": "No floor",
        "floor_value": "{value} €/MWh",
        "contango": {
          "any": "sells only in contango",
          "at_least_20_percent": "sells only ≥ 20% above spot"
        },
        "contango_filter": {
          "none": "No contango condition",
          "any": "Any contango",
          "at_least_20_percent": "Contango ≥ 20%"
        },
        "cadence": "These devices issue in periods wider than the mandate's slices for this range.",
        "allocation_not_ready": "Allocation is switched off for {companies}, so nothing will be escrowed for them.",
        "capacity_cap": "At most {value} MWh over the picked range.",
        "capacity_period": "{period}: {value}",
        "row_subtitle": "{companies} · {devices}",
        "empty": "No mandate can serve this product over this range.",
        "loading": "Looking for mandates",
        "refreshing": "Refreshing",
        "refresh_pending": "Wait for the take table to refresh before creating the deal.",
        "load_failed": "The take table could not be loaded.",
        "hint_floor": "A delivery from this selection may not be priced below {value} €/MWh.",
        "warnings_title": "Worth checking",
        "contango_check": {
          "any": "Check the spot reference manually (contango)",
          "at_least_20_percent": "Check the spot reference manually (contango 20%)"
        },
        "ineligible_title": "Left out ({count})",
        "ineligible_hint": "Mandates you may draw on that this product or range excludes."
      },
      "summary": {
        "all": "All mandates",
        "taken": "Taken",
        "mandates_count": "{count} mandates",
        "by_period": "By production period",
        "by_period_estimate": "Estimated split. The exact one is decided when the deal is created.",
        "by_country": "By country",
        "by_price": "By price condition",
        "by_technology": "By technology",
        "by_cod": "Commercial operation date",
        "re100": "RE100 applicable",
        "by_ecolabel": "Ecolabel status",
        "by_support": "Support status",
        "cod_young": "COD ≤5 years",
        "cod_middle": "COD 6–15 years",
        "cod_old": "COD >15 years",
        "mandate_qualifications": "Qualities describe whole mandates, not allocated certificates. COD uses the oldest device; RE100 and ecolabels require every device to qualify throughout the range.",
        "judged_at": "judged at {date}",
        "nothing_taken": "Nothing taken yet."
      },
      "errors": {
        "no_takes": "Take volume from at least one mandate.",
        "create_failed": "The deal could not be created.",
        "over_capacity": "A take is above what its mandate may sell. Lower it to the mandate's cap first."
      }
    },
    "pap": {
      "title": "New pay-as-produced deal",
      "description": "A pay-as-produced deal buys one mandate's whole output, month by month, against a nominated schedule.",
      "mandate": "Pay-as-produced mandate",
      "mandate_hint": "Only pay-as-produced mandates can back this deal; their devices belong to no other mandate.",
      "mandate_empty": "There is no pay-as-produced mandate yet. Create one on the producer's dashboard first.",
      "mandate_devices": "{devices} devices · {companies} companies",
      "mandate_blocked_choose_another": "Choose another mandate to create the deal.",
      "name": "Deal name",
      "name_placeholder": "e.g. Hydro offtake 2027",
      "description_label": "Description",
      "description_placeholder": "Optional text for the invoice line",
      "unit_price": "Unit price",
      "unit_price_hint": "Every month of the contract is invoiced at this price.",
      "window": "Contract window",
      "window_start": "First month",
      "window_end": "Last month",
      "window_invalid": "The window ends before it starts.",
      "window_missing": "Pick both the first and the last month of the window.",
      "window_too_long": "A contract window covers at most {count} months.",
      "schedule": "Nominated schedule",
      "schedule_hint": "One target per month of the window. Production is compared against it month by month.",
      "schedule_total": "{value} MWh nominated over {count} months",
      "tolerance": "Volume tolerance",
      "tolerance_hint": "How far a month may deviate from its target before it is flagged.",
      "context_failed": "The owner options could not be loaded.",
      "create": "Create deal",
      "creating": "Creating…",
      "cancel": "Cancel",
      "create_failed": "The deal could not be created.",
      "load_failed": "The mandates could not be loaded.",
      "loading": "Loading mandates",
      "production_range_from_until": "This mandate sells only production from {from} until {until}.",
      "production_range_from": "This mandate sells only production from {from}.",
      "production_range_until": "This mandate sells only production until {until}.",
      "window_outside_range": "The contract window must lie within the production this mandate sells."
    },
    "transaction_header": {
      "title": "Forward delivery",
      "deal": "Deal",
      "window_open": "Deliver on or before {date}",
      "window_range": "Deliver between {start} and {end}",
      "escrowed_of_planned": "{escrowed} of {planned} MWh escrowed",
      "managed_note": "Items, amounts, buyer details and prices come from the deal and are changed there.",
      "open_deal": "Open the deal",
      "deal_notes": "Deal notes",
      "delivery_notes": "Delivery notes"
    },
    "deals": {
      "loading": "Loading the deal…",
      "not_found_title": "Deal not found",
      "not_found_body": "This deal does not exist, or it is not yours to see.",
      "load_failed_title": "The deal could not be loaded",
      "load_failed_body": "Something went wrong on our side. Try again in a moment.",
      "draft_warning": "Draft deal: its deliveries are not shown under Upcoming deliveries and no certificates are allocated until the deal is confirmed.",
      "common": {
        "cancel": "Cancel",
        "close": "Close",
        "commitment_gone": "This commitment is no longer on the deal."
      },
      "header": {
        "back": "← Forwards",
        "buyer": "Buyer: {buyer}",
        "buyer_missing": "No buyer entered yet",
        "signed_at": "signed {date}"
      },
      "badges": {
        "escrow_shortfall": "{mwh} MWh short of escrow",
        "infeasible": "{mandate} cannot cover {period} — {mwh} MWh short",
        "stale_draft": "Old draft",
        "drift_report": "{count} devices no longer fit | {count} device no longer fits | {count} devices no longer fit",
        "drift_report_line": "{device}: {reasons}",
        "device_number": "Device {id}",
        "free_escrow": "{mwh} MWh escrow awaiting return"
      },
      "metadata": {
        "title": "Buyer & contract",
        "edit": "Edit",
        "edit_title": "Buyer & contract details",
        "save": "Save",
        "name": "Deal name",
        "description": "Description",
        "buyer": "Buyer",
        "emails": "Buyer emails",
        "registration_authority": "Registration authority",
        "billing_country": "Billing country",
        "deal_volume": "Deal volume",
        "signed_at": "Signed",
        "created_at": "Created",
        "confirmed_at": "Confirmed",
        "links": "Links",
        "contract_links": "Contract",
        "transaction_link": "Transaction",
        "offering_sheets": "Offering sheets",
        "offering_sheets_help": "Comma-separated links, oldest first. Generating a sheet appends to this list; remove old ones here when it is full.",
        "transaction_link_invalid": "Enter a single http:// or https:// link.",
        "shipped_keep_details": "This deal has shipped {count} deliveries. Their transactions and invoices keep the buyer and contract details they shipped with; a change here reaches only deliveries not yet shipped. | This deal has shipped {count} delivery. Its transaction and invoices keep the buyer and contract details it shipped with; a change here reaches only deliveries not yet shipped. | This deal has shipped {count} deliveries. Their transactions and invoices keep the buyer and contract details they shipped with; a change here reaches only deliveries not yet shipped.",
        "not_set": "Not set"
      },
      "criteria": {
        "title": "Eligibility",
        "edit": "Edit",
        "save": "Save eligibility",
        "locked": "Locked",
        "countries": "Countries",
        "technologies": "Technologies",
        "cod": "Commissioning date",
        "cod_from": "COD from",
        "cod_until": "COD until",
        "cod_range": "{from} — {until}",
        "any": "any",
        "support": "Production support",
        "support_any": "Either",
        "support_unsupported_only": "Unsupported only",
        "ecolabels": "Ecolabels",
        "unrestricted": "Unrestricted",
        "conflicts_help": "Saving checks the change first. A change that conflicts with backing or escrow the deal still delivers is refused; nothing is released or returned for it.",
        "conflicts_blocking": "This change conflicts with what the deal still delivers. Clear these first, then save again:",
        "conflicts_warning": "Already delivered under the current criteria. Saving leaves these as they are:",
        "save_anyway": "Save anyway",
        "ecolabel": {
          "ekoenergy": "EKOenergy pre-approved",
          "okpower": "OK-power compatible",
          "okpower_new": "OK-power new compatible"
        }
      },
      "plan": {
        "delivery_id": "Delivery id {id}",
        "profile": {
          "title": "Estimated profile",
          "judged_at": "COD age and RE100 are judged at the end of the delivery window, {date}.",
          "combined_title": "Estimated profile (all deliveries)",
          "judged_per_delivery": "COD age and RE100 are judged at each delivery's window end."
        },
        "backing": {
          "title": "Backing mandates",
          "not_backed": "{mwh} MWh not backed yet"
        },
        "title": "Delivery plan",
        "generate_offering_sheet": "Generate offering sheet",
        "open_offering_sheet": "Open offering sheet",
        "edit_plan": "Edit plan",
        "empty": "This deal has no deliveries yet.",
        "delivery": "Delivery",
        "period": "Production period",
        "escrowed_of": "Escrowed / planned",
        "backed_by": "Backed by",
        "backed_by_commitment": "Backed by commitment {id}. See the Commitments table.",
        "open_volume": "Open",
        "no_slices": "Nothing is planned in this delivery yet.",
        "n_short": "{mwh} short",
        "n_open": "{mwh} open",
        "remove": "Remove",
        "actions": {
          "menu": "Actions for {period}",
          "resize": "Resize",
          "resize_tooltip": "Change the committed volume for this production period. It cannot be reduced below the volume already in escrow.",
          "split_move": "Split-move",
          "split_move_tooltip": "Move all or part of this committed volume to another delivery; its escrow moves with it.",
          "narrow": "Narrow",
          "narrow_tooltip": "Split this committed production period into shorter periods (for example, a year into quarters) without changing its total volume.",
          "remove_backing": "Remove backing",
          "remove_backing_tooltip": "Remove this mandate's backing from the volume, leaving it open for another mandate.",
          "remove_backing_escrowed_tooltip": "{mwh} MWh is escrowed against this volume. Return it to its owner before removing the backing.",
          "pull_to_escrow": "Pull to escrow…",
          "pull_to_escrow_tooltip": "Select available certificates from this mandate and move them into escrow for this commitment.",
          "back": "Back…",
          "back_tooltip": "Back this open volume with a commitment from a qualifying mandate."
        },
        "window_on_or_before": "On or before {end}",
        "window_range": "{start} — {end}",
        "unit_price": "{price} €/MWh",
        "no_price": "No price set",
        "delivery_shortfall": "{mwh} MWh short",
        "deliver": "Deliver →",
        "deliver_anyway": "Deliver anyway",
        "transaction_link": "Transaction #{id}",
        "outside_window_title": "Outside the delivery window",
        "outside_window_body": "Today is outside this delivery's window ({window}). Deliver anyway?",
        "summary_open": "{mwh} MWh open",
        "summary_fully_committed": "Every planned MWh is committed",
        "summary_totals": "{planned} planned · {committed} committed · {escrowed} escrowed",
        "summary_deal_volume": "deal volume {mwh} MWh",
        "summary_no_deal_volume": "no deal volume stored",
        "confirm": "Confirm deal",
        "cancel_deal": "Cancel deal",
        "cancel_title": "Cancel this deal?",
        "cancel_body": "Cancelling releases every commitment and voids every undelivered draft. Escrow already in hand stays until it is returned to its owners.",
        "cancel_body_pap": "Cancelling voids every month not shipped yet. Certificates already escrowed for those months then await return: return them to their owners from the “Escrow awaiting return” card. Months already shipped stay as they are.",
        "unconfirm": "Back to draft",
        "unconfirm_title": "Return this deal to draft?",
        "unconfirm_body": "The deal leaves the allocation queue, so no more certificates are escrowed for it, and its criteria can be edited again. Its commitments stay, keeping the volume reserved. Without a signing date, its deliveries lose their price date. Confirming it again puts it at the back of the queue."
      },
      "editor": {
        "title": "Edit plan",
        "discard": "Discard",
        "save": "Save plan",
        "window_start": "Window start · optional",
        "window_end": "Window end",
        "unit_price": "Unit price",
        "remove_delivery": "Remove delivery",
        "add_period": "Add period",
        "add_delivery": "Add delivery",
        "period_placeholder": "2026-Q1, 2026-04 or 2026",
        "planned_for": "Planned volume for {period}",
        "backed_caption": "{mwh} MWh backed",
        "below_backed": "{mwh} MWh is backed here. Plan at least that much.",
        "remove_row_backed": "{mwh} MWh is backed. Remove the backing in the plan first.",
        "duplicate_period": "This production period is already in this delivery."
      },
      "correction": {
        "editor_hint": "Shipped and voided deliveries keep their periods. As a super admin you can still correct their window and price; invoices already created keep their figures.",
        "schedule_hint": "A shipped month's price can be corrected. Invoices already created keep the old price.",
        "voided_delivery": "This delivery was voided: the change shows on the deal page only, and no invoice or report reads it.",
        "buyer_invoice_replaceable": "Buyer invoice {number} keeps the old price. Recreate it if it hasn't been sent yet.",
        "buyer_invoice_sent": "Buyer invoice {number} has been sent and keeps the old price. It can no longer be recreated.",
        "completion_invoices_issued": "The producer payout and any commission invoiced at completion keep the old price.",
        "dashboard_period_moves": "No invoice reads the delivery window. Only the financial dashboard moves the sale to the period of the new window end."
      },
      "commitments": {
        "title": "Commitments",
        "empty": "Nothing backs this deal yet.",
        "description": "Each row is one pull of volume from a mandate. Its volume and price conditions were locked when it was pulled; the mandate's listing and prices may have changed since.",
        "granularity": "Granularity: {width}",
        "id_header": "ID",
        "mandate_header": "Mandate",
        "pulled_on": "Pulled on",
        "volume": "Escrowed / committed",
        "price_conditions": "Price conditions",
        "released": "Released on",
        "released_tooltip": "The day this backing was removed entirely: the volume returned to the mandate's availability and the commitment stopped claiming its inventory.",
        "floor": "floor {price} €/MWh",
        "no_floor": "no floor",
        "contango": {
          "any": "only in contango",
          "at_least_20_percent": "only ≥ 20% above spot"
        },
        "show_escrow": "Escrow…",
        "show_escrow_tooltip": "Show which companies' certificates back this commitment; a super admin can return them to their owners from here.",
        "contributions": "Contributions · escrow by company",
        "escrow_title": "{mandate} · pulled on {date}",
        "company": "Company",
        "no_escrow": "Nothing is escrowed against this commitment yet.",
        "entry_width": {
          "quarter": "quarterly",
          "month": "monthly",
          "half_year": "half-yearly",
          "year": "yearly"
        },
        "pay_as_produced": "pay-as-produced",
        "strategy_overridden": "Sold beyond the sales strategy",
        "sold_beyond_strategy": "{mandate} — {mwh} MWh sold beyond its sales strategy."
      },
      "free_escrow": {
        "title": "Escrow awaiting return",
        "subtitle": "{mwh} MWh with no live delivery behind it",
        "return": "Return to owner…",
        "company": "Company",
        "period": "Production period"
      },
      "add_commitment": {
        "title_back": "Back {period}",
        "submit": "Add commitment",
        "search": "Search mandates",
        "search_placeholder": "Type part of a mandate name",
        "searching": "Searching mandates…",
        "no_mandates": "No mandate you may draw on matches this search.",
        "listed": "{mwh} MWh listed",
        "no_availability": "nothing available in {period}",
        "takes_title": "How much to take from this period",
        "open": "Open",
        "take": "Take",
        "take_for": "Take for {period}",
        "max": "{mwh} max",
        "over_max": "at most {mwh} MWh can be taken here",
        "impact": "Under-commitment closes from {from} MWh to {to} MWh.",
        "submit_beyond_strategy": "Add commitment beyond sales strategy"
      },
      "resize": {
        "title": "Resize commitment",
        "submit": "Resize",
        "body": "{period} · {mandate} · {mwh} MWh committed today.",
        "new_volume": "New committed volume",
        "escrow_floor": "{mwh} MWh is already escrowed against this slice, so it cannot go below that.",
        "shrink_warning": "The {mwh} MWh you give up becomes open volume and returns to the mandate's availability. The commitment keeps its snapshotted price conditions for the rest; backing that volume again later is a new commitment on that day's conditions.",
        "submit_beyond_strategy": "Resize beyond sales strategy"
      },
      "move": {
        "title": "Move or split",
        "submit": "Move",
        "body": "{period} · {mwh} MWh. The escrow already in hand follows the volume.",
        "target": "Target delivery",
        "target_placeholder": "Pick a delivery",
        "volume": "Volume to move",
        "volume_placeholder": "Whole slice",
        "volume_hint": "Leave empty to move the whole slice.",
        "volume_out_of_range": "between 1 and {mwh} MWh, the slice's volume"
      },
      "narrow": {
        "title": "Narrow the period",
        "submit": "Narrow",
        "body": "{period} · {mwh} MWh. The volume is spread over the sub-periods in proportion to what the mandate lists in each of them.",
        "width": "Narrow into",
        "already_narrowest": "This period is already as narrow as it goes.",
        "hint": "Escrow already in hand is re-pinned onto the sub-period each certificate belongs to."
      },
      "remove_backing": {
        "title": "Remove this mandate's backing?",
        "pull": "Pulled on {date} · {conditions}",
        "released_whole": "The {mwh} MWh return to {mandate}'s availability, and this commitment is released in full because this is its last backed volume.",
        "released_part": "The {mwh} MWh return to {mandate}'s availability, and this commitment is released in part because its other backed volume keeps it.",
        "snapshot_lost": "The price conditions snapshotted at the pull are lost. Backing this volume again later is a new commitment on that day's mandate conditions, and only if the volume is still available.",
        "confirm": "Remove backing"
      },
      "return_escrow": {
        "section_title": "Return to owner",
        "title": "Return escrow to owner",
        "submit": "Return selected",
        "loading": "Loading escrowed certificates…",
        "body": "The selected certificates stay on Soldera's registry account and are assigned to a new virtual portfolio of each owner. Each row can go back in part.",
        "nothing": "Nothing is escrowed for this deal.",
        "company": "Company",
        "device": "Device",
        "month": "Production month",
        "escrowed": "Escrowed",
        "return_count": "Return",
        "select_all": "Select every row",
        "select_row": "Select {device}",
        "count_for": "Count to return for {device}",
        "over_count": "at most {mwh} MWh is escrowed on this row",
        "summary_title": "Returning",
        "results_title": "{moved} MWh returned, {failed} row(s) failed.",
        "result_line": "{count} MWh from item {item}"
      },
      "pull_escrow": {
        "title": "Pull to escrow",
        "submit": "Pull to escrow",
        "body": "Move certificates that flowed past the forwards step into this commitment's escrow. The producer keeps ownership.",
        "company": "Company",
        "company_placeholder": "Pick a mandate member",
        "source_portfolio": "Source portfolio",
        "portfolio_placeholder": "Pick a portfolio",
        "allowed_sources": "Only unallocated, hold, spot and virtual portfolios can be pulled from.",
        "loading_items": "Loading certificates…",
        "no_items": "This portfolio holds nothing that can be pulled.",
        "items_failed": "The certificates could not be loaded. Close this form and open it again to retry.",
        "after_move": "Escrow on this commitment goes from {from} MWh to {to} MWh of {total} MWh committed.",
        "results_title": "{moved} row(s) moved, {failed} row(s) failed.",
        "result_line": "{count} MWh from item {item}"
      },
      "producer_prices": {
        "button": "Producer prices…",
        "title": "Producer prices · {window}",
        "body": "What each mandate's producers invoice for this delivery. These are Soldera's buy prices and are never shown to the deal's owner.",
        "amount": "MWh",
        "price": "Unit price",
        "price_for": "Unit price for {mandate}",
        "delivery_price_note": "A mandate left blank pays the delivery's own price: {price}.",
        "trade_owner": "Trade owner",
        "trade_owner_help": "Paid commission on the swap margin.",
        "trade_owner_placeholder": "Select trade owner…",
        "trade_owner_none": "None",
        "submit": "Save",
        "shipped_meanwhile": "This delivery shipped while you were editing. Its prices are history now, so your changes were not saved.",
        "delivery_gone": "This delivery is no longer on the deal, so your changes were not saved.",
        "blank_price": "blank (the delivery's price)",
        "default_price": "Default producer price",
        "default_price_help": "Every mandate left blank pays it. Leave it blank to use the delivery's own price.",
        "default_price_note": "A mandate left blank pays the default producer price: {price}.",
        "default_price_none": "None (the delivery's own price)",
        "blank_follows_default": "blank (the default producer price)",
        "no_escrow_yet": "No escrow yet: its producers' lines appear here once certificates arrive.",
        "mandate_floor": "Minimum {price}",
        "no_mandates": "No mandate backs this delivery yet. Back its open volume to price its producers.",
        "mandate": "Mandate",
        "mandates_removed": "{count} mandates stopped backing the delivery meanwhile and were dropped | {count} mandate stopped backing the delivery meanwhile and was dropped | {count} mandates stopped backing the delivery meanwhile and were dropped",
        "kept_price": "No longer backing",
        "kept_price_help": "Kept from before this mandate stopped backing the delivery. It applies again if the mandate backs it again; remove it if it should not.",
        "remove_mandate_price": "Remove {mandate}'s price",
        "conflict": "{company} sells through {mandates}, but its single line can carry one price. Price those mandates alike, or move one mandate's slices into a delivery of their own: the delivery cannot ship until then.",
        "foreseen_conflict": "{company} may sell through {mandates}, but its single line can carry one price. Nothing is held back yet: once its escrow comes through two of them, the delivery cannot ship until those mandates are priced alike or one mandate's slices move into a delivery of their own.",
        "conflict_badge": "Price conflict"
      },
      "price_conflict": {
        "warning": "Producer prices conflict · {window}: {company} sells through {mandates}, but its single line can carry one price. The delivery cannot ship until those mandates are priced alike or one mandate's slices move into a delivery of their own.",
        "foreseen_warning": "Possible producer price conflict · {window}: {company} may sell through {mandates}, but its single line can carry one price. Once its escrow comes through two of them, the delivery cannot ship until those mandates are priced alike or one mandate's slices move into a delivery of their own.",
        "mandate_at": "{mandate} at {price}",
        "no_price": "the delivery's price (not set yet)",
        "and": " and "
      },
      "delivery_notes": {
        "button": "Notes…",
        "title": "Internal notes · {window}",
        "label": "Internal notes",
        "help": "Staff only: never copied onto the delivery's transaction, never shown to producers or buyers.",
        "submit": "Save",
        "heading": "Internal notes",
        "default_producer_price": "Producers' default price: {price}"
      },
      "pap": {
        "schedule_title": "Nominated schedule & tolerance",
        "edit_schedule": "Edit schedule",
        "save_schedule": "Save schedule",
        "window": "{start} — {end}",
        "no_window": "No contract window set",
        "no_schedule": "No months are nominated yet.",
        "tolerance": "Tolerance ± {percent} %",
        "mandates": "Mandates | Mandate | Mandates",
        "tolerance_label": "Tolerance ± %",
        "tolerance_hint": "How far a month may run over or under its nomination before it is flagged.",
        "month": "Month",
        "nominated": "Nominated",
        "target_for": "Nominated volume for {month}",
        "monitoring_title": "Monthly monitoring",
        "monitoring_loading": "Loading the monitoring…",
        "monitoring_empty": "There is nothing to monitor yet.",
        "nominated_vs_escrowed": "Nominated vs escrowed",
        "delta": "Delta vs nominated",
        "status": "Status",
        "status_pending": "Pending",
        "status_within": "Within band",
        "status_over": "Over band",
        "status_under": "Under band",
        "status_delivered": "Delivered",
        "ship_early_title": "Ship this month now?",
        "ship_early_body": "This month is not finished yet: it may still produce, and only what is in escrow right now ships. Shipping freezes the month, so certificates issued for it afterwards become free escrow that has to be returned by hand.",
        "ship_early_confirm": "Ship anyway",
        "sell_price": "Sell price",
        "sell_price_for": "Sell price for {month}",
        "sell_price_invalid": "Enter a price above 0 with at most 3 decimals.",
        "months_shipped": "{months} shipped meanwhile; your changes to those months were dropped | {months} shipped meanwhile; your changes to that month were dropped | {months} shipped meanwhile; your changes to those months were dropped"
      },
      "transaction_status": {
        "DRAFT": "Draft",
        "PENDING_BUYER_DETAILS": "Buyer details missing",
        "PENDING_CONTRACTS": "Contracts missing",
        "READY_TO_TRANSFER": "Ready to transfer",
        "DELIVERED": "Delivered",
        "COMPLETED": "Completed",
        "voided": "Voided"
      },
      "merge": {
        "changed_meanwhile": "Someone else saved changes to this while you were editing. Your changes are kept and merged with theirs. Check the result and save again.",
        "unaffected": "The deal was saved by someone else while you were editing, but nothing shown here changed. Save again to apply your changes.",
        "taken_over": "{count} saved changes were taken over | {count} saved change was taken over | {count} saved changes were taken over",
        "conflicts": "{count} fields were changed on both sides; pick a value for each below | {count} field was changed on both sides; pick a value for it below | {count} fields were changed on both sides; pick a value for each below",
        "yours": "Yours: {value}",
        "saved_now": "Saved now: {value}",
        "keep_yours": "Keep yours",
        "use_saved": "Use saved"
      },
      "sale_notices": {
        "title": "Unsent sale notices",
        "subtitle": "What each mandate's owners will be told once the deal has gone 5 days without a plan edit. Review them before they go out.",
        "mandate": "Mandate",
        "states": "Notice",
        "delivery": "Delivery",
        "sold": "Sold",
        "change": "Change",
        "goes_out": "Goes out",
        "daily_email": "Daily email",
        "monthly_email": "Monthly email",
        "select_all": "Select every notice",
        "select": "Select the notice for {mandate}",
        "skip_selected": "Skip selected",
        "skip_title": "Skip sale notices",
        "skip_body": "Skip the notices ({mandates})? A skipped notice is never sent, and its owners count as told: a later notice compares against it. A skip cannot be undone.",
        "skip_confirm": "Skip notices",
        "mandate_count": "no mandate | {n} mandate | {n} mandates",
        "not_skipped": "No mandate was left as it was. | {n} mandate had nothing left to tell and was left as it is. | {n} mandates had nothing left to tell and were left as they are."
      }
    }
  },
  "soldera_inventory": {
    "title": "Soldera Inventory",
    "description": "Guarantees of Origin that Soldera can deliver now or from future production. Select the volume and send Soldera your offer.",
    "not_enabled": "Soldera Inventory is not enabled for your account. Contact {email} to get access.",
    "purchase_details": "Purchase details",
    "counterparty_emails": "Invoice email addresses",
    "counterparty_emails_hint": "Separate several addresses with commas.",
    "price": "Price",
    "price_hint": "Your price per certificate (1 MWh). Certificates whose producers ask more are not listed.",
    "select_certificates": "Select certificates",
    "create_purchase": "Send firm offer",
    "regions": "Regions",
    "blocked": {
      "no_selection": "Select the certificates you want to buy.",
      "no_price": "Enter a price above zero.",
      "mixed_authorities": "Select certificates from a single certificate scheme.",
      "no_company": "Choose the company you are buying for."
    },
    "created_title": "Firm offer sent",
    "created_description": "Your firm offer for {mwh} MWh was sent to Soldera. We will contact you for confirmation on our side.",
    "billing_country": "Billing country",
    "generate_breakdown": "Generate Excel breakdown",
    "open_breakdown": "Open breakdown",
    "breakdown_ready_title": "Breakdown ready",
    "breakdown_ready_description": "The breakdown opened in a new tab and was shared with {email}.",
    "tabs": {
      "spot": "Available now",
      "forward": "Future production"
    },
    "forward": {
      "select_mandates": "Select future production",
      "price_hint": "Your price per MWh, for every delivery. Production whose producers ask more is not listed.",
      "no_mandates": "No future production is on offer for these periods at this price.",
      "spread_over_mandates": "@:forwards.picker.take.spread",
      "by_period": "@:forwards.picker.summary.by_period",
      "all_technologies": "All technologies",
      "all_countries": "All countries",
      "columns": {
        "technology": "@:forwards.picker.take.technology",
        "country": "@:forwards.picker.take.country",
        "scheme": "Scheme",
        "cod_age": "Oldest COD (years)",
        "support": "@:forwards.picker.take.support",
        "ecolabels": "@:forwards.picker.take.ecolabels",
        "capacity": "Available MWh",
        "take": "Your MWh"
      },
      "blocked": {
        "no_takes": "Enter the MWh you want from at least one mandate."
      },
      "warnings": {
        "pl_be_mixed": "Your selection mixes {flagged} with {others}, which are usually bought as separate products.",
        "standard_aib_gc_mixed": "Your selection mixes Standard AIB GC countries ({standard}) with {outside}, outside the standard list.",
        "technology_mixed": "Your selection mixes {advanced} with {hsw}; HSW (hydro, solar, wind) products usually exclude it."
      }
    }
  },
  "inventory_selection": {
    "quick_filters": "@:forwards.picker.criteria.quick_filters",
    "standard_aib_gc": "@:forwards.mandates.eligibility.tier.standard_aib_gc",
    "vintage": "Vintage",
    "tech_filters": {
      "hsw": "Hydro, solar, wind",
      "biomass": "@:common.technology.biomass",
      "nuclear": "Nuclear"
    },
    "auto_select": "Auto-select",
    "target": "@:forwards.picker.take.target",
    "target_label": "@:forwards.picker.take.target_label",
    "spread_over_companies": "Spread over companies",
    "clear": "@:forwards.picker.take.clear",
    "available": "Available",
    "selected": "Selected",
    "row_count": "{count} row | {count} rows",
    "breakdowns": {
      "production_months": "Production months",
      "support_status": "@:forwards.picker.summary.by_support",
      "technology": "@:forwards.picker.take.technology",
      "commercial_operations_date": "@:forwards.picker.summary.by_cod",
      "re100_applicable": "@:forwards.picker.summary.re100",
      "ecolabel_status": "@:forwards.picker.summary.by_ecolabel",
      "supported": "Supported",
      "unsupported": "Unsupported",
      "unknown": "@:common.unknown",
      "cod_le_5": "@:forwards.picker.summary.cod_young",
      "cod_6_15": "@:forwards.picker.summary.cod_middle",
      "cod_gt_15": "@:forwards.picker.summary.cod_old",
      "ekoenergy_pre_approved": "@:forwards.picker.ecolabel.ekoenergy",
      "okpower_new_compatible": "@:forwards.picker.ecolabel.okpower_new"
    }
  },
  "device_groups": {
    "group_devices": "Group devices",
    "new_group": "New group",
    "edit_group": "Edit group",
    "groups_title": "Device groups",
    "all_devices": "All devices",
    "ungrouped": "Ungrouped",
    "suggested_from_address": "Suggested from address",
    "create_group": "Create group",
    "save_group": "Save group",
    "delete_group": "Delete group",
    "delete_confirm": "Delete the group \"{name}\"? Its devices become ungrouped.",
    "dismiss": "Dismiss",
    "dismiss_suggestion": "Dismiss {name}",
    "devices_count": "No devices | {count} device | {count} devices",
    "devices_and_power": "No devices | {count} device · {power} kW | {count} devices · {power} kW",
    "name_label": "Name",
    "name_placeholder": "Group name",
    "pick_devices": "Pick devices",
    "paste_device_ids": "Paste device IDs",
    "start_from_address": "Start from address",
    "search_placeholder": "Search device ID, name or address",
    "all_technologies": "All technologies",
    "select_matching": "Select {count}",
    "deselect": "Deselect",
    "paste_placeholder": "One device ID per line",
    "paste_found": "{found} of {total} found",
    "paste_not_found": "{id} not found",
    "paste_in_group": "{id} in {group}",
    "add_devices": "Add devices | Add {count} device | Add {count} devices",
    "modal_hint": "The group appears in device pickers in Trading strategy and in inventory device filters.",
    "device_column": "Device",
    "group_column": "Group",
    "in_group": "In {group}",
    "selected_summary": "{count} selected · {power} kW",
    "add_to_group": "Add to group",
    "new_group_from_selection": "New group from selection",
    "remove_from_group": "Remove from group",
    "clear_selection": "Clear selection",
    "hint_select_ungrouped": "Select ungrouped devices to add them to a group",
    "hint_select_to_remove": "Select devices to remove them from this group",
    "select_all_shown": "Select all shown devices",
    "select_device": "Select {device}",
    "group_created": "Group \"{name}\" created",
    "group_saved": "Group \"{name}\" saved",
    "group_deleted": "Group \"{name}\" deleted",
    "picker": {
      "select_by_group": "Select by group",
      "hint": "Selecting a group adds the devices in it now. Devices added to the group later are not added here.",
      "group_partial_count": "{selected} of {count} devices",
      "other_devices": "Other devices",
      "more": "+{count} more",
      "show_less": "Show less"
    },
    "filter": {
      "groups": "Groups",
      "devices": "Devices",
      "n_groups": "No groups | {count} group | {count} groups"
    },
    "errors": {
      "name_taken": "A group with this name already exists.",
      "limit_reached": "This company already has the maximum number of device groups.",
      "unknown_devices": "Some devices are no longer available. Reload the page and try again.",
      "devices_in_other_group": "Some devices already belong to another group: {devices}"
    }
  },
  "billing": {
    "onboarding_label": "Set up your Soldera account",
    "steps": {
      "company": "Company",
      "needs": "Your needs",
      "agreement": "Agreement",
      "plan": "Plan"
    },
    "agreement": {
      "eyebrow": "One more step",
      "title": "Accept the Platform Agreement"
    },
    "qualification": {
      "eyebrow": "Almost there",
      "title": "Tell us about your electricity use",
      "subtitle": "Four quick questions so we can match you with the right plan and the right evidence.",
      "consumption_label": "How much electricity do you consume in a year?",
      "consumption_bands": {
        "under_10_gwh": {
          "name": "Less than 10 GWh",
          "description": "Under 10,000 MWh across all sites"
        },
        "over_10_gwh": {
          "name": "10 GWh or more",
          "description": "10,000 MWh or more across all sites"
        }
      },
      "countries_label": "In how many countries do you consume electricity?",
      "country_scopes": {
        "one": "1 country",
        "multiple": "More than 1 country"
      },
      "required": "Please pick one",
      "incomplete": "Answer the first two questions to see your plan.",
      "standards_label": "Which standards do you report under?",
      "standards_optional": "Optional · pick all that apply",
      "standard_other_placeholder": "Which standard or target?",
      "regions_label": "Where do you consume electricity?",
      "regions_optional": "Pick all that apply",
      "regions": {
        "europe": "Europe",
        "usa": "USA",
        "china": "China",
        "japan": "Japan",
        "rest_of_world": "Rest of the world"
      },
      "continue": "See my plan",
      "standards": {
        "ghg_protocol": {
          "name": "GHG Protocol",
          "description": "Scope 2 market-based reporting"
        },
        "sbti": {
          "name": "SBTi",
          "description": "Science Based Targets initiative"
        },
        "re100": {
          "name": "RE100",
          "description": "100% renewable electricity commitment"
        },
        "cdp": {
          "name": "CDP",
          "description": "Climate change disclosure"
        },
        "csrd": {
          "name": "CSRD",
          "description": "EU sustainability reporting (ESRS E1)"
        },
        "iso_14064": {
          "name": "ISO 14064",
          "description": "GHG inventory verification"
        },
        "ecovadis": {
          "name": "EcoVadis",
          "description": "Supplier sustainability rating"
        },
        "cbam": {
          "name": "CBAM",
          "description": "EU Carbon Border Adjustment"
        },
        "other": {
          "name": "Other",
          "description": "Another framework or internal target"
        }
      }
    },
    "plan": {
      "eyebrow": "Your plan",
      "title": "Clean energy compliance on autopilot",
      "tailored_for": "Tailored for",
      "based_on": "{consumption} · {countries}",
      "names": {
        "annual": "Fully Managed Service",
        "enterprise": "Enterprise"
      },
      "per_year": "/ year",
      "billed_annually": "Billed once a year, upfront",
      "vat_note": "Plus VAT where applicable",
      "guarantee_title": "3-month money-back guarantee",
      "guarantee_body": "Not convinced within the first 3 months? Tell your Account Executive and we refund your payment in full.",
      "cta": "Continue to secure checkout",
      "redirecting": "Opening checkout…",
      "secure_note": "Payments are processed by Creem, our merchant of record. Card and invoice details never touch our servers.",
      "change_answers": "Change my answers",
      "talk_to_us": "Prefer to talk first? Book a demo",
      "included_title": "What's included",
      "included": {
        "account_executive": "Personal Account Executive",
        "call_plan": "Dedicated call and execution plan",
        "matched": "Matched, cancelled and verified, market by market",
        "buy_missing": "Buy only what is missing, from 6 000+ power plants",
        "evidence": "Audit-ready evidence for {standards}",
        "suppliers": "We deal with your suppliers and registries"
      },
      "default_standards": "RE100, GHG Protocol, CDP and CSRD"
    },
    "demo": {
      "eyebrow": "Enterprise",
      "title": "At your scale, let's design your programme together",
      "subtitle": "Companies consuming 10 GWh or more a year, or in several countries, get a tailored procurement strategy, volume pricing and a dedicated team. Book a 30-minute call and we'll walk you through it.",
      "points": {
        "account_executive": "A Personal Account Executive from day one",
        "strategy": "A multi-year GO procurement strategy across markets and technologies",
        "pricing": "Volume pricing directly from producers, no broker margins",
        "reporting": "Consolidated, audit-ready reporting across all your entities and jurisdictions"
      },
      "cta": "Book a demo",
      "booked_note": "We'll open our booking page in a new tab.",
      "requested_title": "Thanks, we'll be in touch",
      "requested_body": "Pick a time on the booking page if you haven't yet. Your Account Executive will confirm the call, and your dashboard opens once we have agreed your programme together.",
      "book_again": "Open booking page again"
    },
    "proof": {
      "account_executive_label": "Your Account Executive",
      "account_executive_role": "Guides you from requirements to evidence",
      "title": "Automated by software. Directed by experts.",
      "body": "Our specialists configure Soldera to your requirements, monitor that it runs as planned and keep it current as rules change.",
      "used_by": "Used by",
      "recognised_backed_by": "Recognised and backed by",
      "team_label": "Our team previously at",
      "team": "Including a former board member of the AIB.",
      "stats": {
        "clients": "clients",
        "plants": "power plants served",
        "registries": "registries"
      }
    },
    "success": {
      "confirming_title": "Confirming your payment…",
      "confirming_body": "This usually takes a few seconds.",
      "done_title": "Welcome to Soldera",
      "done_body": "Your subscription is active. Next, book your onboarding call with your Account Executive.",
      "pending_title": "Payment received, we are finishing up",
      "pending_body": "Your payment is still being confirmed. You can keep using the dashboard, and your plan switches on automatically once it is.",
      "continue": "Go to dashboard"
    },
    "onboarding_call": {
      "title": "Book your onboarding call",
      "body": "Your Account Executive walks you through setup in 30 minutes: your requirements, your data and your first cancellations.",
      "book": "Book onboarding call",
      "requested_title": "Did you book a time?",
      "requested_body": "Confirm once you have picked a time, or open the booking page again.",
      "book_again": "Open booking page",
      "booked": "Yes, it is booked"
    },
    "preview": {
      "title": "Your certificate overview",
      "sample": "Sample data",
      "kpi": {
        "held": "Certificates held",
        "cancelled": "Cancelled this year",
        "coverage": "Consumption covered",
        "countries": "Countries"
      },
      "coverage_title": "Consumption covered by certificates",
      "technology_title": "Certificates by technology",
      "certificates_title": "Recent certificates",
      "price_title": "Guarantee of Origin price",
      "price_label": "EUR/MWh",
      "certificates": "Certificates",
      "consumption": "Consumption",
      "columns": {
        "country": "Country",
        "technology": "Technology",
        "vintage": "Vintage",
        "volume": "Volume",
        "status": "Status"
      },
      "technology": {
        "wind": "Wind",
        "solar": "Solar",
        "hydro": "Hydro",
        "biomass": "Biomass"
      },
      "status": {
        "cancelled": "Cancelled",
        "held": "In portfolio"
      },
      "load_failed": "We couldn't load your plan.",
      "retry": "Try again",
      "left_title": "{company} stays locked",
      "left_body": "Choose a plan to use it. Meanwhile, here are your other companies."
    }
  }
}
